function load_data() {
  return {
    title: "Indonesia",
    version: "1.1.3",
    type: "FeatureCollection",
    copyright:
      "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
    copyrightShort: "Natural Earth",
    copyrightUrl: "http://www.naturalearthdata.com",
    crs: { type: "name", properties: { name: "urn:ogc:def:crs:EPSG:23836" } },
    "hc-transform": {
      default: {
        rotation: -0.0523598775598,
        crs: "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
        scale: 0.000132056229838,
        jsonres: 15.5,
        jsonmarginX: -999,
        jsonmarginY: 9851.0,
        xoffset: -1856151.37844,
        yoffset: 2110546.03205,
      },
    },
    features: [
      {
        type: "Feature",
        id: "ID.3700",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-3700",
          "hc-a2": "NU",
          labelrank: "20",
          hasc: "-99",
          "alt-name": null,
          "woe-id": "-99",
          subregion: null,
          fips: null,
          "postal-code": null,
          name: "Indonesia",
          country: "Indonesia",
          "type-en": null,
          region: null,
          longitude: "104.223",
          "woe-name": null,
          latitude: "-1.04563",
          "woe-label": null,
          type: null,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [8129, 7927],
              [8149, 7905],
              [8121, 7915],
              [8113, 7930],
              [8129, 7927],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.AC",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ac",
          "hc-a2": "AC",
          labelrank: "6",
          hasc: "ID.AC",
          "alt-name": "Achin|Atjeh|Nanggroe Aceh Darussalam",
          "woe-id": "2345710",
          subregion: null,
          fips: "ID01",
          "postal-code": "AC",
          name: "Aceh",
          country: "Indonesia",
          "type-en": "Autonomous Province",
          region: null,
          longitude: "96.9956",
          "woe-name": "Aceh",
          latitude: "4.41533",
          "woe-label": "Aceh, ID, Indonesia",
          type: "Propinsi",
        },  
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-501, 8952],
                [-489, 8957],
                [-471, 8946],
                [-469, 8911],
                [-501, 8952],
              ],
            ],
            [
              [
                [-983, 9800],
                [-966, 9807],
                [-956, 9794],
                [-967, 9779],
                [-983, 9800],
              ],
            ],
            [
              [
                [-793, 9077],
                [-767, 9070],
                [-729, 9034],
                [-711, 9027],
                [-697, 9006],
                [-681, 9010],
                [-671, 8981],
                [-705, 8978],
                [-707, 8987],
                [-771, 9028],
                [-803, 9030],
                [-860, 9072],
                [-844, 9087],
                [-840, 9111],
                [-811, 9104],
                [-793, 9077],
              ],
            ],
            [
              [
                [-287, 8956],
                [-322, 8974],
                [-339, 8968],
                [-372, 8974],
                [-393, 9004],
                [-399, 9064],
                [-411, 9109],
                [-454, 9122],
                [-476, 9146],
                [-492, 9188],
                [-513, 9195],
                [-554, 9258],
                [-587, 9295],
                [-617, 9309],
                [-664, 9307],
                [-696, 9325],
                [-754, 9394],
                [-770, 9396],
                [-798, 9416],
                [-894, 9508],
                [-906, 9510],
                [-940, 9554],
                [-975, 9639],
                [-997, 9663],
                [-985, 9688],
                [-999, 9723],
                [-948, 9749],
                [-925, 9738],
                [-901, 9744],
                [-835, 9719],
                [-825, 9696],
                [-777, 9666],
                [-721, 9654],
                [-653, 9653],
                [-612, 9670],
                [-578, 9669],
                [-507, 9643],
                [-454, 9667],
                [-414, 9627],
                [-355, 9585],
                [-330, 9526],
                [-332, 9506],
                [-317, 9508],
                [-283, 9496],
                [-266, 9480],
                [-267, 9447],
                [-285, 9448],
                [-314, 9435],
                [-327, 9373],
                [-376, 9317],
                [-344, 9245],
                [-324, 9221],
                [-353, 9203],
                [-335, 9177],
                [-344, 9163],
                [-336, 9122],
                [-304, 9101],
                [-299, 9070],
                [-309, 9046],
                [-282, 8988],
                [-287, 8956],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jt",
          "hc-a2": "JT",
          labelrank: "2",
          hasc: "ID.JT",
          "alt-name": "Jateng",
          "woe-id": "2345716",
          subregion: null,
          fips: "ID07",
          "postal-code": "JT",
          name: "Jawa Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "109.896",
          "woe-name": "Jawa Tengah",
          latitude: "-7.2901",
          "woe-label": "Central Java, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [2341, 6828],
                [2351, 6817],
                [2304, 6826],
                [2310, 6836],
                [2341, 6828],
              ],
            ],
            [
              [
                [2796, 6740],
                [2792, 6741],
                [2773, 6745],
                [2761, 6762],
                [2755, 6818],
                [2733, 6829],
                [2691, 6835],
                [2673, 6884],
                [2634, 6847],
                [2606, 6854],
                [2588, 6805],
                [2499, 6824],
                [2447, 6823],
                [2434, 6836],
                [2372, 6838],
                [2354, 6826],
                [2325, 6837],
                [2320, 6852],
                [2304, 6839],
                [2289, 6852],
                [2290, 6867],
                [2270, 6910],
                [2244, 6916],
                [2247, 6949],
                [2274, 6956],
                [2294, 6975],
                [2295, 7004],
                [2314, 7033],
                [2335, 7028],
                [2338, 7040],
                [2371, 7027],
                [2418, 7025],
                [2459, 7036],
                [2503, 7033],
                [2542, 7022],
                [2610, 7033],
                [2647, 7016],
                [2673, 7024],
                [2694, 7050],
                [2708, 7084],
                [2712, 7127],
                [2725, 7138],
                [2768, 7152],
                [2797, 7142],
                [2815, 7099],
                [2824, 7090],
                [2886, 7091],
                [2899, 7109],
                [2926, 7101],
                [2941, 7087],
                [2932, 7071],
                [2927, 7034],
                [2932, 6991],
                [2897, 6953],
                [2845, 6964],
                [2841, 6951],
                [2841, 6901],
                [2849, 6882],
                [2844, 6861],
                [2872, 6845],
                [2868, 6809],
                [2828, 6791],
                [2799, 6765],
                [2796, 6740],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BE",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-be",
          "hc-a2": "BE",
          labelrank: "7",
          hasc: "ID.BE",
          "alt-name": "Bencoolen|Benkoelen|Benkulen",
          "woe-id": "2345712",
          subregion: null,
          fips: "ID03",
          "postal-code": "BE",
          name: "Bengkulu",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "102.368",
          "woe-name": "Bengkulu",
          latitude: "-3.48606",
          "woe-label": "Bengkulu, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [811, 7243],
                [791, 7240],
                [743, 7268],
                [759, 7282],
                [812, 7264],
                [811, 7243],
              ],
            ],
            [
              [
                [453, 7909],
                [485, 7937],
                [522, 7955],
                [544, 7971],
                [564, 7956],
                [577, 7923],
                [619, 7883],
                [659, 7861],
                [698, 7854],
                [736, 7817],
                [742, 7793],
                [786, 7789],
                [800, 7775],
                [795, 7752],
                [836, 7727],
                [866, 7750],
                [891, 7729],
                [916, 7726],
                [927, 7706],
                [923, 7684],
                [897, 7684],
                [901, 7671],
                [859, 7632],
                [842, 7626],
                [876, 7594],
                [926, 7580],
                [964, 7580],
                [977, 7536],
                [1078, 7502],
                [1081, 7482],
                [1118, 7416],
                [1111, 7407],
                [1084, 7388],
                [1060, 7397],
                [1038, 7396],
                [1033, 7408],
                [979, 7449],
                [919, 7474],
                [908, 7490],
                [866, 7522],
                [772, 7580],
                [768, 7614],
                [746, 7659],
                [708, 7678],
                [605, 7740],
                [550, 7812],
                [526, 7853],
                [472, 7885],
                [453, 7909],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-bt",
          "hc-a2": "BT",
          labelrank: "2",
          hasc: "ID.BT",
          "alt-name": null,
          "woe-id": "28350158",
          subregion: null,
          fips: "ID33",
          "postal-code": "BT",
          name: "Banten",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "106.167",
          "woe-name": "Banten",
          latitude: "-6.25794",
          "woe-label": "Banten, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1486, 7045],
                [1486, 7022],
                [1470, 7011],
                [1469, 7040],
                [1486, 7045],
              ],
            ],
            [
              [
                [1824, 7119],
                [1826, 7103],
                [1795, 7098],
                [1756, 7106],
                [1747, 7098],
                [1746, 7063],
                [1753, 7024],
                [1773, 7006],
                [1761, 6993],
                [1753, 6957],
                [1725, 6957],
                [1670, 6987],
                [1649, 6990],
                [1607, 6980],
                [1591, 6982],
                [1542, 6971],
                [1501, 6982],
                [1489, 6991],
                [1511, 7016],
                [1534, 6984],
                [1570, 7031],
                [1567, 7050],
                [1580, 7064],
                [1588, 7051],
                [1604, 7057],
                [1612, 7075],
                [1611, 7122],
                [1622, 7159],
                [1656, 7204],
                [1673, 7181],
                [1686, 7176],
                [1704, 7193],
                [1759, 7176],
                [1797, 7184],
                [1813, 7174],
                [1803, 7163],
                [1809, 7139],
                [1824, 7119],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kb",
          "hc-a2": "KB",
          labelrank: "2",
          hasc: "ID.KB",
          "alt-name": "Kalbar",
          "woe-id": "2345720",
          subregion: null,
          fips: "ID11",
          "postal-code": "KB",
          name: "Kalimantan Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "111.304",
          "woe-name": "Kalimantan Barat",
          latitude: "-0.063647",
          "woe-label": "West Kalimantan, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [2262, 8220],
                [2256, 8204],
                [2233, 8198],
                [2227, 8220],
                [2247, 8228],
                [2262, 8220],
              ],
            ],
            [
              [
                [2401, 8363],
                [2437, 8352],
                [2443, 8330],
                [2376, 8289],
                [2362, 8298],
                [2367, 8355],
                [2401, 8363],
              ],
            ],
            [
              [
                [2732, 7948],
                [2696, 7933],
                [2667, 7900],
                [2655, 7938],
                [2630, 7945],
                [2576, 7913],
                [2561, 7936],
                [2569, 7961],
                [2560, 7991],
                [2547, 7998],
                [2560, 8018],
                [2545, 8040],
                [2539, 8072],
                [2528, 8093],
                [2534, 8122],
                [2520, 8155],
                [2479, 8174],
                [2507, 8217],
                [2512, 8265],
                [2502, 8298],
                [2478, 8311],
                [2475, 8338],
                [2455, 8341],
                [2430, 8370],
                [2418, 8362],
                [2373, 8390],
                [2355, 8375],
                [2324, 8387],
                [2319, 8429],
                [2367, 8416],
                [2337, 8449],
                [2318, 8446],
                [2286, 8465],
                [2279, 8496],
                [2265, 8522],
                [2281, 8532],
                [2306, 8526],
                [2297, 8539],
                [2288, 8586],
                [2320, 8583],
                [2288, 8604],
                [2272, 8633],
                [2230, 8653],
                [2234, 8677],
                [2225, 8696],
                [2227, 8721],
                [2209, 8763],
                [2228, 8776],
                [2235, 8802],
                [2222, 8843],
                [2234, 8852],
                [2249, 8891],
                [2255, 8931],
                [2290, 8957],
                [2310, 8991],
                [2307, 9019],
                [2356, 9034],
                [2371, 9044],
                [2350, 9011],
                [2355, 8994],
                [2377, 8987],
                [2379, 8955],
                [2388, 8941],
                [2427, 8904],
                [2448, 8900],
                [2459, 8880],
                [2487, 8859],
                [2504, 8856],
                [2528, 8817],
                [2548, 8816],
                [2565, 8799],
                [2596, 8788],
                [2647, 8803],
                [2662, 8824],
                [2739, 8846],
                [2775, 8834],
                [2818, 8833],
                [2844, 8841],
                [2882, 8838],
                [2901, 8863],
                [2944, 8875],
                [2960, 8924],
                [2958, 8942],
                [3023, 8972],
                [3091, 8973],
                [3110, 8980],
                [3149, 8972],
                [3136, 8944],
                [3165, 8949],
                [3220, 8934],
                [3237, 8922],
                [3261, 8928],
                [3295, 8911],
                [3330, 8937],
                [3352, 8961],
                [3385, 8968],
                [3420, 8964],
                [3419, 8913],
                [3347, 8856],
                [3348, 8839],
                [3368, 8831],
                [3362, 8802],
                [3332, 8760],
                [3304, 8725],
                [3300, 8702],
                [3280, 8690],
                [3254, 8692],
                [3233, 8684],
                [3265, 8645],
                [3272, 8619],
                [3262, 8587],
                [3239, 8571],
                [3223, 8546],
                [3236, 8533],
                [3227, 8503],
                [3204, 8520],
                [3169, 8507],
                [3075, 8460],
                [3030, 8447],
                [2970, 8448],
                [2867, 8379],
                [2853, 8339],
                [2817, 8319],
                [2798, 8294],
                [2756, 8256],
                [2728, 8256],
                [2708, 8235],
                [2731, 8225],
                [2736, 8207],
                [2730, 8152],
                [2735, 8120],
                [2767, 8059],
                [2771, 7984],
                [2756, 7976],
                [2732, 7948],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-bb",
          "hc-a2": "BB",
          labelrank: "2",
          hasc: "ID.BB",
          "alt-name": "Babel|Kepulauan Bangka Belitung",
          "woe-id": "28350154",
          subregion: null,
          fips: "ID35",
          "postal-code": "BB",
          name: "Bangka-Belitung",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "106.819",
          "woe-name": "Bangka-Belitung",
          latitude: "-2.95817",
          "woe-label": "Bangka-Belitung, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1802, 7864],
                [1769, 7876],
                [1788, 7894],
                [1811, 7887],
                [1802, 7864],
              ],
            ],
            [
              [
                [1944, 7906],
                [1925, 7889],
                [1909, 7902],
                [1935, 7918],
                [1944, 7906],
              ],
            ],
            [
              [
                [1980, 7980],
                [2020, 7985],
                [2053, 7981],
                [2063, 7966],
                [2071, 7978],
                [2102, 7960],
                [2118, 7943],
                [2125, 7919],
                [2107, 7886],
                [2110, 7857],
                [2083, 7849],
                [2080, 7834],
                [2062, 7830],
                [2055, 7850],
                [2032, 7871],
                [2026, 7850],
                [1980, 7825],
                [1971, 7833],
                [1980, 7853],
                [1965, 7877],
                [1971, 7898],
                [1965, 7928],
                [1976, 7937],
                [1980, 7980],
              ],
            ],
            [
              [
                [1767, 7847],
                [1724, 7844],
                [1706, 7869],
                [1624, 7896],
                [1599, 7899],
                [1577, 7942],
                [1585, 7972],
                [1557, 7994],
                [1547, 8044],
                [1503, 8055],
                [1493, 8065],
                [1467, 8051],
                [1434, 8046],
                [1416, 8060],
                [1397, 8057],
                [1397, 8090],
                [1446, 8118],
                [1449, 8138],
                [1438, 8158],
                [1462, 8178],
                [1492, 8189],
                [1501, 8169],
                [1519, 8161],
                [1508, 8148],
                [1523, 8134],
                [1546, 8131],
                [1530, 8150],
                [1521, 8191],
                [1547, 8193],
                [1565, 8200],
                [1596, 8179],
                [1595, 8160],
                [1629, 8116],
                [1628, 8086],
                [1656, 8009],
                [1678, 7985],
                [1789, 7968],
                [1768, 7956],
                [1754, 7936],
                [1742, 7896],
                [1743, 7880],
                [1773, 7867],
                [1767, 7847],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ba",
          "hc-a2": "BA",
          labelrank: "2",
          hasc: "ID.BA",
          "alt-name": "Penida|Lembongan|Ceningan|Menjangan",
          "woe-id": "2345711",
          subregion: null,
          fips: "ID02",
          "postal-code": "BA",
          name: "Bali",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "115.179",
          "woe-name": "Bali",
          latitude: "-8.341200000000001",
          "woe-label": "Bali, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3843, 6692],
                [3855, 6671],
                [3848, 6661],
                [3820, 6677],
                [3843, 6692],
              ],
            ],
            [
              [
                [3639, 6804],
                [3677, 6793],
                [3714, 6799],
                [3738, 6823],
                [3756, 6827],
                [3822, 6804],
                [3872, 6761],
                [3848, 6731],
                [3786, 6700],
                [3762, 6676],
                [3768, 6655],
                [3746, 6647],
                [3736, 6654],
                [3756, 6677],
                [3749, 6690],
                [3695, 6732],
                [3665, 6744],
                [3630, 6744],
                [3609, 6758],
                [3589, 6783],
                [3584, 6811],
                [3604, 6804],
                [3639, 6804],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ji",
          "hc-a2": "JI",
          labelrank: "2",
          hasc: "ID.JI",
          "alt-name": "Jatim",
          "woe-id": "2345717",
          subregion: null,
          fips: "ID08",
          "postal-code": "JI",
          name: "Jawa Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "112.616",
          "woe-name": "Jawa Timur",
          latitude: "-7.88129",
          "woe-label": "East Java, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3561, 7028],
                [3561, 7018],
                [3538, 7025],
                [3544, 7046],
                [3561, 7028],
              ],
            ],
            [
              [
                [3780, 7106],
                [3824, 7092],
                [3822, 7084],
                [3782, 7089],
                [3763, 7066],
                [3745, 7088],
                [3757, 7105],
                [3780, 7106],
              ],
            ],
            [
              [
                [3165, 7325],
                [3170, 7304],
                [3141, 7298],
                [3136, 7310],
                [3149, 7325],
                [3165, 7325],
              ],
            ],
            [
              [
                [3344, 7074],
                [3362, 7072],
                [3467, 7081],
                [3498, 7059],
                [3450, 7042],
                [3434, 7022],
                [3396, 7025],
                [3378, 7014],
                [3371, 6996],
                [3284, 6994],
                [3276, 6992],
                [3205, 7004],
                [3184, 7003],
                [3177, 7031],
                [3197, 7043],
                [3208, 7061],
                [3258, 7070],
                [3276, 7068],
                [3344, 7074],
              ],
            ],
            [
              [
                [2941, 7087],
                [2952, 7079],
                [2990, 7072],
                [3010, 7079],
                [3032, 7055],
                [3061, 7054],
                [3099, 7064],
                [3130, 7057],
                [3154, 7059],
                [3150, 7040],
                [3169, 7026],
                [3157, 7020],
                [3175, 6999],
                [3157, 6994],
                [3180, 6981],
                [3198, 6993],
                [3207, 6981],
                [3206, 6948],
                [3197, 6919],
                [3216, 6906],
                [3260, 6895],
                [3283, 6879],
                [3307, 6878],
                [3321, 6867],
                [3372, 6890],
                [3434, 6888],
                [3465, 6900],
                [3481, 6914],
                [3510, 6897],
                [3536, 6898],
                [3565, 6887],
                [3585, 6871],
                [3582, 6829],
                [3567, 6739],
                [3572, 6714],
                [3582, 6727],
                [3592, 6693],
                [3621, 6684],
                [3624, 6658],
                [3572, 6664],
                [3575, 6681],
                [3556, 6692],
                [3533, 6684],
                [3495, 6691],
                [3484, 6687],
                [3445, 6711],
                [3424, 6706],
                [3405, 6720],
                [3353, 6733],
                [3338, 6747],
                [3304, 6756],
                [3257, 6743],
                [3239, 6724],
                [3223, 6729],
                [3187, 6711],
                [3135, 6721],
                [3111, 6733],
                [3018, 6735],
                [2987, 6744],
                [2961, 6717],
                [2951, 6727],
                [2910, 6727],
                [2908, 6735],
                [2868, 6739],
                [2847, 6730],
                [2829, 6746],
                [2822, 6735],
                [2796, 6740],
                [2799, 6765],
                [2828, 6791],
                [2868, 6809],
                [2872, 6845],
                [2844, 6861],
                [2849, 6882],
                [2841, 6901],
                [2841, 6951],
                [2845, 6964],
                [2897, 6953],
                [2932, 6991],
                [2927, 7034],
                [2932, 7071],
                [2941, 7087],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KS",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ks",
          "hc-a2": "KS",
          labelrank: "2",
          hasc: "ID.KS",
          "alt-name": "Kalsel",
          "woe-id": "2345721",
          subregion: null,
          fips: "ID12",
          "postal-code": "KS",
          name: "Kalimantan Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "115.451",
          "woe-name": "Kalimantan Selatan",
          latitude: "-3.00713",
          "woe-label": "South Kalimantan, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3976, 7842],
                [3960, 7864],
                [3976, 7901],
                [3983, 7893],
                [3976, 7842],
              ],
            ],
            [
              [
                [3897, 7873],
                [3912, 7910],
                [3943, 7934],
                [3944, 7892],
                [3958, 7872],
                [3948, 7868],
                [3957, 7822],
                [3959, 7779],
                [3919, 7749],
                [3902, 7750],
                [3910, 7772],
                [3906, 7800],
                [3890, 7834],
                [3897, 7873],
              ],
            ],
            [
              [
                [4003, 8132],
                [3997, 8097],
                [3945, 8094],
                [3965, 8082],
                [3959, 8064],
                [3962, 8025],
                [3955, 8002],
                [3935, 7982],
                [3912, 8024],
                [3905, 7981],
                [3917, 7982],
                [3942, 7953],
                [3919, 7944],
                [3887, 7879],
                [3879, 7843],
                [3850, 7836],
                [3833, 7820],
                [3794, 7800],
                [3677, 7747],
                [3636, 7726],
                [3600, 7702],
                [3580, 7701],
                [3580, 7736],
                [3572, 7772],
                [3572, 7811],
                [3553, 7837],
                [3554, 7886],
                [3543, 7877],
                [3541, 7853],
                [3500, 7864],
                [3532, 7963],
                [3538, 7991],
                [3566, 8006],
                [3600, 8038],
                [3607, 8067],
                [3625, 8100],
                [3622, 8135],
                [3673, 8150],
                [3716, 8191],
                [3721, 8222],
                [3715, 8253],
                [3731, 8329],
                [3788, 8348],
                [3788, 8334],
                [3765, 8312],
                [3779, 8311],
                [3807, 8253],
                [3811, 8204],
                [3830, 8195],
                [3828, 8164],
                [3844, 8127],
                [3870, 8146],
                [3882, 8143],
                [3961, 8141],
                [4003, 8132],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.NT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-nt",
          "hc-a2": "NT",
          labelrank: "2",
          hasc: "ID.NT",
          "alt-name": "NTT",
          "woe-id": "2345727",
          subregion: null,
          fips: "ID18",
          "postal-code": "NT",
          name: "Nusa Tenggara Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "120.689",
          "woe-name": "Nusa Tenggara Timur",
          latitude: "-8.584429999999999",
          "woe-label": "East Nusa Tenggara, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5295, 6340],
                [5308, 6338],
                [5307, 6320],
                [5278, 6300],
                [5239, 6308],
                [5295, 6340],
              ],
            ],
            [
              [
                [5640, 6397],
                [5626, 6394],
                [5630, 6370],
                [5613, 6368],
                [5609, 6384],
                [5627, 6410],
                [5650, 6407],
                [5640, 6397],
              ],
            ],
            [
              [
                [4770, 6731],
                [4795, 6736],
                [4778, 6723],
                [4776, 6699],
                [4755, 6705],
                [4770, 6731],
              ],
            ],
            [
              [
                [4722, 6770],
                [4746, 6765],
                [4745, 6746],
                [4731, 6751],
                [4717, 6725],
                [4724, 6711],
                [4703, 6714],
                [4702, 6748],
                [4709, 6778],
                [4722, 6770],
              ],
            ],
            [
              [
                [5565, 6806],
                [5564, 6796],
                [5528, 6788],
                [5517, 6769],
                [5500, 6770],
                [5526, 6801],
                [5565, 6806],
              ],
            ],
            [
              [
                [5591, 6849],
                [5601, 6848],
                [5600, 6818],
                [5535, 6810],
                [5534, 6828],
                [5568, 6852],
                [5591, 6849],
              ],
            ],
            [
              [
                [5809, 6823],
                [5794, 6789],
                [5768, 6786],
                [5760, 6811],
                [5734, 6805],
                [5752, 6832],
                [5768, 6840],
                [5781, 6822],
                [5814, 6870],
                [5825, 6861],
                [5824, 6838],
                [5809, 6823],
              ],
            ],
            [
              [
                [5502, 6232],
                [5495, 6264],
                [5549, 6281],
                [5574, 6299],
                [5588, 6320],
                [5624, 6346],
                [5622, 6314],
                [5631, 6290],
                [5617, 6291],
                [5593, 6276],
                [5585, 6258],
                [5535, 6245],
                [5532, 6236],
                [5502, 6232],
              ],
            ],
            [
              [
                [4848, 6429],
                [4784, 6459],
                [4778, 6471],
                [4733, 6481],
                [4717, 6471],
                [4690, 6481],
                [4665, 6481],
                [4633, 6494],
                [4611, 6518],
                [4629, 6549],
                [4661, 6562],
                [4765, 6575],
                [4808, 6568],
                [4836, 6589],
                [4851, 6574],
                [4865, 6555],
                [4905, 6541],
                [4912, 6511],
                [4959, 6512],
                [4983, 6492],
                [5004, 6458],
                [5032, 6441],
                [5041, 6412],
                [5015, 6385],
                [4983, 6379],
                [4957, 6359],
                [4943, 6370],
                [4890, 6378],
                [4862, 6402],
                [4848, 6429],
              ],
            ],
            [
              [
                [5681, 6807],
                [5677, 6815],
                [5652, 6776],
                [5641, 6787],
                [5619, 6772],
                [5601, 6783],
                [5579, 6785],
                [5608, 6812],
                [5633, 6823],
                [5634, 6833],
                [5610, 6834],
                [5620, 6845],
                [5655, 6851],
                [5644, 6830],
                [5656, 6821],
                [5672, 6857],
                [5688, 6852],
                [5708, 6868],
                [5741, 6854],
                [5703, 6838],
                [5681, 6807],
              ],
            ],
            [
              [
                [5907, 6875],
                [6006, 6879],
                [6017, 6862],
                [6014, 6834],
                [5932, 6820],
                [5905, 6820],
                [5852, 6805],
                [5832, 6817],
                [5849, 6842],
                [5846, 6861],
                [5858, 6878],
                [5885, 6883],
                [5893, 6866],
                [5907, 6875],
              ],
            ],
            [
              [
                [5705, 6436],
                [5666, 6444],
                [5682, 6473],
                [5681, 6499],
                [5690, 6537],
                [5729, 6566],
                [5758, 6599],
                [5788, 6581],
                [5805, 6594],
                [5820, 6565],
                [5832, 6568],
                [5840, 6594],
                [5858, 6612],
                [5863, 6640],
                [5889, 6642],
                [5918, 6667],
                [5970, 6692],
                [5977, 6665],
                [6008, 6687],
                [6026, 6670],
                [6022, 6641],
                [5983, 6639],
                [5979, 6628],
                [5994, 6605],
                [6004, 6571],
                [5991, 6560],
                [5984, 6530],
                [5956, 6510],
                [5931, 6474],
                [5887, 6442],
                [5859, 6412],
                [5791, 6409],
                [5772, 6385],
                [5749, 6380],
                [5724, 6364],
                [5700, 6362],
                [5667, 6369],
                [5643, 6364],
                [5648, 6390],
                [5660, 6404],
                [5706, 6425],
                [5705, 6436],
              ],
            ],
            [
              [
                [5520, 6871],
                [5530, 6828],
                [5504, 6820],
                [5503, 6798],
                [5481, 6803],
                [5492, 6777],
                [5483, 6763],
                [5428, 6748],
                [5393, 6730],
                [5325, 6731],
                [5301, 6714],
                [5253, 6694],
                [5229, 6701],
                [5220, 6688],
                [5214, 6704],
                [5162, 6712],
                [5150, 6683],
                [5110, 6688],
                [5088, 6676],
                [5055, 6679],
                [5034, 6703],
                [5019, 6692],
                [4991, 6696],
                [4980, 6706],
                [4931, 6705],
                [4900, 6698],
                [4874, 6709],
                [4839, 6698],
                [4827, 6684],
                [4800, 6713],
                [4799, 6746],
                [4813, 6770],
                [4847, 6796],
                [4866, 6795],
                [4889, 6819],
                [4927, 6824],
                [4976, 6824],
                [4975, 6835],
                [5011, 6814],
                [5063, 6814],
                [5076, 6802],
                [5136, 6784],
                [5157, 6763],
                [5178, 6764],
                [5187, 6757],
                [5209, 6771],
                [5209, 6786],
                [5225, 6779],
                [5260, 6788],
                [5273, 6784],
                [5299, 6800],
                [5307, 6780],
                [5330, 6775],
                [5365, 6754],
                [5413, 6769],
                [5411, 6792],
                [5434, 6811],
                [5470, 6820],
                [5498, 6838],
                [5514, 6857],
                [5496, 6861],
                [5466, 6850],
                [5477, 6878],
                [5493, 6888],
                [5520, 6871],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SE",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-se",
          "hc-a2": "SE",
          labelrank: "2",
          hasc: "ID.SE",
          "alt-name": "Sulsel",
          "woe-id": "2345729",
          subregion: null,
          fips: "ID38",
          "postal-code": "SE",
          name: "Sulawesi Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "119.99",
          "woe-name": "Sulawesi Selatan",
          latitude: "-3.7444",
          "woe-label": "South Sulawesi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5031, 7056],
                [5072, 7055],
                [5074, 7047],
                [5019, 7049],
                [5031, 7056],
              ],
            ],
            [
              [
                [5001, 7101],
                [5008, 7088],
                [4985, 7083],
                [4971, 7101],
                [4972, 7117],
                [5001, 7101],
              ],
            ],
            [
              [
                [5160, 8047],
                [5132, 8035],
                [5085, 8065],
                [5059, 8065],
                [5042, 8056],
                [5028, 8077],
                [5039, 8090],
                [5021, 8112],
                [4967, 8120],
                [4924, 8103],
                [4915, 8088],
                [4839, 8036],
                [4860, 7990],
                [4884, 7979],
                [4897, 7876],
                [4903, 7862],
                [4884, 7815],
                [4885, 7777],
                [4892, 7762],
                [4890, 7711],
                [4901, 7669],
                [4911, 7657],
                [4900, 7611],
                [4883, 7600],
                [4883, 7573],
                [4875, 7536],
                [4903, 7495],
                [4923, 7429],
                [4892, 7455],
                [4841, 7433],
                [4799, 7438],
                [4775, 7408],
                [4739, 7410],
                [4735, 7424],
                [4721, 7415],
                [4708, 7436],
                [4689, 7429],
                [4689, 7444],
                [4668, 7481],
                [4679, 7536],
                [4690, 7546],
                [4703, 7590],
                [4694, 7619],
                [4715, 7664],
                [4721, 7721],
                [4714, 7768],
                [4722, 7798],
                [4711, 7786],
                [4676, 7856],
                [4687, 7894],
                [4682, 7908],
                [4663, 7974],
                [4712, 7993],
                [4688, 8041],
                [4680, 8074],
                [4713, 8076],
                [4741, 8091],
                [4729, 8121],
                [4719, 8168],
                [4699, 8181],
                [4703, 8208],
                [4743, 8240],
                [4753, 8261],
                [4792, 8284],
                [4817, 8286],
                [4849, 8278],
                [4874, 8294],
                [4884, 8288],
                [4927, 8235],
                [4970, 8206],
                [5096, 8187],
                [5120, 8179],
                [5201, 8118],
                [5199, 8088],
                [5160, 8047],
              ],
            ],
            [
              [
                [4949, 7350],
                [4944, 7268],
                [4938, 7237],
                [4926, 7312],
                [4923, 7380],
                [4932, 7397],
                [4949, 7350],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kr",
          "hc-a2": "KR",
          labelrank: "2",
          hasc: "ID.KR",
          "alt-name": "Rhio|Riou|Riouw",
          "woe-id": "55949082",
          subregion: null,
          fips: "ID40",
          "postal-code": "KR",
          name: "Kepulauan Riau",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "104.601",
          "woe-name": "Kepulauan Riau",
          latitude: "-0.142639",
          "woe-label": "Kepulauan Riau, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1238, 8433],
                [1249, 8414],
                [1232, 8383],
                [1211, 8391],
                [1197, 8370],
                [1191, 8397],
                [1172, 8411],
                [1186, 8437],
                [1200, 8430],
                [1219, 8447],
                [1238, 8433],
              ],
            ],
            [
              [
                [1222, 8576],
                [1231, 8575],
                [1265, 8541],
                [1264, 8533],
                [1228, 8562],
                [1222, 8576],
              ],
            ],
            [
              [
                [1155, 8679],
                [1143, 8689],
                [1162, 8700],
                [1167, 8682],
                [1155, 8679],
              ],
            ],
            [
              [
                [964, 8710],
                [986, 8681],
                [984, 8654],
                [965, 8660],
                [948, 8684],
                [949, 8709],
                [964, 8710],
              ],
            ],
            [
              [
                [1061, 8691],
                [1035, 8707],
                [1038, 8718],
                [1055, 8707],
                [1061, 8691],
              ],
            ],
            [
              [
                [1137, 8721],
                [1159, 8715],
                [1141, 8702],
                [1118, 8719],
                [1122, 8736],
                [1137, 8721],
              ],
            ],
            [
              [
                [1075, 8746],
                [1089, 8733],
                [1076, 8730],
                [1060, 8746],
                [1075, 8746],
              ],
            ],
            [
              [
                [967, 8742],
                [948, 8739],
                [937, 8752],
                [954, 8768],
                [967, 8742],
              ],
            ],
            [
              [
                [1129, 8779],
                [1125, 8758],
                [1107, 8742],
                [1084, 8748],
                [1072, 8765],
                [1103, 8787],
                [1129, 8779],
              ],
            ],
            [
              [
                [2184, 9221],
                [2167, 9228],
                [2184, 9255],
                [2194, 9251],
                [2184, 9221],
              ],
            ],
            [
              [
                [1482, 9216],
                [1491, 9200],
                [1464, 9194],
                [1470, 9215],
                [1461, 9234],
                [1482, 9216],
              ],
            ],
            [
              [
                [1585, 9277],
                [1596, 9267],
                [1597, 9246],
                [1579, 9255],
                [1585, 9277],
              ],
            ],
            [
              [
                [1279, 8477],
                [1235, 8461],
                [1213, 8472],
                [1228, 8521],
                [1242, 8526],
                [1278, 8497],
                [1286, 8483],
                [1304, 8495],
                [1324, 8474],
                [1343, 8465],
                [1307, 8458],
                [1279, 8477],
              ],
            ],
            [
              [
                [1148, 8769],
                [1185, 8796],
                [1230, 8797],
                [1245, 8775],
                [1246, 8734],
                [1235, 8715],
                [1208, 8719],
                [1193, 8740],
                [1199, 8764],
                [1168, 8750],
                [1152, 8752],
                [1148, 8769],
              ],
            ],
            [
              [
                [2003, 9404],
                [2036, 9432],
                [1994, 9440],
                [1975, 9474],
                [2027, 9530],
                [2047, 9495],
                [2068, 9475],
                [2072, 9448],
                [2054, 9403],
                [2022, 9395],
                [2003, 9404],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.IB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ib",
          "hc-a2": "IB",
          labelrank: "2",
          hasc: "ID.IB",
          "alt-name":
            "New Guinea|Yos Sudarso or Frederick Hendrik|Waigeo|Supiori Biak|Yapen|Misool|Salawati|Batanta",
          "woe-id": "28350157",
          subregion: null,
          fips: "ID39",
          "postal-code": "IB",
          name: "Papua Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "132.825",
          "woe-name": "Papua Barat",
          latitude: "-1.32525",
          "woe-label": "West Papua, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [7991, 7850],
                [7968, 7846],
                [7936, 7864],
                [7936, 7878],
                [7969, 7856],
                [7991, 7850],
              ],
            ],
            [
              [
                [8176, 8362],
                [8165, 8378],
                [8176, 8398],
                [8187, 8391],
                [8176, 8362],
              ],
            ],
            [
              [
                [8128, 8416],
                [8122, 8438],
                [8135, 8459],
                [8140, 8447],
                [8128, 8416],
              ],
            ],
            [
              [
                [7098, 8551],
                [7075, 8537],
                [7047, 8543],
                [7074, 8558],
                [7098, 8551],
              ],
            ],
            [
              [
                [7304, 8658],
                [7324, 8656],
                [7300, 8634],
                [7252, 8622],
                [7210, 8624],
                [7211, 8642],
                [7279, 8643],
                [7304, 8658],
              ],
            ],
            [
              [
                [7228, 8820],
                [7291, 8840],
                [7371, 8825],
                [7407, 8809],
                [7418, 8781],
                [7395, 8753],
                [7361, 8767],
                [7343, 8756],
                [7326, 8760],
                [7307, 8781],
                [7287, 8784],
                [7261, 8820],
                [7246, 8805],
                [7292, 8765],
                [7310, 8771],
                [7325, 8755],
                [7306, 8739],
                [7275, 8735],
                [7262, 8770],
                [7236, 8758],
                [7233, 8736],
                [7248, 8741],
                [7264, 8729],
                [7254, 8713],
                [7211, 8711],
                [7220, 8732],
                [7233, 8736],
                [7218, 8777],
                [7204, 8769],
                [7152, 8783],
                [7192, 8785],
                [7194, 8802],
                [7168, 8793],
                [7162, 8809],
                [7186, 8818],
                [7197, 8811],
                [7216, 8826],
                [7228, 8820],
              ],
            ],
            [
              [
                [7196, 8372],
                [7178, 8348],
                [7098, 8355],
                [7047, 8382],
                [7116, 8416],
                [7166, 8421],
                [7198, 8432],
                [7198, 8421],
                [7219, 8396],
                [7198, 8377],
                [7220, 8369],
                [7205, 8357],
                [7196, 8372],
              ],
            ],
            [
              [
                [7292, 8543],
                [7261, 8603],
                [7268, 8611],
                [7318, 8630],
                [7329, 8622],
                [7352, 8625],
                [7363, 8612],
                [7356, 8551],
                [7345, 8521],
                [7313, 8524],
                [7292, 8543],
              ],
            ],
            [
              [
                [8313, 7851],
                [8280, 7863],
                [8259, 7880],
                [8269, 7927],
                [8325, 7920],
                [8320, 7933],
                [8262, 7935],
                [8241, 7910],
                [8226, 7905],
                [8202, 7934],
                [8178, 7943],
                [8175, 7906],
                [8144, 7923],
                [8132, 7940],
                [8144, 7950],
                [8127, 7971],
                [8119, 7952],
                [8087, 7948],
                [8057, 7995],
                [8054, 7975],
                [8024, 8001],
                [8007, 8037],
                [8020, 8046],
                [8015, 8093],
                [8058, 8131],
                [8056, 8169],
                [8042, 8146],
                [8011, 8120],
                [8011, 8061],
                [7986, 8043],
                [7994, 8011],
                [7952, 7972],
                [7964, 7942],
                [7920, 7891],
                [7906, 7885],
                [7874, 7888],
                [7847, 7875],
                [7804, 7915],
                [7812, 7916],
                [7787, 7977],
                [7793, 7991],
                [7823, 7988],
                [7835, 8010],
                [7810, 8031],
                [7804, 8074],
                [7775, 8060],
                [7752, 8085],
                [7758, 8093],
                [7740, 8115],
                [7683, 8151],
                [7650, 8157],
                [7623, 8147],
                [7599, 8156],
                [7614, 8183],
                [7595, 8185],
                [7651, 8215],
                [7678, 8216],
                [7744, 8209],
                [7782, 8188],
                [7805, 8206],
                [7851, 8270],
                [7884, 8285],
                [7918, 8281],
                [7943, 8252],
                [7949, 8268],
                [7970, 8247],
                [7991, 8262],
                [8006, 8255],
                [8011, 8218],
                [8017, 8268],
                [8043, 8236],
                [8042, 8277],
                [8024, 8286],
                [8083, 8296],
                [8060, 8306],
                [8073, 8323],
                [8046, 8321],
                [8034, 8330],
                [8071, 8353],
                [8069, 8368],
                [8013, 8350],
                [7998, 8334],
                [7949, 8332],
                [7912, 8339],
                [7827, 8316],
                [7796, 8325],
                [7768, 8309],
                [7733, 8337],
                [7683, 8314],
                [7650, 8338],
                [7615, 8351],
                [7589, 8384],
                [7577, 8422],
                [7597, 8452],
                [7573, 8445],
                [7567, 8470],
                [7583, 8486],
                [7545, 8468],
                [7546, 8489],
                [7525, 8476],
                [7520, 8490],
                [7488, 8496],
                [7453, 8490],
                [7439, 8514],
                [7415, 8514],
                [7428, 8496],
                [7400, 8482],
                [7380, 8498],
                [7340, 8498],
                [7355, 8539],
                [7391, 8555],
                [7407, 8588],
                [7401, 8650],
                [7473, 8674],
                [7467, 8662],
                [7554, 8691],
                [7604, 8744],
                [7644, 8767],
                [7684, 8778],
                [7750, 8778],
                [7799, 8758],
                [7816, 8761],
                [7836, 8746],
                [7860, 8742],
                [7920, 8698],
                [8007, 8696],
                [8063, 8705],
                [8113, 8673],
                [8089, 8664],
                [8080, 8649],
                [8105, 8603],
                [8124, 8589],
                [8145, 8556],
                [8133, 8534],
                [8129, 8501],
                [8100, 8473],
                [8121, 8387],
                [8121, 8354],
                [8133, 8304],
                [8168, 8271],
                [8187, 8217],
                [8203, 8189],
                [8220, 8196],
                [8205, 8245],
                [8206, 8268],
                [8222, 8280],
                [8214, 8301],
                [8227, 8325],
                [8229, 8293],
                [8248, 8264],
                [8254, 8197],
                [8200, 8149],
                [8202, 8136],
                [8173, 8108],
                [8155, 8079],
                [8157, 8056],
                [8407, 7975],
                [8313, 7851],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SU",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-su",
          "hc-a2": "SU",
          labelrank: "2",
          hasc: "ID.SU",
          "alt-name": "Sumut",
          "woe-id": "2345735",
          subregion: null,
          fips: "ID26",
          "postal-code": "SU",
          name: "Sumatera Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "99.2161",
          "woe-name": "Sumatera Utara",
          latitude: "2.36304",
          "woe-label": "North Sumatra, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-166, 8331],
                [-180, 8312],
                [-206, 8323],
                [-196, 8367],
                [-178, 8389],
                [-163, 8365],
                [-166, 8331],
              ],
            ],
            [
              [
                [-152, 8386],
                [-155, 8362],
                [-217, 8446],
                [-191, 8447],
                [-167, 8403],
                [-152, 8386],
              ],
            ],
            [
              [
                [-142, 8492],
                [-92, 8487],
                [-90, 8474],
                [-126, 8469],
                [-161, 8471],
                [-165, 8484],
                [-142, 8492],
              ],
            ],
            [
              [
                [-187, 8838],
                [-165, 8831],
                [-202, 8834],
                [-197, 8848],
                [-187, 8838],
              ],
            ],
            [
              [
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
              ],
            ],
            [
              [
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
              ],
            ],
            [
              [
                [-20, 8517],
                [-38, 8602],
                [-48, 8601],
                [-52, 8637],
                [-66, 8649],
                [-84, 8715],
                [-118, 8782],
                [-127, 8810],
                [-114, 8845],
                [-136, 8870],
                [-152, 8863],
                [-183, 8901],
                [-205, 8913],
                [-246, 8922],
                [-287, 8956],
                [-282, 8988],
                [-309, 9046],
                [-299, 9070],
                [-304, 9101],
                [-336, 9122],
                [-344, 9163],
                [-335, 9177],
                [-353, 9203],
                [-324, 9221],
                [-344, 9245],
                [-376, 9317],
                [-327, 9373],
                [-314, 9435],
                [-285, 9448],
                [-267, 9447],
                [-266, 9430],
                [-285, 9419],
                [-286, 9405],
                [-267, 9422],
                [-256, 9399],
                [-216, 9393],
                [-168, 9364],
                [-159, 9338],
                [-138, 9321],
                [-100, 9309],
                [-47, 9282],
                [27, 9236],
                [51, 9212],
                [89, 9203],
                [114, 9173],
                [145, 9151],
                [150, 9116],
                [141, 9094],
                [164, 9100],
                [183, 9055],
                [183, 9091],
                [199, 9098],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [220, 9016],
                [230, 8976],
                [231, 8907],
                [248, 8892],
                [266, 8843],
                [246, 8825],
                [190, 8797],
                [182, 8784],
                [202, 8753],
                [219, 8742],
                [220, 8671],
                [213, 8646],
                [131, 8667],
                [103, 8670],
                [124, 8647],
                [155, 8599],
                [154, 8584],
                [132, 8574],
                [102, 8580],
                [78, 8594],
                [22, 8570],
                [-20, 8517],
              ],
            ],
            [
              [
                [-524, 8764],
                [-483, 8766],
                [-451, 8792],
                [-424, 8783],
                [-373, 8717],
                [-349, 8709],
                [-313, 8673],
                [-321, 8654],
                [-322, 8592],
                [-334, 8573],
                [-363, 8574],
                [-387, 8632],
                [-442, 8659],
                [-443, 8675],
                [-477, 8730],
                [-524, 8764],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.RI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ri",
          "hc-a2": "RI",
          labelrank: "2",
          hasc: "ID.RI",
          "alt-name": "Rhio|Riou|Riouw",
          "woe-id": "2345728",
          subregion: null,
          fips: "ID37",
          "postal-code": "RI",
          name: "Riau",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "101.745",
          "woe-name": "Riau",
          latitude: "0.396892",
          "woe-label": "Riau, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [913, 8625],
                [903, 8630],
                [906, 8659],
                [917, 8669],
                [937, 8651],
                [935, 8631],
                [913, 8625],
              ],
            ],
            [
              [
                [873, 8745],
                [907, 8709],
                [887, 8698],
                [817, 8739],
                [784, 8731],
                [798, 8766],
                [818, 8769],
                [873, 8745],
              ],
            ],
            [
              [
                [742, 8719],
                [727, 8710],
                [712, 8718],
                [687, 8748],
                [688, 8776],
                [677, 8793],
                [680, 8819],
                [697, 8819],
                [741, 8783],
                [737, 8751],
                [742, 8719],
              ],
            ],
            [
              [
                [558, 8963],
                [572, 8938],
                [560, 8898],
                [529, 8881],
                [501, 8893],
                [484, 8930],
                [493, 8961],
                [514, 8960],
                [541, 8978],
                [558, 8963],
              ],
            ],
            [
              [
                [220, 9016],
                [226, 9063],
                [244, 9017],
                [288, 8973],
                [313, 8969],
                [358, 8940],
                [368, 8914],
                [381, 8914],
                [365, 8949],
                [344, 8977],
                [345, 8998],
                [367, 9010],
                [400, 9010],
                [405, 8993],
                [461, 8956],
                [482, 8894],
                [494, 8879],
                [532, 8869],
                [576, 8868],
                [634, 8823],
                [657, 8813],
                [665, 8781],
                [679, 8767],
                [678, 8740],
                [690, 8721],
                [744, 8676],
                [765, 8669],
                [791, 8673],
                [840, 8670],
                [883, 8633],
                [889, 8607],
                [808, 8560],
                [792, 8556],
                [778, 8536],
                [804, 8554],
                [851, 8565],
                [890, 8593],
                [910, 8600],
                [923, 8619],
                [954, 8632],
                [997, 8611],
                [1013, 8583],
                [1022, 8591],
                [1049, 8569],
                [1059, 8511],
                [1014, 8509],
                [1013, 8490],
                [992, 8484],
                [975, 8460],
                [992, 8462],
                [982, 8433],
                [989, 8429],
                [1000, 8455],
                [1025, 8459],
                [1055, 8445],
                [1055, 8435],
                [1023, 8423],
                [996, 8426],
                [1018, 8415],
                [1015, 8403],
                [980, 8391],
                [979, 8371],
                [965, 8350],
                [987, 8339],
                [910, 8329],
                [867, 8329],
                [842, 8321],
                [815, 8293],
                [784, 8250],
                [741, 8265],
                [717, 8294],
                [700, 8298],
                [660, 8290],
                [631, 8261],
                [606, 8251],
                [582, 8266],
                [548, 8272],
                [478, 8321],
                [429, 8372],
                [419, 8388],
                [385, 8404],
                [368, 8430],
                [357, 8463],
                [379, 8472],
                [376, 8522],
                [295, 8577],
                [262, 8568],
                [238, 8576],
                [212, 8620],
                [213, 8646],
                [220, 8671],
                [219, 8742],
                [202, 8753],
                [182, 8784],
                [190, 8797],
                [246, 8825],
                [266, 8843],
                [248, 8892],
                [231, 8907],
                [230, 8976],
                [220, 9016],
              ],
            ],
            [
              [
                [833, 8686],
                [794, 8685],
                [766, 8678],
                [730, 8698],
                [751, 8722],
                [746, 8759],
                [761, 8758],
                [783, 8729],
                [811, 8734],
                [872, 8699],
                [880, 8684],
                [870, 8664],
                [833, 8686],
              ],
            ],
            [
              [
                [629, 8864],
                [644, 8867],
                [683, 8856],
                [709, 8854],
                [742, 8840],
                [749, 8792],
                [731, 8796],
                [706, 8821],
                [660, 8829],
                [642, 8841],
                [629, 8864],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SW",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sw",
          "hc-a2": "SW",
          labelrank: "2",
          hasc: "ID.SW",
          "alt-name": "Sulut",
          "woe-id": "28350156",
          subregion: null,
          fips: "ID31",
          "postal-code": "SW",
          name: "Sulawesi Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "124.446",
          "woe-name": "Sulawesi Utara",
          latitude: "0.853039",
          "woe-label": "North Sulawesi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5978, 9385],
                [5963, 9404],
                [5968, 9423],
                [5983, 9418],
                [5973, 9404],
                [5978, 9385],
              ],
            ],
            [
              [
                [6013, 9593],
                [6023, 9575],
                [6014, 9565],
                [5985, 9582],
                [5988, 9605],
                [5968, 9618],
                [5967, 9640],
                [5984, 9635],
                [6013, 9593],
              ],
            ],
            [
              [
                [6292, 9664],
                [6275, 9670],
                [6269, 9688],
                [6285, 9683],
                [6292, 9664],
              ],
            ],
            [
              [
                [6258, 9678],
                [6249, 9705],
                [6235, 9731],
                [6260, 9704],
                [6258, 9678],
              ],
            ],
            [
              [
                [6254, 9783],
                [6250, 9821],
                [6255, 9847],
                [6274, 9851],
                [6289, 9840],
                [6287, 9810],
                [6303, 9791],
                [6279, 9760],
                [6281, 9732],
                [6270, 9721],
                [6247, 9729],
                [6276, 9775],
                [6254, 9783],
              ],
            ],
            [
              [
                [5462, 8959],
                [5525, 8962],
                [5571, 8951],
                [5582, 8956],
                [5633, 8946],
                [5660, 8949],
                [5673, 8964],
                [5707, 8977],
                [5743, 9000],
                [5758, 9035],
                [5806, 9040],
                [5810, 9055],
                [5795, 9058],
                [5793, 9078],
                [5809, 9092],
                [5826, 9089],
                [5862, 9112],
                [5857, 9134],
                [5901, 9170],
                [5904, 9158],
                [5936, 9157],
                [5934, 9138],
                [5955, 9116],
                [5964, 9132],
                [5960, 9100],
                [5931, 9100],
                [5908, 9041],
                [5880, 8993],
                [5862, 8984],
                [5827, 8951],
                [5822, 8932],
                [5793, 8886],
                [5796, 8879],
                [5753, 8853],
                [5694, 8839],
                [5620, 8825],
                [5594, 8813],
                [5553, 8822],
                [5561, 8849],
                [5545, 8890],
                [5499, 8916],
                [5488, 8939],
                [5462, 8959],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KU",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ku",
          "hc-a2": "KU",
          labelrank: "2",
          hasc: "ID.KU",
          "alt-name": "Kaluta",
          "woe-id": "2345723",
          subregion: null,
          fips: "ID42",
          "postal-code": "KU",
          name: "Kalimantan Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.354",
          "woe-name": "Kalimantan Utara",
          latitude: "1.28915",
          "woe-label": "North Kalimantan, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [4183, 9419],
                [4163, 9431],
                [4154, 9456],
                [4186, 9455],
                [4183, 9419],
              ],
            ],
            [
              [
                [4234, 9470],
                [4208, 9485],
                [4208, 9494],
                [4222, 9494],
                [4234, 9470],
              ],
            ],
            [
              [
                [4145, 9473],
                [4144, 9462],
                [4088, 9471],
                [4090, 9490],
                [4119, 9486],
                [4145, 9473],
              ],
            ],
            [
              [
                [4184, 9585],
                [4158, 9601],
                [4172, 9622],
                [4193, 9607],
                [4184, 9585],
              ],
            ],
            [
              [
                [4228, 9627],
                [4235, 9605],
                [4214, 9599],
                [4181, 9625],
                [4228, 9627],
              ],
            ],
            [
              [
                [3501, 8981],
                [3522, 9027],
                [3521, 9056],
                [3556, 9077],
                [3558, 9104],
                [3543, 9106],
                [3535, 9132],
                [3540, 9154],
                [3571, 9167],
                [3616, 9211],
                [3634, 9219],
                [3623, 9236],
                [3599, 9239],
                [3598, 9289],
                [3636, 9339],
                [3652, 9328],
                [3686, 9340],
                [3697, 9369],
                [3688, 9380],
                [3694, 9414],
                [3712, 9434],
                [3698, 9471],
                [3704, 9528],
                [3692, 9537],
                [3709, 9570],
                [3713, 9600],
                [3751, 9627],
                [3755, 9652],
                [3788, 9638],
                [3797, 9627],
                [3820, 9653],
                [3843, 9649],
                [3862, 9657],
                [3881, 9638],
                [3904, 9646],
                [3912, 9662],
                [3923, 9649],
                [3953, 9658],
                [3974, 9651],
                [4056, 9657],
                [4068, 9662],
                [4120, 9627],
                [4150, 9623],
                [4137, 9614],
                [4106, 9622],
                [4112, 9607],
                [4141, 9597],
                [4181, 9570],
                [4168, 9565],
                [4214, 9554],
                [4194, 9532],
                [4215, 9523],
                [4199, 9506],
                [4176, 9503],
                [4152, 9510],
                [4133, 9538],
                [4148, 9501],
                [4049, 9500],
                [4078, 9492],
                [4082, 9470],
                [4105, 9455],
                [4132, 9457],
                [4117, 9426],
                [4114, 9398],
                [4138, 9397],
                [4145, 9381],
                [4176, 9380],
                [4165, 9356],
                [4194, 9355],
                [4161, 9343],
                [4205, 9339],
                [4183, 9318],
                [4218, 9308],
                [4230, 9274],
                [4266, 9244],
                [4242, 9202],
                [4205, 9215],
                [4179, 9245],
                [4139, 9248],
                [4121, 9265],
                [4095, 9265],
                [4056, 9254],
                [4043, 9238],
                [3984, 9214],
                [3942, 9215],
                [3931, 9227],
                [3912, 9197],
                [3889, 9191],
                [3878, 9123],
                [3864, 9112],
                [3869, 9085],
                [3804, 8982],
                [3750, 8966],
                [3718, 8962],
                [3711, 8902],
                [3633, 8898],
                [3608, 8923],
                [3584, 8937],
                [3524, 8951],
                [3501, 8981],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.LA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-la",
          "hc-a2": "LA",
          labelrank: "2",
          hasc: "ID.LA",
          "alt-name": "Malut",
          "woe-id": "20069998",
          subregion: null,
          fips: "ID29",
          "postal-code": "LA",
          name: "Maluku Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "125.976",
          "woe-name": "Maluku Utara",
          latitude: "-2.28945",
          "woe-label": "North Maluku, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [6194, 8209],
                [6167, 8222],
                [6162, 8252],
                [6151, 8261],
                [6140, 8294],
                [6155, 8324],
                [6168, 8317],
                [6168, 8274],
                [6190, 8232],
                [6194, 8209],
              ],
            ],
            [
              [
                [6562, 8513],
                [6555, 8504],
                [6506, 8510],
                [6526, 8526],
                [6562, 8513],
              ],
            ],
            [
              [
                [6468, 8615],
                [6429, 8615],
                [6441, 8652],
                [6460, 8634],
                [6468, 8615],
              ],
            ],
            [
              [
                [6437, 8737],
                [6456, 8732],
                [6448, 8717],
                [6452, 8690],
                [6417, 8672],
                [6413, 8727],
                [6437, 8737],
              ],
            ],
            [
              [
                [6989, 8774],
                [6966, 8797],
                [6945, 8804],
                [6929, 8833],
                [6993, 8784],
                [6989, 8774],
              ],
            ],
            [
              [
                [6478, 8833],
                [6486, 8827],
                [6492, 8790],
                [6475, 8811],
                [6478, 8833],
              ],
            ],
            [
              [
                [6476, 8974],
                [6480, 8955],
                [6465, 8944],
                [6465, 8975],
                [6476, 8974],
              ],
            ],
            [
              [
                [6456, 8975],
                [6440, 8987],
                [6449, 8999],
                [6462, 8987],
                [6456, 8975],
              ],
            ],
            [
              [
                [6100, 8355],
                [6168, 8366],
                [6250, 8362],
                [6234, 8350],
                [6166, 8339],
                [6082, 8332],
                [6038, 8322],
                [6039, 8335],
                [6017, 8353],
                [6034, 8358],
                [6048, 8362],
                [6100, 8355],
              ],
            ],
            [
              [
                [5849, 8387],
                [5940, 8370],
                [5958, 8364],
                [5963, 8380],
                [5978, 8376],
                [5980, 8358],
                [6001, 8371],
                [6012, 8340],
                [5949, 8332],
                [5940, 8319],
                [5903, 8328],
                [5832, 8299],
                [5800, 8298],
                [5780, 8339],
                [5791, 8376],
                [5825, 8385],
                [5849, 8387],
              ],
            ],
            [
              [
                [6651, 8404],
                [6623, 8410],
                [6568, 8406],
                [6529, 8395],
                [6491, 8416],
                [6502, 8468],
                [6513, 8460],
                [6546, 8490],
                [6580, 8482],
                [6596, 8468],
                [6612, 8470],
                [6648, 8443],
                [6669, 8438],
                [6674, 8415],
                [6651, 8404],
              ],
            ],
            [
              [
                [6546, 8636],
                [6578, 8641],
                [6604, 8624],
                [6587, 8601],
                [6570, 8595],
                [6547, 8608],
                [6540, 8625],
                [6501, 8608],
                [6495, 8631],
                [6502, 8649],
                [6485, 8653],
                [6461, 8678],
                [6462, 8718],
                [6472, 8722],
                [6497, 8704],
                [6509, 8729],
                [6524, 8724],
                [6537, 8704],
                [6550, 8694],
                [6534, 8653],
                [6546, 8636],
              ],
            ],
            [
              [
                [6707, 9295],
                [6660, 9288],
                [6649, 9303],
                [6643, 9336],
                [6635, 9340],
                [6661, 9387],
                [6694, 9421],
                [6724, 9427],
                [6750, 9388],
                [6740, 9346],
                [6725, 9309],
                [6707, 9295],
              ],
            ],
            [
              [
                [6639, 8639],
                [6588, 8718],
                [6554, 8735],
                [6545, 8748],
                [6548, 8813],
                [6542, 8840],
                [6548, 8867],
                [6513, 8899],
                [6500, 8931],
                [6505, 8973],
                [6520, 8996],
                [6492, 9007],
                [6481, 9048],
                [6465, 9042],
                [6463, 9086],
                [6492, 9145],
                [6486, 9158],
                [6497, 9210],
                [6520, 9253],
                [6570, 9314],
                [6600, 9323],
                [6602, 9310],
                [6579, 9269],
                [6561, 9256],
                [6560, 9232],
                [6581, 9227],
                [6600, 9209],
                [6597, 9187],
                [6607, 9167],
                [6596, 9110],
                [6579, 9075],
                [6565, 9072],
                [6521, 9035],
                [6526, 9010],
                [6561, 8990],
                [6590, 9009],
                [6591, 9041],
                [6618, 9069],
                [6642, 9073],
                [6650, 9089],
                [6625, 9102],
                [6645, 9131],
                [6686, 9163],
                [6707, 9175],
                [6769, 9184],
                [6762, 9154],
                [6776, 9146],
                [6771, 9066],
                [6711, 9030],
                [6682, 9021],
                [6678, 9001],
                [6660, 8990],
                [6685, 8966],
                [6774, 8942],
                [6778, 8896],
                [6810, 8889],
                [6820, 8874],
                [6742, 8889],
                [6727, 8903],
                [6676, 8901],
                [6649, 8914],
                [6627, 8915],
                [6604, 8918],
                [6593, 8907],
                [6587, 8875],
                [6599, 8839],
                [6594, 8800],
                [6627, 8733],
                [6634, 8709],
                [6681, 8642],
                [6732, 8597],
                [6697, 8603],
                [6676, 8627],
                [6639, 8639],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sb",
          "hc-a2": "SB",
          labelrank: "2",
          hasc: "ID.SB",
          "alt-name": "Sumbar",
          "woe-id": "2345733",
          subregion: null,
          fips: "ID24",
          "postal-code": "SB",
          name: "Sumatera Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "100.611",
          "woe-name": "Sumatera Barat",
          latitude: "-0.642611",
          "woe-label": "West Sumatra, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [266, 7832],
                [251, 7817],
                [223, 7813],
                [215, 7828],
                [216, 7857],
                [206, 7877],
                [211, 7893],
                [264, 7851],
                [266, 7832],
              ],
            ],
            [
              [
                [141, 7972],
                [180, 7921],
                [119, 7938],
                [100, 7963],
                [113, 7996],
                [137, 7985],
                [141, 7972],
              ],
            ],
            [
              [
                [522, 7955],
                [485, 7937],
                [453, 7909],
                [427, 7941],
                [403, 7984],
                [414, 8009],
                [405, 8042],
                [387, 8059],
                [352, 8108],
                [348, 8128],
                [333, 8142],
                [331, 8168],
                [292, 8181],
                [296, 8198],
                [282, 8204],
                [291, 8233],
                [283, 8235],
                [262, 8283],
                [227, 8316],
                [187, 8363],
                [142, 8398],
                [127, 8426],
                [123, 8458],
                [89, 8486],
                [41, 8499],
                [19, 8516],
                [2, 8509],
                [-20, 8517],
                [22, 8570],
                [78, 8594],
                [102, 8580],
                [132, 8574],
                [154, 8584],
                [155, 8599],
                [124, 8647],
                [103, 8670],
                [131, 8667],
                [213, 8646],
                [212, 8620],
                [238, 8576],
                [262, 8568],
                [295, 8577],
                [376, 8522],
                [379, 8472],
                [357, 8463],
                [368, 8430],
                [385, 8404],
                [419, 8388],
                [429, 8372],
                [478, 8321],
                [548, 8272],
                [582, 8266],
                [606, 8251],
                [610, 8230],
                [624, 8222],
                [614, 8205],
                [588, 8192],
                [590, 8144],
                [540, 8091],
                [489, 8085],
                [462, 8089],
                [472, 8040],
                [501, 8004],
                [522, 7955],
              ],
            ],
            [
              [
                [265, 7784],
                [261, 7817],
                [271, 7830],
                [331, 7777],
                [331, 7765],
                [332, 7750],
                [313, 7744],
                [338, 7708],
                [314, 7717],
                [304, 7750],
                [265, 7784],
              ],
            ],
            [
              [
                [-68, 8242],
                [-59, 8236],
                [-62, 8224],
                [-20, 8166],
                [-3, 8121],
                [32, 8087],
                [31, 8048],
                [-5, 8039],
                [-57, 8064],
                [-76, 8098],
                [-132, 8172],
                [-122, 8197],
                [-120, 8228],
                [-68, 8242],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.MA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ma",
          "hc-a2": "MA",
          labelrank: "2",
          hasc: "ID.MA",
          "alt-name": "Molucas||Moluccas|Molucche|Moluckerna|Moluqu",
          "woe-id": "20069997",
          subregion: null,
          fips: "ID28",
          "postal-code": "MA",
          name: "Maluku",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "128.161",
          "woe-name": "Maluku",
          latitude: "-8.248139999999999",
          "woe-label": "Maluku, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [6734, 6879],
                [6731, 6862],
                [6706, 6864],
                [6706, 6878],
                [6734, 6879],
              ],
            ],
            [
              [
                [6925, 6879],
                [6897, 6870],
                [6877, 6883],
                [6913, 6887],
                [6925, 6879],
              ],
            ],
            [
              [
                [6609, 6871],
                [6589, 6878],
                [6608, 6890],
                [6628, 6877],
                [6609, 6871],
              ],
            ],
            [
              [
                [6642, 6904],
                [6709, 6886],
                [6692, 6868],
                [6635, 6886],
                [6629, 6903],
                [6642, 6904],
              ],
            ],
            [
              [
                [7407, 6901],
                [7427, 6899],
                [7387, 6879],
                [7364, 6875],
                [7360, 6861],
                [7333, 6851],
                [7354, 6877],
                [7398, 6915],
                [7407, 6901],
              ],
            ],
            [
              [
                [7096, 6977],
                [7114, 6972],
                [7118, 6949],
                [7099, 6920],
                [7079, 6923],
                [7056, 6950],
                [7064, 6981],
                [7096, 6977],
              ],
            ],
            [
              [
                [7420, 7025],
                [7414, 7011],
                [7381, 7006],
                [7388, 7016],
                [7420, 7025],
              ],
            ],
            [
              [
                [6537, 7008],
                [6533, 7041],
                [6559, 7036],
                [6560, 7025],
                [6537, 7008],
              ],
            ],
            [
              [
                [7431, 7074],
                [7409, 7055],
                [7389, 7057],
                [7394, 7075],
                [7431, 7074],
              ],
            ],
            [
              [
                [7606, 7151],
                [7620, 7134],
                [7618, 7115],
                [7597, 7136],
                [7571, 7136],
                [7568, 7149],
                [7606, 7151],
              ],
            ],
            [
              [
                [6837, 7123],
                [6828, 7113],
                [6803, 7129],
                [6823, 7150],
                [6842, 7140],
                [6837, 7123],
              ],
            ],
            [
              [
                [8273, 7239],
                [8259, 7241],
                [8275, 7279],
                [8286, 7276],
                [8273, 7239],
              ],
            ],
            [
              [
                [8285, 7291],
                [8268, 7287],
                [8259, 7305],
                [8283, 7305],
                [8285, 7291],
              ],
            ],
            [
              [
                [8255, 7321],
                [8232, 7298],
                [8220, 7320],
                [8195, 7331],
                [8217, 7353],
                [8255, 7321],
              ],
            ],
            [
              [
                [8312, 7312],
                [8301, 7326],
                [8312, 7354],
                [8323, 7342],
                [8312, 7312],
              ],
            ],
            [
              [
                [8144, 7421],
                [8161, 7416],
                [8164, 7391],
                [8188, 7366],
                [8210, 7355],
                [8189, 7342],
                [8141, 7384],
                [8144, 7421],
              ],
            ],
            [
              [
                [7791, 7511],
                [7816, 7452],
                [7801, 7430],
                [7784, 7442],
                [7784, 7488],
                [7770, 7514],
                [7791, 7511],
              ],
            ],
            [
              [
                [7811, 7526],
                [7817, 7498],
                [7805, 7496],
                [7802, 7521],
                [7811, 7526],
              ],
            ],
            [
              [
                [6480, 7882],
                [6464, 7881],
                [6455, 7896],
                [6478, 7903],
                [6480, 7882],
              ],
            ],
            [
              [
                [6758, 7958],
                [6752, 7978],
                [6780, 7981],
                [6789, 7967],
                [6758, 7958],
              ],
            ],
            [
              [
                [6812, 7982],
                [6822, 7990],
                [6828, 7963],
                [6814, 7974],
                [6804, 7962],
                [6790, 7982],
                [6812, 7982],
              ],
            ],
            [
              [
                [6543, 8038],
                [6555, 8035],
                [6566, 8014],
                [6531, 8028],
                [6543, 8038],
              ],
            ],
            [
              [
                [6601, 8042],
                [6569, 8046],
                [6583, 8062],
                [6596, 8064],
                [6601, 8042],
              ],
            ],
            [
              [
                [6647, 8114],
                [6639, 8097],
                [6613, 8092],
                [6616, 8103],
                [6647, 8114],
              ],
            ],
            [
              [
                [6723, 7986],
                [6732, 7970],
                [6735, 7957],
                [6716, 7959],
                [6722, 7946],
                [6695, 7929],
                [6704, 7953],
                [6654, 7920],
                [6636, 7936],
                [6664, 7964],
                [6693, 7966],
                [6723, 7986],
              ],
            ],
            [
              [
                [6359, 7026],
                [6382, 7001],
                [6400, 7002],
                [6409, 6985],
                [6380, 6982],
                [6344, 6965],
                [6323, 6930],
                [6313, 6938],
                [6259, 6939],
                [6232, 6948],
                [6198, 6940],
                [6172, 6918],
                [6163, 6921],
                [6170, 6951],
                [6184, 6963],
                [6202, 6995],
                [6261, 6988],
                [6290, 6993],
                [6330, 7018],
                [6359, 7026],
              ],
            ],
            [
              [
                [7513, 7134],
                [7539, 7149],
                [7543, 7135],
                [7555, 7144],
                [7564, 7128],
                [7541, 7114],
                [7554, 7076],
                [7541, 7032],
                [7521, 7006],
                [7481, 6972],
                [7464, 6931],
                [7456, 6950],
                [7443, 6934],
                [7416, 6935],
                [7409, 6965],
                [7427, 6980],
                [7421, 7010],
                [7437, 7004],
                [7434, 7031],
                [7448, 7061],
                [7472, 7070],
                [7482, 7092],
                [7513, 7134],
              ],
            ],
            [
              [
                [8184, 7214],
                [8153, 7199],
                [8121, 7234],
                [8133, 7307],
                [8153, 7304],
                [8137, 7320],
                [8131, 7368],
                [8140, 7379],
                [8179, 7350],
                [8177, 7340],
                [8214, 7315],
                [8235, 7280],
                [8184, 7214],
              ],
            ],
            [
              [
                [8191, 7493],
                [8216, 7537],
                [8228, 7534],
                [8224, 7558],
                [8246, 7564],
                [8275, 7538],
                [8262, 7527],
                [8290, 7504],
                [8277, 7464],
                [8293, 7451],
                [8259, 7440],
                [8295, 7402],
                [8278, 7345],
                [8255, 7334],
                [8188, 7369],
                [8178, 7385],
                [8176, 7441],
                [8194, 7460],
                [8194, 7477],
                [8156, 7489],
                [8168, 7501],
                [8191, 7493],
              ],
            ],
            [
              [
                [7863, 7504],
                [7888, 7586],
                [7906, 7587],
                [7890, 7517],
                [7874, 7504],
                [7857, 7485],
                [7851, 7449],
                [7825, 7422],
                [7845, 7492],
                [7863, 7504],
              ],
            ],
            [
              [
                [6181, 8026],
                [6203, 8058],
                [6226, 8043],
                [6252, 8062],
                [6280, 8071],
                [6350, 8076],
                [6387, 8066],
                [6439, 8047],
                [6444, 8030],
                [6428, 8029],
                [6433, 8015],
                [6456, 8015],
                [6482, 8005],
                [6478, 7953],
                [6470, 7940],
                [6450, 7941],
                [6409, 7913],
                [6362, 7890],
                [6326, 7898],
                [6227, 7945],
                [6221, 7962],
                [6197, 7980],
                [6181, 8026],
              ],
            ],
            [
              [
                [7031, 8162],
                [7083, 8137],
                [7136, 8121],
                [7207, 8127],
                [7243, 8102],
                [7264, 8095],
                [7276, 8074],
                [7288, 8029],
                [7311, 8029],
                [7339, 7990],
                [7330, 7961],
                [7333, 7920],
                [7276, 7939],
                [7230, 7971],
                [7160, 7994],
                [7125, 8010],
                [7119, 8028],
                [7102, 8039],
                [7019, 8045],
                [7009, 8036],
                [7025, 8011],
                [7007, 8005],
                [6976, 8017],
                [6947, 8018],
                [6917, 8029],
                [6881, 8026],
                [6885, 8051],
                [6860, 8062],
                [6818, 8026],
                [6815, 8006],
                [6769, 7997],
                [6749, 8009],
                [6719, 8052],
                [6695, 8058],
                [6699, 8077],
                [6684, 8085],
                [6668, 8056],
                [6667, 8032],
                [6651, 8013],
                [6638, 7971],
                [6631, 7978],
                [6639, 8010],
                [6634, 8029],
                [6615, 8060],
                [6653, 8084],
                [6676, 8087],
                [6679, 8116],
                [6691, 8137],
                [6740, 8138],
                [6771, 8145],
                [6792, 8141],
                [6854, 8142],
                [6898, 8157],
                [6902, 8136],
                [6916, 8122],
                [6971, 8148],
                [6991, 8165],
                [7031, 8162],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.NB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-nb",
          "hc-a2": "NB",
          labelrank: "2",
          hasc: "ID.NB",
          "alt-name": "NTB",
          "woe-id": "2345726",
          subregion: null,
          fips: "ID17",
          "postal-code": "NB",
          name: "Nusa Tenggara Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.294",
          "woe-name": "Nusa Tenggara Barat",
          latitude: "-8.571059999999999",
          "woe-label": "West Nusa Tenggara, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [4287, 6777],
                [4271, 6785],
                [4272, 6823],
                [4310, 6831],
                [4287, 6777],
              ],
            ],
            [
              [
                [4636, 6819],
                [4619, 6823],
                [4622, 6842],
                [4643, 6839],
                [4636, 6819],
              ],
            ],
            [
              [
                [4019, 6806],
                [4078, 6792],
                [4104, 6767],
                [4092, 6729],
                [4053, 6671],
                [4069, 6651],
                [4039, 6646],
                [4047, 6663],
                [4031, 6658],
                [4033, 6636],
                [4017, 6647],
                [3988, 6642],
                [3975, 6651],
                [3942, 6645],
                [3902, 6667],
                [3953, 6687],
                [3955, 6718],
                [3943, 6748],
                [3959, 6757],
                [3996, 6795],
                [4019, 6806],
              ],
            ],
            [
              [
                [4348, 6785],
                [4320, 6812],
                [4325, 6829],
                [4362, 6846],
                [4412, 6842],
                [4443, 6795],
                [4457, 6786],
                [4487, 6812],
                [4534, 6807],
                [4546, 6789],
                [4538, 6753],
                [4553, 6771],
                [4553, 6794],
                [4571, 6807],
                [4611, 6805],
                [4627, 6769],
                [4626, 6733],
                [4663, 6738],
                [4649, 6707],
                [4616, 6704],
                [4594, 6718],
                [4564, 6712],
                [4560, 6697],
                [4601, 6694],
                [4606, 6684],
                [4580, 6681],
                [4563, 6691],
                [4497, 6674],
                [4479, 6690],
                [4489, 6710],
                [4480, 6717],
                [4428, 6671],
                [4410, 6676],
                [4368, 6653],
                [4333, 6658],
                [4294, 6636],
                [4244, 6621],
                [4207, 6625],
                [4197, 6612],
                [4171, 6607],
                [4114, 6625],
                [4107, 6657],
                [4125, 6678],
                [4108, 6705],
                [4127, 6741],
                [4160, 6745],
                [4206, 6779],
                [4261, 6753],
                [4263, 6769],
                [4288, 6771],
                [4297, 6747],
                [4305, 6760],
                [4310, 6739],
                [4329, 6736],
                [4347, 6702],
                [4365, 6707],
                [4384, 6697],
                [4406, 6719],
                [4454, 6724],
                [4419, 6758],
                [4390, 6760],
                [4348, 6785],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SG",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sg",
          "hc-a2": "SG",
          labelrank: "2",
          hasc: "ID.SG",
          "alt-name": "Sultra",
          "woe-id": "2345731",
          subregion: null,
          fips: "ID22",
          "postal-code": "SG",
          name: "Sulawesi Tenggara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "122.119",
          "woe-name": "Sulawesi Tenggara",
          latitude: "-4.0746",
          "woe-label": "South East Sulawesi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5757, 7370],
                [5750, 7367],
                [5732, 7391],
                [5749, 7392],
                [5757, 7370],
              ],
            ],
            [
              [
                [5651, 7515],
                [5634, 7518],
                [5629, 7543],
                [5648, 7538],
                [5651, 7515],
              ],
            ],
            [
              [
                [5254, 7564],
                [5265, 7570],
                [5288, 7543],
                [5287, 7487],
                [5268, 7479],
                [5248, 7496],
                [5229, 7525],
                [5239, 7561],
                [5254, 7564],
              ],
            ],
            [
              [
                [5512, 7825],
                [5540, 7828],
                [5553, 7806],
                [5534, 7775],
                [5515, 7771],
                [5489, 7795],
                [5482, 7813],
                [5499, 7831],
                [5512, 7825],
              ],
            ],
            [
              [
                [5042, 8056],
                [5059, 8065],
                [5085, 8065],
                [5132, 8035],
                [5160, 8047],
                [5202, 8046],
                [5267, 8024],
                [5302, 8021],
                [5334, 7994],
                [5324, 7976],
                [5343, 7963],
                [5315, 7961],
                [5325, 7944],
                [5305, 7919],
                [5317, 7897],
                [5342, 7881],
                [5362, 7881],
                [5383, 7851],
                [5416, 7840],
                [5390, 7826],
                [5414, 7820],
                [5419, 7793],
                [5458, 7794],
                [5442, 7811],
                [5458, 7810],
                [5474, 7779],
                [5474, 7734],
                [5461, 7722],
                [5420, 7749],
                [5444, 7713],
                [5404, 7730],
                [5381, 7720],
                [5366, 7724],
                [5292, 7697],
                [5279, 7654],
                [5300, 7633],
                [5268, 7619],
                [5229, 7627],
                [5202, 7621],
                [5167, 7641],
                [5150, 7660],
                [5158, 7758],
                [5169, 7757],
                [5178, 7792],
                [5160, 7806],
                [5114, 7817],
                [5092, 7846],
                [5068, 7854],
                [5004, 7910],
                [4997, 7931],
                [5021, 7973],
                [5040, 7991],
                [5035, 8020],
                [5042, 8056],
              ],
            ],
            [
              [
                [5438, 7674],
                [5450, 7604],
                [5420, 7574],
                [5411, 7539],
                [5425, 7518],
                [5414, 7496],
                [5400, 7492],
                [5392, 7525],
                [5383, 7499],
                [5368, 7509],
                [5339, 7504],
                [5351, 7564],
                [5365, 7575],
                [5346, 7627],
                [5363, 7650],
                [5384, 7653],
                [5420, 7678],
                [5438, 7674],
              ],
            ],
            [
              [
                [5458, 7540],
                [5447, 7555],
                [5457, 7583],
                [5467, 7635],
                [5464, 7674],
                [5476, 7715],
                [5501, 7735],
                [5542, 7696],
                [5548, 7671],
                [5551, 7639],
                [5528, 7662],
                [5512, 7655],
                [5505, 7611],
                [5494, 7596],
                [5499, 7574],
                [5491, 7555],
                [5508, 7562],
                [5548, 7539],
                [5554, 7527],
                [5539, 7507],
                [5520, 7499],
                [5500, 7504],
                [5477, 7488],
                [5487, 7473],
                [5468, 7438],
                [5446, 7448],
                [5424, 7439],
                [5406, 7475],
                [5442, 7534],
                [5458, 7540],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.ST",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-st",
          "hc-a2": "ST",
          labelrank: "2",
          hasc: "ID.ST",
          "alt-name": "Sulteng",
          "woe-id": "2345730",
          subregion: null,
          fips: "ID21",
          "postal-code": "ST",
          name: "Sulawesi Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "120.153",
          "woe-name": "Sulawesi Tengah",
          latitude: "-1.30097",
          "woe-label": "Central Sulawesi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5675, 8292],
                [5657, 8295],
                [5655, 8322],
                [5669, 8310],
                [5675, 8292],
              ],
            ],
            [
              [
                [5495, 8310],
                [5488, 8310],
                [5495, 8344],
                [5507, 8327],
                [5495, 8310],
              ],
            ],
            [
              [
                [5601, 8383],
                [5612, 8378],
                [5604, 8355],
                [5583, 8359],
                [5579, 8390],
                [5589, 8409],
                [5601, 8383],
              ],
            ],
            [
              [
                [5191, 8639],
                [5206, 8624],
                [5198, 8614],
                [5152, 8621],
                [5191, 8639],
              ],
            ],
            [
              [
                [5238, 8658],
                [5241, 8672],
                [5253, 8644],
                [5209, 8636],
                [5196, 8640],
                [5207, 8660],
                [5238, 8658],
              ],
            ],
            [
              [
                [4670, 8513],
                [4696, 8536],
                [4689, 8543],
                [4706, 8561],
                [4735, 8507],
                [4735, 8543],
                [4719, 8567],
                [4710, 8598],
                [4713, 8681],
                [4699, 8677],
                [4677, 8692],
                [4685, 8711],
                [4721, 8686],
                [4733, 8723],
                [4708, 8760],
                [4726, 8772],
                [4722, 8784],
                [4734, 8815],
                [4761, 8826],
                [4757, 8861],
                [4765, 8878],
                [4804, 8901],
                [4812, 8938],
                [4826, 8937],
                [4829, 8908],
                [4881, 8894],
                [4906, 8944],
                [4916, 8941],
                [4931, 8962],
                [4932, 9017],
                [4952, 9028],
                [5010, 9020],
                [5035, 9005],
                [5077, 9023],
                [5073, 9007],
                [5086, 8983],
                [5122, 8971],
                [5189, 8983],
                [5200, 8968],
                [5227, 8977],
                [5253, 8970],
                [5207, 8947],
                [5171, 8953],
                [5096, 8920],
                [5066, 8922],
                [5049, 8913],
                [5035, 8889],
                [5018, 8879],
                [5041, 8857],
                [5059, 8856],
                [5061, 8830],
                [5022, 8827],
                [5012, 8816],
                [4981, 8822],
                [4960, 8816],
                [4909, 8838],
                [4869, 8835],
                [4840, 8822],
                [4818, 8798],
                [4787, 8751],
                [4779, 8711],
                [4766, 8692],
                [4761, 8660],
                [4788, 8559],
                [4826, 8509],
                [4845, 8498],
                [4865, 8507],
                [4886, 8492],
                [4906, 8463],
                [4904, 8438],
                [4931, 8398],
                [4966, 8412],
                [4980, 8400],
                [5003, 8404],
                [5023, 8396],
                [5043, 8420],
                [5049, 8448],
                [5064, 8461],
                [5115, 8530],
                [5151, 8542],
                [5165, 8515],
                [5214, 8513],
                [5255, 8521],
                [5265, 8551],
                [5277, 8559],
                [5370, 8567],
                [5395, 8559],
                [5440, 8568],
                [5450, 8576],
                [5408, 8584],
                [5397, 8592],
                [5417, 8602],
                [5464, 8607],
                [5475, 8617],
                [5513, 8616],
                [5552, 8601],
                [5565, 8575],
                [5551, 8518],
                [5535, 8506],
                [5497, 8531],
                [5483, 8554],
                [5475, 8543],
                [5418, 8530],
                [5399, 8486],
                [5383, 8474],
                [5346, 8421],
                [5322, 8394],
                [5281, 8364],
                [5243, 8362],
                [5193, 8336],
                [5171, 8292],
                [5136, 8286],
                [5112, 8311],
                [5082, 8316],
                [5090, 8300],
                [5091, 8269],
                [5104, 8288],
                [5136, 8255],
                [5146, 8232],
                [5176, 8229],
                [5205, 8206],
                [5220, 8178],
                [5253, 8133],
                [5253, 8115],
                [5292, 8091],
                [5296, 8077],
                [5324, 8065],
                [5318, 8038],
                [5362, 8009],
                [5355, 7993],
                [5334, 7994],
                [5302, 8021],
                [5267, 8024],
                [5202, 8046],
                [5160, 8047],
                [5199, 8088],
                [5201, 8118],
                [5120, 8179],
                [5096, 8187],
                [4970, 8206],
                [4927, 8235],
                [4884, 8288],
                [4874, 8294],
                [4849, 8278],
                [4817, 8286],
                [4792, 8284],
                [4753, 8261],
                [4741, 8279],
                [4745, 8298],
                [4715, 8337],
                [4706, 8372],
                [4694, 8386],
                [4659, 8399],
                [4657, 8409],
                [4682, 8441],
                [4674, 8463],
                [4670, 8513],
              ],
            ],
            [
              [
                [5428, 8450],
                [5441, 8471],
                [5458, 8470],
                [5511, 8481],
                [5522, 8466],
                [5512, 8458],
                [5521, 8426],
                [5559, 8469],
                [5591, 8458],
                [5590, 8421],
                [5575, 8406],
                [5552, 8401],
                [5543, 8421],
                [5528, 8410],
                [5528, 8374],
                [5511, 8373],
                [5495, 8388],
                [5511, 8405],
                [5504, 8445],
                [5488, 8436],
                [5467, 8397],
                [5440, 8379],
                [5424, 8410],
                [5428, 8450],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.PA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-pa",
          "hc-a2": "PA",
          labelrank: "2",
          hasc: "ID.PA",
          "alt-name":
            "New Guinea|Yos Sudarso or Frederick Hendrik|Waigeo|Supiori Biak|Yapen|Misool|Salawati|Batanta",
          "woe-id": "2345718",
          subregion: null,
          fips: "ID36",
          "postal-code": "PA",
          name: "Papua",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "138.689",
          "woe-name": "Papua",
          latitude: "-4.10825",
          "woe-label": "Papua, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [9317, 6836],
                [9314, 6822],
                [9230, 6834],
                [9231, 6849],
                [9263, 6880],
                [9299, 6878],
                [9301, 6855],
                [9317, 6836],
              ],
            ],
            [
              [
                [9282, 7212],
                [9266, 7216],
                [9252, 7248],
                [9282, 7236],
                [9282, 7212],
              ],
            ],
            [
              [
                [8354, 8534],
                [8405, 8534],
                [8391, 8524],
                [8349, 8523],
                [8354, 8534],
              ],
            ],
            [
              [
                [8301, 8631],
                [8317, 8645],
                [8308, 8617],
                [8282, 8621],
                [8269, 8640],
                [8287, 8663],
                [8307, 8649],
                [8301, 8631],
              ],
            ],
            [
              [
                [9100, 7025],
                [9154, 7063],
                [9192, 7076],
                [9249, 7086],
                [9295, 7083],
                [9329, 7040],
                [9363, 7031],
                [9340, 6990],
                [9339, 6967],
                [9313, 6942],
                [9315, 6914],
                [9278, 6887],
                [9256, 6883],
                [9241, 6862],
                [9201, 6831],
                [9163, 6822],
                [9134, 6831],
                [9053, 6834],
                [9000, 6823],
                [9000, 6832],
                [9031, 6910],
                [9042, 6918],
                [9066, 6974],
                [9100, 7025],
              ],
            ],
            [
              [
                [8642, 8439],
                [8502, 8484],
                [8444, 8489],
                [8428, 8504],
                [8442, 8510],
                [8546, 8499],
                [8619, 8501],
                [8669, 8485],
                [8748, 8487],
                [8784, 8480],
                [8791, 8467],
                [8755, 8463],
                [8734, 8450],
                [8687, 8444],
                [8658, 8451],
                [8642, 8439],
              ],
            ],
            [
              [
                [8412, 8722],
                [8418, 8739],
                [8463, 8731],
                [8481, 8734],
                [8507, 8720],
                [8524, 8734],
                [8580, 8693],
                [8614, 8646],
                [8639, 8650],
                [8659, 8641],
                [8640, 8618],
                [8603, 8607],
                [8565, 8619],
                [8544, 8613],
                [8523, 8632],
                [8509, 8689],
                [8499, 8702],
                [8479, 8684],
                [8434, 8714],
                [8412, 8722],
              ],
            ],
            [
              [
                [8254, 8197],
                [8262, 8167],
                [8280, 8163],
                [8299, 8183],
                [8292, 8125],
                [8308, 8099],
                [8329, 8101],
                [8335, 8079],
                [8418, 8067],
                [8455, 8074],
                [8495, 8120],
                [8526, 8138],
                [8521, 8146],
                [8561, 8170],
                [8573, 8222],
                [8599, 8248],
                [8646, 8278],
                [8677, 8363],
                [8766, 8359],
                [8831, 8394],
                [8881, 8406],
                [8875, 8437],
                [8849, 8452],
                [8858, 8477],
                [8909, 8498],
                [8954, 8528],
                [9019, 8559],
                [9051, 8560],
                [9091, 8530],
                [9163, 8508],
                [9242, 8491],
                [9278, 8459],
                [9356, 8439],
                [9402, 8412],
                [9553, 8354],
                [9630, 8368],
                [9642, 8349],
                [9673, 8336],
                [9687, 8351],
                [9744, 8342],
                [9780, 8328],
                [9769, 8300],
                [9840, 8304],
                [9844, 8136],
                [9851, 7686],
                [9851, 7342],
                [9844, 7305],
                [9820, 7272],
                [9817, 7248],
                [9834, 7207],
                [9849, 7198],
                [9836, 6630],
                [9806, 6646],
                [9748, 6709],
                [9720, 6753],
                [9657, 6814],
                [9602, 6856],
                [9587, 6883],
                [9605, 6908],
                [9577, 6892],
                [9501, 6889],
                [9471, 6876],
                [9431, 6872],
                [9413, 6879],
                [9398, 6904],
                [9364, 6890],
                [9319, 6851],
                [9301, 6890],
                [9322, 6904],
                [9320, 6944],
                [9341, 6958],
                [9345, 6986],
                [9367, 7035],
                [9333, 7049],
                [9316, 7086],
                [9266, 7129],
                [9321, 7126],
                [9346, 7116],
                [9384, 7115],
                [9337, 7135],
                [9285, 7148],
                [9238, 7192],
                [9240, 7205],
                [9280, 7203],
                [9328, 7216],
                [9377, 7184],
                [9346, 7214],
                [9301, 7226],
                [9263, 7254],
                [9273, 7271],
                [9212, 7328],
                [9193, 7370],
                [9186, 7406],
                [9162, 7458],
                [9189, 7465],
                [9147, 7473],
                [9134, 7486],
                [9185, 7510],
                [9153, 7508],
                [9112, 7497],
                [9113, 7575],
                [9090, 7562],
                [9072, 7582],
                [9075, 7597],
                [9049, 7588],
                [9020, 7623],
                [8988, 7633],
                [8959, 7654],
                [8944, 7654],
                [8913, 7693],
                [8897, 7674],
                [8831, 7696],
                [8829, 7707],
                [8798, 7694],
                [8681, 7754],
                [8659, 7754],
                [8601, 7776],
                [8585, 7792],
                [8524, 7797],
                [8451, 7811],
                [8401, 7803],
                [8334, 7836],
                [8313, 7851],
                [8407, 7975],
                [8157, 8056],
                [8155, 8079],
                [8173, 8108],
                [8202, 8136],
                [8200, 8149],
                [8254, 8197],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jr",
          "hc-a2": "JR",
          labelrank: "2",
          hasc: "ID.JR",
          "alt-name": "Jabar",
          "woe-id": "2345715",
          subregion: null,
          fips: "ID30",
          "postal-code": "JR",
          name: "Jawa Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "107.638",
          "woe-name": "Jawa Barat",
          latitude: "-6.90763",
          "woe-label": "West Java, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1753, 6957],
              [1761, 6993],
              [1773, 7006],
              [1753, 7024],
              [1746, 7063],
              [1747, 7098],
              [1756, 7106],
              [1795, 7098],
              [1826, 7103],
              [1824, 7119],
              [1862, 7103],
              [1873, 7137],
              [1872, 7173],
              [1882, 7211],
              [1907, 7199],
              [1953, 7201],
              [1982, 7165],
              [2017, 7157],
              [2031, 7146],
              [2060, 7159],
              [2126, 7132],
              [2150, 7145],
              [2149, 7156],
              [2185, 7154],
              [2189, 7133],
              [2210, 7111],
              [2229, 7102],
              [2248, 7041],
              [2281, 7031],
              [2314, 7033],
              [2295, 7004],
              [2294, 6975],
              [2274, 6956],
              [2247, 6949],
              [2244, 6916],
              [2270, 6910],
              [2290, 6867],
              [2289, 6852],
              [2304, 6839],
              [2285, 6837],
              [2276, 6824],
              [2246, 6829],
              [2228, 6799],
              [2200, 6798],
              [2114, 6810],
              [2094, 6807],
              [2080, 6820],
              [2053, 6824],
              [2030, 6843],
              [1988, 6857],
              [1943, 6857],
              [1919, 6862],
              [1786, 6864],
              [1757, 6869],
              [1751, 6899],
              [1784, 6945],
              [1783, 6961],
              [1763, 6966],
              [1753, 6957],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ki",
          "hc-a2": "KI",
          labelrank: "2",
          hasc: "ID.KI",
          "alt-name": "Kaltim",
          "woe-id": "2345723",
          subregion: null,
          fips: "ID14",
          "postal-code": "KI",
          name: "Kalimantan Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.354",
          "woe-name": "Kalimantan Timur",
          latitude: "1.28915",
          "woe-label": "East Kalimantan, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [3420, 8964],
              [3462, 8981],
              [3487, 8967],
              [3501, 8981],
              [3524, 8951],
              [3584, 8937],
              [3608, 8923],
              [3633, 8898],
              [3711, 8902],
              [3718, 8962],
              [3750, 8966],
              [3804, 8982],
              [3869, 9085],
              [3864, 9112],
              [3878, 9123],
              [3889, 9191],
              [3912, 9197],
              [3931, 9227],
              [3942, 9215],
              [3984, 9214],
              [4043, 9238],
              [4056, 9254],
              [4095, 9265],
              [4121, 9265],
              [4139, 9248],
              [4179, 9245],
              [4205, 9215],
              [4242, 9202],
              [4266, 9244],
              [4295, 9199],
              [4262, 9175],
              [4254, 9148],
              [4217, 9145],
              [4248, 9134],
              [4247, 9111],
              [4262, 9096],
              [4290, 9090],
              [4310, 9061],
              [4381, 9027],
              [4375, 9019],
              [4426, 8999],
              [4453, 8978],
              [4485, 8935],
              [4519, 8932],
              [4520, 8915],
              [4475, 8877],
              [4448, 8885],
              [4421, 8874],
              [4390, 8880],
              [4380, 8872],
              [4364, 8883],
              [4334, 8885],
              [4306, 8896],
              [4286, 8929],
              [4266, 8928],
              [4298, 8880],
              [4291, 8863],
              [4272, 8874],
              [4249, 8866],
              [4231, 8843],
              [4231, 8829],
              [4209, 8794],
              [4179, 8703],
              [4195, 8671],
              [4185, 8657],
              [4176, 8618],
              [4190, 8590],
              [4180, 8558],
              [4214, 8583],
              [4216, 8561],
              [4205, 8521],
              [4223, 8501],
              [4170, 8486],
              [4161, 8472],
              [4147, 8492],
              [4141, 8469],
              [4122, 8452],
              [4093, 8400],
              [4047, 8384],
              [4038, 8407],
              [4022, 8414],
              [4040, 8388],
              [4035, 8360],
              [4001, 8346],
              [3985, 8331],
              [3991, 8303],
              [3939, 8278],
              [3917, 8258],
              [3952, 8265],
              [3968, 8259],
              [3961, 8247],
              [3974, 8234],
              [3974, 8208],
              [3936, 8172],
              [3955, 8180],
              [3964, 8166],
              [3991, 8175],
              [4009, 8170],
              [4003, 8132],
              [3961, 8141],
              [3882, 8143],
              [3870, 8146],
              [3844, 8127],
              [3828, 8164],
              [3830, 8195],
              [3811, 8204],
              [3807, 8253],
              [3779, 8311],
              [3765, 8312],
              [3788, 8334],
              [3798, 8334],
              [3815, 8365],
              [3814, 8412],
              [3799, 8407],
              [3772, 8434],
              [3733, 8453],
              [3721, 8478],
              [3711, 8521],
              [3699, 8537],
              [3684, 8581],
              [3683, 8602],
              [3697, 8653],
              [3660, 8652],
              [3620, 8608],
              [3611, 8626],
              [3621, 8662],
              [3603, 8712],
              [3606, 8730],
              [3628, 8770],
              [3623, 8793],
              [3603, 8814],
              [3549, 8797],
              [3533, 8785],
              [3469, 8774],
              [3424, 8786],
              [3390, 8783],
              [3376, 8773],
              [3332, 8760],
              [3362, 8802],
              [3368, 8831],
              [3348, 8839],
              [3347, 8856],
              [3419, 8913],
              [3420, 8964],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.1024",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-1024",
          "hc-a2": "LA",
          labelrank: "2",
          hasc: "ID.LA",
          "alt-name": null,
          "woe-id": "2345724",
          subregion: null,
          fips: "ID15",
          "postal-code": null,
          name: "Lampung",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "105.059",
          "woe-name": "Lampung",
          latitude: "-4.919",
          "woe-label": "Lampung, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1084, 7388],
              [1111, 7407],
              [1118, 7416],
              [1139, 7406],
              [1148, 7388],
              [1192, 7388],
              [1221, 7402],
              [1241, 7404],
              [1249, 7422],
              [1231, 7445],
              [1240, 7464],
              [1237, 7507],
              [1285, 7538],
              [1319, 7545],
              [1355, 7565],
              [1386, 7574],
              [1415, 7605],
              [1418, 7629],
              [1448, 7647],
              [1457, 7677],
              [1505, 7654],
              [1522, 7635],
              [1527, 7615],
              [1553, 7593],
              [1581, 7593],
              [1580, 7560],
              [1603, 7523],
              [1600, 7436],
              [1610, 7415],
              [1602, 7393],
              [1604, 7344],
              [1599, 7314],
              [1602, 7252],
              [1594, 7212],
              [1583, 7196],
              [1578, 7210],
              [1553, 7214],
              [1537, 7248],
              [1523, 7246],
              [1481, 7288],
              [1467, 7288],
              [1466, 7263],
              [1453, 7260],
              [1464, 7220],
              [1442, 7213],
              [1365, 7247],
              [1345, 7265],
              [1324, 7272],
              [1305, 7255],
              [1344, 7201],
              [1352, 7175],
              [1317, 7171],
              [1311, 7191],
              [1273, 7222],
              [1252, 7232],
              [1242, 7255],
              [1207, 7274],
              [1178, 7303],
              [1179, 7315],
              [1155, 7323],
              [1157, 7341],
              [1127, 7364],
              [1095, 7374],
              [1084, 7388],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JK",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jk",
          "hc-a2": "JK",
          labelrank: "9",
          hasc: "ID.JK",
          "alt-name": "Jawa|Djakarta",
          "woe-id": "2345713",
          subregion: null,
          fips: "ID04",
          "postal-code": "JK",
          name: "Jakarta Raya",
          country: "Indonesia",
          "type-en": "Special district",
          region: null,
          longitude: "106.837",
          "woe-name": "Jakarta Raya",
          latitude: "-6.22462",
          "woe-label": "DKI Jakarta, ID, Indonesia",
          type: "Daerah Khusus Ibukota",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1813, 7174],
              [1818, 7166],
              [1872, 7173],
              [1873, 7137],
              [1862, 7103],
              [1824, 7119],
              [1809, 7139],
              [1803, 7163],
              [1813, 7174],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.GO",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-go",
          "hc-a2": "GO",
          labelrank: "7",
          hasc: "ID.GO",
          "alt-name": null,
          "woe-id": "2345732",
          subregion: null,
          fips: "ID34",
          "postal-code": "GO",
          name: "Gorontalo",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "122.331",
          "woe-name": "Gorontalo",
          latitude: "0.760501",
          "woe-label": "Gorontalo, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [5253, 8970],
              [5262, 8967],
              [5312, 8972],
              [5352, 8962],
              [5406, 8931],
              [5421, 8941],
              [5432, 8965],
              [5462, 8959],
              [5488, 8939],
              [5499, 8916],
              [5545, 8890],
              [5561, 8849],
              [5553, 8822],
              [5502, 8822],
              [5462, 8864],
              [5440, 8855],
              [5365, 8851],
              [5289, 8850],
              [5253, 8842],
              [5223, 8843],
              [5211, 8835],
              [5169, 8828],
              [5142, 8848],
              [5105, 8850],
              [5101, 8838],
              [5061, 8830],
              [5059, 8856],
              [5041, 8857],
              [5018, 8879],
              [5035, 8889],
              [5049, 8913],
              [5066, 8922],
              [5096, 8920],
              [5171, 8953],
              [5207, 8947],
              [5253, 8970],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.YO",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-yo",
          "hc-a2": "YO",
          labelrank: "7",
          hasc: "ID.YO",
          "alt-name": "Jawa|Daerah Istimewa Yogyakarta",
          "woe-id": "2345719",
          subregion: null,
          fips: "ID10",
          "postal-code": "YO",
          name: "Yogyakarta",
          country: "Indonesia",
          "type-en": "Special region",
          region: null,
          longitude: "110.443",
          "woe-name": "Yogyakarta",
          latitude: "-7.83533",
          "woe-label": "Special Region of Yogyakarta, ID, Indonesia",
          type: "Daerah Istimewa",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [2773, 6745],
              [2738, 6748],
              [2689, 6760],
              [2588, 6805],
              [2606, 6854],
              [2634, 6847],
              [2673, 6884],
              [2691, 6835],
              [2733, 6829],
              [2755, 6818],
              [2761, 6762],
              [2773, 6745],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SL",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sl",
          "hc-a2": "SL",
          labelrank: "2",
          hasc: "ID.SL",
          "alt-name": "Sumsel",
          "woe-id": "2345734",
          subregion: null,
          fips: "ID32",
          "postal-code": "SL",
          name: "Sumatera Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "104.073",
          "woe-name": "Sumatera Selatan",
          latitude: "-3.3824",
          "woe-label": "South Sumatra, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1251, 8127],
              [1242, 8093],
              [1254, 8100],
              [1278, 8086],
              [1292, 8058],
              [1310, 8070],
              [1334, 8053],
              [1336, 8034],
              [1308, 7992],
              [1303, 7938],
              [1315, 7972],
              [1339, 8006],
              [1351, 7987],
              [1367, 7997],
              [1394, 7988],
              [1413, 7996],
              [1510, 7990],
              [1509, 7955],
              [1525, 7931],
              [1549, 7926],
              [1555, 7887],
              [1576, 7868],
              [1607, 7866],
              [1617, 7849],
              [1624, 7801],
              [1593, 7774],
              [1583, 7754],
              [1572, 7703],
              [1605, 7668],
              [1588, 7628],
              [1581, 7593],
              [1553, 7593],
              [1527, 7615],
              [1522, 7635],
              [1505, 7654],
              [1457, 7677],
              [1448, 7647],
              [1418, 7629],
              [1415, 7605],
              [1386, 7574],
              [1355, 7565],
              [1319, 7545],
              [1285, 7538],
              [1237, 7507],
              [1240, 7464],
              [1231, 7445],
              [1249, 7422],
              [1241, 7404],
              [1221, 7402],
              [1192, 7388],
              [1148, 7388],
              [1139, 7406],
              [1118, 7416],
              [1081, 7482],
              [1078, 7502],
              [977, 7536],
              [964, 7580],
              [926, 7580],
              [876, 7594],
              [842, 7626],
              [859, 7632],
              [901, 7671],
              [897, 7684],
              [923, 7684],
              [927, 7706],
              [916, 7726],
              [891, 7729],
              [866, 7750],
              [836, 7727],
              [795, 7752],
              [800, 7775],
              [786, 7789],
              [742, 7793],
              [736, 7817],
              [698, 7854],
              [735, 7879],
              [740, 7890],
              [785, 7872],
              [819, 7878],
              [862, 7913],
              [877, 7939],
              [875, 7963],
              [936, 7957],
              [954, 7966],
              [945, 7983],
              [954, 8007],
              [976, 7985],
              [1013, 7961],
              [1011, 7998],
              [1032, 8009],
              [1023, 8026],
              [1025, 8061],
              [1104, 8105],
              [1159, 8100],
              [1204, 8109],
              [1227, 8135],
              [1251, 8127],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sr",
          "hc-a2": "SR",
          labelrank: "2",
          hasc: "ID.SR",
          "alt-name": "Sulsel",
          "woe-id": "28350155",
          subregion: null,
          fips: "ID41",
          "postal-code": "SR",
          name: "Sulawesi Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "119.316",
          "woe-name": "Sulawesi Barat",
          latitude: "-2.69615",
          "woe-label": "West Sulawesi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [4682, 7908],
              [4637, 7919],
              [4617, 7904],
              [4576, 7898],
              [4553, 7884],
              [4531, 7933],
              [4534, 7945],
              [4511, 7990],
              [4531, 8000],
              [4535, 8044],
              [4511, 8043],
              [4506, 8062],
              [4520, 8098],
              [4541, 8093],
              [4563, 8110],
              [4591, 8142],
              [4586, 8196],
              [4603, 8241],
              [4630, 8252],
              [4635, 8284],
              [4621, 8314],
              [4625, 8342],
              [4615, 8384],
              [4622, 8390],
              [4620, 8424],
              [4647, 8452],
              [4661, 8507],
              [4670, 8513],
              [4674, 8463],
              [4682, 8441],
              [4657, 8409],
              [4659, 8399],
              [4694, 8386],
              [4706, 8372],
              [4715, 8337],
              [4745, 8298],
              [4741, 8279],
              [4753, 8261],
              [4743, 8240],
              [4703, 8208],
              [4699, 8181],
              [4719, 8168],
              [4729, 8121],
              [4741, 8091],
              [4713, 8076],
              [4680, 8074],
              [4688, 8041],
              [4712, 7993],
              [4663, 7974],
              [4682, 7908],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ja",
          "hc-a2": "JA",
          labelrank: "6",
          hasc: "ID.JA",
          "alt-name": "Djambi",
          "woe-id": "2345714",
          subregion: null,
          fips: "ID05",
          "postal-code": "JA",
          name: "Jambi",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "102.823",
          "woe-name": "Jambi",
          latitude: "-1.65497",
          "woe-label": "Jambi, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [987, 8339],
              [989, 8324],
              [1004, 8327],
              [1038, 8297],
              [1083, 8279],
              [1109, 8293],
              [1169, 8274],
              [1207, 8286],
              [1213, 8250],
              [1226, 8224],
              [1231, 8173],
              [1251, 8127],
              [1227, 8135],
              [1204, 8109],
              [1159, 8100],
              [1104, 8105],
              [1025, 8061],
              [1023, 8026],
              [1032, 8009],
              [1011, 7998],
              [1013, 7961],
              [976, 7985],
              [954, 8007],
              [945, 7983],
              [954, 7966],
              [936, 7957],
              [875, 7963],
              [877, 7939],
              [862, 7913],
              [819, 7878],
              [785, 7872],
              [740, 7890],
              [735, 7879],
              [698, 7854],
              [659, 7861],
              [619, 7883],
              [577, 7923],
              [564, 7956],
              [544, 7971],
              [522, 7955],
              [501, 8004],
              [472, 8040],
              [462, 8089],
              [489, 8085],
              [540, 8091],
              [590, 8144],
              [588, 8192],
              [614, 8205],
              [624, 8222],
              [610, 8230],
              [606, 8251],
              [631, 8261],
              [660, 8290],
              [700, 8298],
              [717, 8294],
              [741, 8265],
              [784, 8250],
              [815, 8293],
              [842, 8321],
              [867, 8329],
              [910, 8329],
              [987, 8339],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kt",
          "hc-a2": "KT",
          labelrank: "2",
          hasc: "ID.KT",
          "alt-name": "Kalteng",
          "woe-id": "2345722",
          subregion: null,
          fips: "ID13",
          "postal-code": "KT",
          name: "Kalimantan Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "113.286",
          "woe-name": "Kalimantan Tengah",
          latitude: "-1.84217",
          "woe-label": "Central Kalimantan, ID, Indonesia",
          type: "Propinsi",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [3500, 7864],
              [3489, 7871],
              [3510, 7915],
              [3485, 7880],
              [3458, 7876],
              [3455, 7911],
              [3438, 7878],
              [3404, 7859],
              [3365, 7848],
              [3347, 7851],
              [3347, 7887],
              [3341, 7912],
              [3306, 7910],
              [3281, 7889],
              [3254, 7909],
              [3240, 7931],
              [3221, 7938],
              [3205, 7964],
              [3202, 7938],
              [3188, 7918],
              [3204, 7910],
              [3116, 7846],
              [3095, 7842],
              [3063, 7862],
              [3043, 7867],
              [3001, 7850],
              [2956, 7804],
              [2936, 7809],
              [2939, 7851],
              [2931, 7889],
              [2933, 7919],
              [2908, 7974],
              [2895, 7954],
              [2902, 7944],
              [2876, 7928],
              [2844, 7944],
              [2810, 7940],
              [2758, 7909],
              [2723, 7902],
              [2688, 7914],
              [2698, 7929],
              [2732, 7948],
              [2756, 7976],
              [2771, 7984],
              [2767, 8059],
              [2735, 8120],
              [2730, 8152],
              [2736, 8207],
              [2731, 8225],
              [2708, 8235],
              [2728, 8256],
              [2756, 8256],
              [2798, 8294],
              [2817, 8319],
              [2853, 8339],
              [2867, 8379],
              [2970, 8448],
              [3030, 8447],
              [3075, 8460],
              [3169, 8507],
              [3204, 8520],
              [3227, 8503],
              [3236, 8533],
              [3223, 8546],
              [3239, 8571],
              [3262, 8587],
              [3272, 8619],
              [3265, 8645],
              [3233, 8684],
              [3254, 8692],
              [3280, 8690],
              [3300, 8702],
              [3304, 8725],
              [3332, 8760],
              [3376, 8773],
              [3390, 8783],
              [3424, 8786],
              [3469, 8774],
              [3533, 8785],
              [3549, 8797],
              [3603, 8814],
              [3623, 8793],
              [3628, 8770],
              [3606, 8730],
              [3603, 8712],
              [3621, 8662],
              [3611, 8626],
              [3620, 8608],
              [3660, 8652],
              [3697, 8653],
              [3683, 8602],
              [3684, 8581],
              [3699, 8537],
              [3711, 8521],
              [3721, 8478],
              [3733, 8453],
              [3772, 8434],
              [3799, 8407],
              [3814, 8412],
              [3815, 8365],
              [3798, 8334],
              [3788, 8334],
              [3788, 8348],
              [3731, 8329],
              [3715, 8253],
              [3721, 8222],
              [3716, 8191],
              [3673, 8150],
              [3622, 8135],
              [3625, 8100],
              [3607, 8067],
              [3600, 8038],
              [3566, 8006],
              [3538, 7991],
              [3532, 7963],
              [3500, 7864],
            ],
          ],
        },
      },
    ],
  };
}

function load_data2() {
  return {
    title: "Indonesia",
    version: "1.1.3",
    type: "FeatureCollection",
    copyright:
      "Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth",
    copyrightShort: "Natural Earth",
    copyrightUrl: "http://www.naturalearthdata.com",
    crs: { type: "name", properties: { name: "urn:ogc:def:crs:EPSG:23836" } },
    "hc-transform": {
      default: {
        rotation: -0.0523598775598,
        crs: "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
        scale: 0.000132056229838,
        jsonres: 15.5,
        jsonmarginX: -999,
        jsonmarginY: 9851,
        xoffset: -1856151.37844,
        yoffset: 2110546.03205,
      },
    },
    features: [
      {
        type: "Feature",
        id: "ID.3700",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-3700",
          "hc-a2": "NU",
          labelrank: "20",
          hasc: "-99",
          "alt-name": null,
          "woe-id": "-99",
          subregion: null,
          fips: null,
          "postal-code": null,
          name: null,
          country: "Indonesia",
          "type-en": null,
          region: null,
          longitude: "104.223",
          "woe-name": null,
          latitude: "-1.04563",
          "woe-label": null,
          type: null,
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [8129, 7927],
              [8149, 7905],
              [8121, 7915],
              [8113, 7930],
              [8129, 7927],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.AC",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ac",
          "hc-a2": "AC",
          labelrank: "6",
          hasc: "ID.AC",
          "alt-name": "Achin|Atjeh|Nanggroe Aceh Darussalam",
          "woe-id": "2345710",
          subregion: null,
          fips: "ID01",
          "postal-code": "AC",
          name: "Aceh",
          country: "Indonesia",
          "type-en": "Autonomous Province",
          region: null,
          longitude: "96.9956",
          "woe-name": "Aceh",
          latitude: "4.41533",
          "woe-label": "Aceh, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.35,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-501, 8952],
                [-489, 8957],
                [-471, 8946],
                [-469, 8911],
                [-501, 8952],
              ],
            ],
            [
              [
                [-983, 9800],
                [-966, 9807],
                [-956, 9794],
                [-967, 9779],
                [-983, 9800],
              ],
            ],
            [
              [
                [-793, 9077],
                [-767, 9070],
                [-729, 9034],
                [-711, 9027],
                [-697, 9006],
                [-681, 9010],
                [-671, 8981],
                [-705, 8978],
                [-707, 8987],
                [-771, 9028],
                [-803, 9030],
                [-860, 9072],
                [-844, 9087],
                [-840, 9111],
                [-811, 9104],
                [-793, 9077],
              ],
            ],
            [
              [
                [-287, 8956],
                [-322, 8974],
                [-339, 8968],
                [-372, 8974],
                [-393, 9004],
                [-399, 9064],
                [-411, 9109],
                [-454, 9122],
                [-476, 9146],
                [-492, 9188],
                [-513, 9195],
                [-554, 9258],
                [-587, 9295],
                [-617, 9309],
                [-664, 9307],
                [-696, 9325],
                [-754, 9394],
                [-770, 9396],
                [-798, 9416],
                [-894, 9508],
                [-906, 9510],
                [-940, 9554],
                [-975, 9639],
                [-997, 9663],
                [-985, 9688],
                [-999, 9723],
                [-948, 9749],
                [-925, 9738],
                [-901, 9744],
                [-835, 9719],
                [-825, 9696],
                [-777, 9666],
                [-721, 9654],
                [-653, 9653],
                [-612, 9670],
                [-578, 9669],
                [-507, 9643],
                [-454, 9667],
                [-414, 9627],
                [-355, 9585],
                [-330, 9526],
                [-332, 9506],
                [-317, 9508],
                [-283, 9496],
                [-266, 9480],
                [-267, 9447],
                [-285, 9448],
                [-314, 9435],
                [-327, 9373],
                [-376, 9317],
                [-344, 9245],
                [-324, 9221],
                [-353, 9203],
                [-335, 9177],
                [-344, 9163],
                [-336, 9122],
                [-304, 9101],
                [-299, 9070],
                [-309, 9046],
                [-282, 8988],
                [-287, 8956],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jt",
          "hc-a2": "JT",
          labelrank: "2",
          hasc: "ID.JT",
          "alt-name": "Jateng",
          "woe-id": "2345716",
          subregion: null,
          fips: "ID07",
          "postal-code": "JT",
          name: "Jawa Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "109.896",
          "woe-name": "Jawa Tengah",
          latitude: "-7.2901",
          "woe-label": "Central Java, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [2341, 6828],
                [2351, 6817],
                [2304, 6826],
                [2310, 6836],
                [2341, 6828],
              ],
            ],
            [
              [
                [2796, 6740],
                [2792, 6741],
                [2773, 6745],
                [2761, 6762],
                [2755, 6818],
                [2733, 6829],
                [2691, 6835],
                [2673, 6884],
                [2634, 6847],
                [2606, 6854],
                [2588, 6805],
                [2499, 6824],
                [2447, 6823],
                [2434, 6836],
                [2372, 6838],
                [2354, 6826],
                [2325, 6837],
                [2320, 6852],
                [2304, 6839],
                [2289, 6852],
                [2290, 6867],
                [2270, 6910],
                [2244, 6916],
                [2247, 6949],
                [2274, 6956],
                [2294, 6975],
                [2295, 7004],
                [2314, 7033],
                [2335, 7028],
                [2338, 7040],
                [2371, 7027],
                [2418, 7025],
                [2459, 7036],
                [2503, 7033],
                [2542, 7022],
                [2610, 7033],
                [2647, 7016],
                [2673, 7024],
                [2694, 7050],
                [2708, 7084],
                [2712, 7127],
                [2725, 7138],
                [2768, 7152],
                [2797, 7142],
                [2815, 7099],
                [2824, 7090],
                [2886, 7091],
                [2899, 7109],
                [2926, 7101],
                [2941, 7087],
                [2932, 7071],
                [2927, 7034],
                [2932, 6991],
                [2897, 6953],
                [2845, 6964],
                [2841, 6951],
                [2841, 6901],
                [2849, 6882],
                [2844, 6861],
                [2872, 6845],
                [2868, 6809],
                [2828, 6791],
                [2799, 6765],
                [2796, 6740],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BE",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-be",
          "hc-a2": "BE",
          labelrank: "7",
          hasc: "ID.BE",
          "alt-name": "Bencoolen|Benkoelen|Benkulen",
          "woe-id": "2345712",
          subregion: null,
          fips: "ID03",
          "postal-code": "BE",
          name: "Bengkulu",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "102.368",
          "woe-name": "Bengkulu",
          latitude: "-3.48606",
          "woe-label": "Bengkulu, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [811, 7243],
                [791, 7240],
                [743, 7268],
                [759, 7282],
                [812, 7264],
                [811, 7243],
              ],
            ],
            [
              [
                [453, 7909],
                [485, 7937],
                [522, 7955],
                [544, 7971],
                [564, 7956],
                [577, 7923],
                [619, 7883],
                [659, 7861],
                [698, 7854],
                [736, 7817],
                [742, 7793],
                [786, 7789],
                [800, 7775],
                [795, 7752],
                [836, 7727],
                [866, 7750],
                [891, 7729],
                [916, 7726],
                [927, 7706],
                [923, 7684],
                [897, 7684],
                [901, 7671],
                [859, 7632],
                [842, 7626],
                [876, 7594],
                [926, 7580],
                [964, 7580],
                [977, 7536],
                [1078, 7502],
                [1081, 7482],
                [1118, 7416],
                [1111, 7407],
                [1084, 7388],
                [1060, 7397],
                [1038, 7396],
                [1033, 7408],
                [979, 7449],
                [919, 7474],
                [908, 7490],
                [866, 7522],
                [772, 7580],
                [768, 7614],
                [746, 7659],
                [708, 7678],
                [605, 7740],
                [550, 7812],
                [526, 7853],
                [472, 7885],
                [453, 7909],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-bt",
          "hc-a2": "BT",
          labelrank: "2",
          hasc: "ID.BT",
          "alt-name": null,
          "woe-id": "28350158",
          subregion: null,
          fips: "ID33",
          "postal-code": "BT",
          name: "Banten",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "106.167",
          "woe-name": "Banten",
          latitude: "-6.25794",
          "woe-label": "Banten, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1486, 7045],
                [1486, 7022],
                [1470, 7011],
                [1469, 7040],
                [1486, 7045],
              ],
            ],
            [
              [
                [1824, 7119],
                [1826, 7103],
                [1795, 7098],
                [1756, 7106],
                [1747, 7098],
                [1746, 7063],
                [1753, 7024],
                [1773, 7006],
                [1761, 6993],
                [1753, 6957],
                [1725, 6957],
                [1670, 6987],
                [1649, 6990],
                [1607, 6980],
                [1591, 6982],
                [1542, 6971],
                [1501, 6982],
                [1489, 6991],
                [1511, 7016],
                [1534, 6984],
                [1570, 7031],
                [1567, 7050],
                [1580, 7064],
                [1588, 7051],
                [1604, 7057],
                [1612, 7075],
                [1611, 7122],
                [1622, 7159],
                [1656, 7204],
                [1673, 7181],
                [1686, 7176],
                [1704, 7193],
                [1759, 7176],
                [1797, 7184],
                [1813, 7174],
                [1803, 7163],
                [1809, 7139],
                [1824, 7119],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kb",
          "hc-a2": "KB",
          labelrank: "2",
          hasc: "ID.KB",
          "alt-name": "Kalbar",
          "woe-id": "2345720",
          subregion: null,
          fips: "ID11",
          "postal-code": "KB",
          name: "Kalimantan Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "111.304",
          "woe-name": "Kalimantan Barat",
          latitude: "-0.063647",
          "woe-label": "West Kalimantan, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.35,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [2262, 8220],
                [2256, 8204],
                [2233, 8198],
                [2227, 8220],
                [2247, 8228],
                [2262, 8220],
              ],
            ],
            [
              [
                [2401, 8363],
                [2437, 8352],
                [2443, 8330],
                [2376, 8289],
                [2362, 8298],
                [2367, 8355],
                [2401, 8363],
              ],
            ],
            [
              [
                [2732, 7948],
                [2696, 7933],
                [2667, 7900],
                [2655, 7938],
                [2630, 7945],
                [2576, 7913],
                [2561, 7936],
                [2569, 7961],
                [2560, 7991],
                [2547, 7998],
                [2560, 8018],
                [2545, 8040],
                [2539, 8072],
                [2528, 8093],
                [2534, 8122],
                [2520, 8155],
                [2479, 8174],
                [2507, 8217],
                [2512, 8265],
                [2502, 8298],
                [2478, 8311],
                [2475, 8338],
                [2455, 8341],
                [2430, 8370],
                [2418, 8362],
                [2373, 8390],
                [2355, 8375],
                [2324, 8387],
                [2319, 8429],
                [2367, 8416],
                [2337, 8449],
                [2318, 8446],
                [2286, 8465],
                [2279, 8496],
                [2265, 8522],
                [2281, 8532],
                [2306, 8526],
                [2297, 8539],
                [2288, 8586],
                [2320, 8583],
                [2288, 8604],
                [2272, 8633],
                [2230, 8653],
                [2234, 8677],
                [2225, 8696],
                [2227, 8721],
                [2209, 8763],
                [2228, 8776],
                [2235, 8802],
                [2222, 8843],
                [2234, 8852],
                [2249, 8891],
                [2255, 8931],
                [2290, 8957],
                [2310, 8991],
                [2307, 9019],
                [2356, 9034],
                [2371, 9044],
                [2350, 9011],
                [2355, 8994],
                [2377, 8987],
                [2379, 8955],
                [2388, 8941],
                [2427, 8904],
                [2448, 8900],
                [2459, 8880],
                [2487, 8859],
                [2504, 8856],
                [2528, 8817],
                [2548, 8816],
                [2565, 8799],
                [2596, 8788],
                [2647, 8803],
                [2662, 8824],
                [2739, 8846],
                [2775, 8834],
                [2818, 8833],
                [2844, 8841],
                [2882, 8838],
                [2901, 8863],
                [2944, 8875],
                [2960, 8924],
                [2958, 8942],
                [3023, 8972],
                [3091, 8973],
                [3110, 8980],
                [3149, 8972],
                [3136, 8944],
                [3165, 8949],
                [3220, 8934],
                [3237, 8922],
                [3261, 8928],
                [3295, 8911],
                [3330, 8937],
                [3352, 8961],
                [3385, 8968],
                [3420, 8964],
                [3419, 8913],
                [3347, 8856],
                [3348, 8839],
                [3368, 8831],
                [3362, 8802],
                [3332, 8760],
                [3304, 8725],
                [3300, 8702],
                [3280, 8690],
                [3254, 8692],
                [3233, 8684],
                [3265, 8645],
                [3272, 8619],
                [3262, 8587],
                [3239, 8571],
                [3223, 8546],
                [3236, 8533],
                [3227, 8503],
                [3204, 8520],
                [3169, 8507],
                [3075, 8460],
                [3030, 8447],
                [2970, 8448],
                [2867, 8379],
                [2853, 8339],
                [2817, 8319],
                [2798, 8294],
                [2756, 8256],
                [2728, 8256],
                [2708, 8235],
                [2731, 8225],
                [2736, 8207],
                [2730, 8152],
                [2735, 8120],
                [2767, 8059],
                [2771, 7984],
                [2756, 7976],
                [2732, 7948],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-bb",
          "hc-a2": "BB",
          labelrank: "2",
          hasc: "ID.BB",
          "alt-name": "Babel|Kepulauan Bangka Belitung",
          "woe-id": "28350154",
          subregion: null,
          fips: "ID35",
          "postal-code": "BB",
          name: "Bangka-Belitung",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "106.819",
          "woe-name": "Bangka-Belitung",
          latitude: "-2.95817",
          "woe-label": "Bangka-Belitung, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1802, 7864],
                [1769, 7876],
                [1788, 7894],
                [1811, 7887],
                [1802, 7864],
              ],
            ],
            [
              [
                [1944, 7906],
                [1925, 7889],
                [1909, 7902],
                [1935, 7918],
                [1944, 7906],
              ],
            ],
            [
              [
                [1980, 7980],
                [2020, 7985],
                [2053, 7981],
                [2063, 7966],
                [2071, 7978],
                [2102, 7960],
                [2118, 7943],
                [2125, 7919],
                [2107, 7886],
                [2110, 7857],
                [2083, 7849],
                [2080, 7834],
                [2062, 7830],
                [2055, 7850],
                [2032, 7871],
                [2026, 7850],
                [1980, 7825],
                [1971, 7833],
                [1980, 7853],
                [1965, 7877],
                [1971, 7898],
                [1965, 7928],
                [1976, 7937],
                [1980, 7980],
              ],
            ],
            [
              [
                [1767, 7847],
                [1724, 7844],
                [1706, 7869],
                [1624, 7896],
                [1599, 7899],
                [1577, 7942],
                [1585, 7972],
                [1557, 7994],
                [1547, 8044],
                [1503, 8055],
                [1493, 8065],
                [1467, 8051],
                [1434, 8046],
                [1416, 8060],
                [1397, 8057],
                [1397, 8090],
                [1446, 8118],
                [1449, 8138],
                [1438, 8158],
                [1462, 8178],
                [1492, 8189],
                [1501, 8169],
                [1519, 8161],
                [1508, 8148],
                [1523, 8134],
                [1546, 8131],
                [1530, 8150],
                [1521, 8191],
                [1547, 8193],
                [1565, 8200],
                [1596, 8179],
                [1595, 8160],
                [1629, 8116],
                [1628, 8086],
                [1656, 8009],
                [1678, 7985],
                [1789, 7968],
                [1768, 7956],
                [1754, 7936],
                [1742, 7896],
                [1743, 7880],
                [1773, 7867],
                [1767, 7847],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.BA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ba",
          "hc-a2": "BA",
          labelrank: "2",
          hasc: "ID.BA",
          "alt-name": "Penida|Lembongan|Ceningan|Menjangan",
          "woe-id": "2345711",
          subregion: null,
          fips: "ID02",
          "postal-code": "BA",
          name: "Bali",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "115.179",
          "woe-name": "Bali",
          latitude: "-8.341200000000001",
          "woe-label": "Bali, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3843, 6692],
                [3855, 6671],
                [3848, 6661],
                [3820, 6677],
                [3843, 6692],
              ],
            ],
            [
              [
                [3639, 6804],
                [3677, 6793],
                [3714, 6799],
                [3738, 6823],
                [3756, 6827],
                [3822, 6804],
                [3872, 6761],
                [3848, 6731],
                [3786, 6700],
                [3762, 6676],
                [3768, 6655],
                [3746, 6647],
                [3736, 6654],
                [3756, 6677],
                [3749, 6690],
                [3695, 6732],
                [3665, 6744],
                [3630, 6744],
                [3609, 6758],
                [3589, 6783],
                [3584, 6811],
                [3604, 6804],
                [3639, 6804],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ji",
          "hc-a2": "JI",
          labelrank: "2",
          hasc: "ID.JI",
          "alt-name": "Jatim",
          "woe-id": "2345717",
          subregion: null,
          fips: "ID08",
          "postal-code": "JI",
          name: "Jawa Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "112.616",
          "woe-name": "Jawa Timur",
          latitude: "-7.88129",
          "woe-label": "East Java, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3561, 7028],
                [3561, 7018],
                [3538, 7025],
                [3544, 7046],
                [3561, 7028],
              ],
            ],
            [
              [
                [3780, 7106],
                [3824, 7092],
                [3822, 7084],
                [3782, 7089],
                [3763, 7066],
                [3745, 7088],
                [3757, 7105],
                [3780, 7106],
              ],
            ],
            [
              [
                [3165, 7325],
                [3170, 7304],
                [3141, 7298],
                [3136, 7310],
                [3149, 7325],
                [3165, 7325],
              ],
            ],
            [
              [
                [3344, 7074],
                [3362, 7072],
                [3467, 7081],
                [3498, 7059],
                [3450, 7042],
                [3434, 7022],
                [3396, 7025],
                [3378, 7014],
                [3371, 6996],
                [3284, 6994],
                [3276, 6992],
                [3205, 7004],
                [3184, 7003],
                [3177, 7031],
                [3197, 7043],
                [3208, 7061],
                [3258, 7070],
                [3276, 7068],
                [3344, 7074],
              ],
            ],
            [
              [
                [2941, 7087],
                [2952, 7079],
                [2990, 7072],
                [3010, 7079],
                [3032, 7055],
                [3061, 7054],
                [3099, 7064],
                [3130, 7057],
                [3154, 7059],
                [3150, 7040],
                [3169, 7026],
                [3157, 7020],
                [3175, 6999],
                [3157, 6994],
                [3180, 6981],
                [3198, 6993],
                [3207, 6981],
                [3206, 6948],
                [3197, 6919],
                [3216, 6906],
                [3260, 6895],
                [3283, 6879],
                [3307, 6878],
                [3321, 6867],
                [3372, 6890],
                [3434, 6888],
                [3465, 6900],
                [3481, 6914],
                [3510, 6897],
                [3536, 6898],
                [3565, 6887],
                [3585, 6871],
                [3582, 6829],
                [3567, 6739],
                [3572, 6714],
                [3582, 6727],
                [3592, 6693],
                [3621, 6684],
                [3624, 6658],
                [3572, 6664],
                [3575, 6681],
                [3556, 6692],
                [3533, 6684],
                [3495, 6691],
                [3484, 6687],
                [3445, 6711],
                [3424, 6706],
                [3405, 6720],
                [3353, 6733],
                [3338, 6747],
                [3304, 6756],
                [3257, 6743],
                [3239, 6724],
                [3223, 6729],
                [3187, 6711],
                [3135, 6721],
                [3111, 6733],
                [3018, 6735],
                [2987, 6744],
                [2961, 6717],
                [2951, 6727],
                [2910, 6727],
                [2908, 6735],
                [2868, 6739],
                [2847, 6730],
                [2829, 6746],
                [2822, 6735],
                [2796, 6740],
                [2799, 6765],
                [2828, 6791],
                [2868, 6809],
                [2872, 6845],
                [2844, 6861],
                [2849, 6882],
                [2841, 6901],
                [2841, 6951],
                [2845, 6964],
                [2897, 6953],
                [2932, 6991],
                [2927, 7034],
                [2932, 7071],
                [2941, 7087],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KS",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ks",
          "hc-a2": "KS",
          labelrank: "2",
          hasc: "ID.KS",
          "alt-name": "Kalsel",
          "woe-id": "2345721",
          subregion: null,
          fips: "ID12",
          "postal-code": "KS",
          name: "Kalimantan Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "115.451",
          "woe-name": "Kalimantan Selatan",
          latitude: "-3.00713",
          "woe-label": "South Kalimantan, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3976, 7842],
                [3960, 7864],
                [3976, 7901],
                [3983, 7893],
                [3976, 7842],
              ],
            ],
            [
              [
                [3897, 7873],
                [3912, 7910],
                [3943, 7934],
                [3944, 7892],
                [3958, 7872],
                [3948, 7868],
                [3957, 7822],
                [3959, 7779],
                [3919, 7749],
                [3902, 7750],
                [3910, 7772],
                [3906, 7800],
                [3890, 7834],
                [3897, 7873],
              ],
            ],
            [
              [
                [4003, 8132],
                [3997, 8097],
                [3945, 8094],
                [3965, 8082],
                [3959, 8064],
                [3962, 8025],
                [3955, 8002],
                [3935, 7982],
                [3912, 8024],
                [3905, 7981],
                [3917, 7982],
                [3942, 7953],
                [3919, 7944],
                [3887, 7879],
                [3879, 7843],
                [3850, 7836],
                [3833, 7820],
                [3794, 7800],
                [3677, 7747],
                [3636, 7726],
                [3600, 7702],
                [3580, 7701],
                [3580, 7736],
                [3572, 7772],
                [3572, 7811],
                [3553, 7837],
                [3554, 7886],
                [3543, 7877],
                [3541, 7853],
                [3500, 7864],
                [3532, 7963],
                [3538, 7991],
                [3566, 8006],
                [3600, 8038],
                [3607, 8067],
                [3625, 8100],
                [3622, 8135],
                [3673, 8150],
                [3716, 8191],
                [3721, 8222],
                [3715, 8253],
                [3731, 8329],
                [3788, 8348],
                [3788, 8334],
                [3765, 8312],
                [3779, 8311],
                [3807, 8253],
                [3811, 8204],
                [3830, 8195],
                [3828, 8164],
                [3844, 8127],
                [3870, 8146],
                [3882, 8143],
                [3961, 8141],
                [4003, 8132],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.NT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-nt",
          "hc-a2": "NT",
          labelrank: "2",
          hasc: "ID.NT",
          "alt-name": "NTT",
          "woe-id": "2345727",
          subregion: null,
          fips: "ID18",
          "postal-code": "NT",
          name: "Nusa Tenggara Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "120.689",
          "woe-name": "Nusa Tenggara Timur",
          latitude: "-8.584429999999999",
          "woe-label": "East Nusa Tenggara, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5295, 6340],
                [5308, 6338],
                [5307, 6320],
                [5278, 6300],
                [5239, 6308],
                [5295, 6340],
              ],
            ],
            [
              [
                [5640, 6397],
                [5626, 6394],
                [5630, 6370],
                [5613, 6368],
                [5609, 6384],
                [5627, 6410],
                [5650, 6407],
                [5640, 6397],
              ],
            ],
            [
              [
                [4770, 6731],
                [4795, 6736],
                [4778, 6723],
                [4776, 6699],
                [4755, 6705],
                [4770, 6731],
              ],
            ],
            [
              [
                [4722, 6770],
                [4746, 6765],
                [4745, 6746],
                [4731, 6751],
                [4717, 6725],
                [4724, 6711],
                [4703, 6714],
                [4702, 6748],
                [4709, 6778],
                [4722, 6770],
              ],
            ],
            [
              [
                [5565, 6806],
                [5564, 6796],
                [5528, 6788],
                [5517, 6769],
                [5500, 6770],
                [5526, 6801],
                [5565, 6806],
              ],
            ],
            [
              [
                [5591, 6849],
                [5601, 6848],
                [5600, 6818],
                [5535, 6810],
                [5534, 6828],
                [5568, 6852],
                [5591, 6849],
              ],
            ],
            [
              [
                [5809, 6823],
                [5794, 6789],
                [5768, 6786],
                [5760, 6811],
                [5734, 6805],
                [5752, 6832],
                [5768, 6840],
                [5781, 6822],
                [5814, 6870],
                [5825, 6861],
                [5824, 6838],
                [5809, 6823],
              ],
            ],
            [
              [
                [5502, 6232],
                [5495, 6264],
                [5549, 6281],
                [5574, 6299],
                [5588, 6320],
                [5624, 6346],
                [5622, 6314],
                [5631, 6290],
                [5617, 6291],
                [5593, 6276],
                [5585, 6258],
                [5535, 6245],
                [5532, 6236],
                [5502, 6232],
              ],
            ],
            [
              [
                [4848, 6429],
                [4784, 6459],
                [4778, 6471],
                [4733, 6481],
                [4717, 6471],
                [4690, 6481],
                [4665, 6481],
                [4633, 6494],
                [4611, 6518],
                [4629, 6549],
                [4661, 6562],
                [4765, 6575],
                [4808, 6568],
                [4836, 6589],
                [4851, 6574],
                [4865, 6555],
                [4905, 6541],
                [4912, 6511],
                [4959, 6512],
                [4983, 6492],
                [5004, 6458],
                [5032, 6441],
                [5041, 6412],
                [5015, 6385],
                [4983, 6379],
                [4957, 6359],
                [4943, 6370],
                [4890, 6378],
                [4862, 6402],
                [4848, 6429],
              ],
            ],
            [
              [
                [5681, 6807],
                [5677, 6815],
                [5652, 6776],
                [5641, 6787],
                [5619, 6772],
                [5601, 6783],
                [5579, 6785],
                [5608, 6812],
                [5633, 6823],
                [5634, 6833],
                [5610, 6834],
                [5620, 6845],
                [5655, 6851],
                [5644, 6830],
                [5656, 6821],
                [5672, 6857],
                [5688, 6852],
                [5708, 6868],
                [5741, 6854],
                [5703, 6838],
                [5681, 6807],
              ],
            ],
            [
              [
                [5907, 6875],
                [6006, 6879],
                [6017, 6862],
                [6014, 6834],
                [5932, 6820],
                [5905, 6820],
                [5852, 6805],
                [5832, 6817],
                [5849, 6842],
                [5846, 6861],
                [5858, 6878],
                [5885, 6883],
                [5893, 6866],
                [5907, 6875],
              ],
            ],
            [
              [
                [5705, 6436],
                [5666, 6444],
                [5682, 6473],
                [5681, 6499],
                [5690, 6537],
                [5729, 6566],
                [5758, 6599],
                [5788, 6581],
                [5805, 6594],
                [5820, 6565],
                [5832, 6568],
                [5840, 6594],
                [5858, 6612],
                [5863, 6640],
                [5889, 6642],
                [5918, 6667],
                [5970, 6692],
                [5977, 6665],
                [6008, 6687],
                [6026, 6670],
                [6022, 6641],
                [5983, 6639],
                [5979, 6628],
                [5994, 6605],
                [6004, 6571],
                [5991, 6560],
                [5984, 6530],
                [5956, 6510],
                [5931, 6474],
                [5887, 6442],
                [5859, 6412],
                [5791, 6409],
                [5772, 6385],
                [5749, 6380],
                [5724, 6364],
                [5700, 6362],
                [5667, 6369],
                [5643, 6364],
                [5648, 6390],
                [5660, 6404],
                [5706, 6425],
                [5705, 6436],
              ],
            ],
            [
              [
                [5520, 6871],
                [5530, 6828],
                [5504, 6820],
                [5503, 6798],
                [5481, 6803],
                [5492, 6777],
                [5483, 6763],
                [5428, 6748],
                [5393, 6730],
                [5325, 6731],
                [5301, 6714],
                [5253, 6694],
                [5229, 6701],
                [5220, 6688],
                [5214, 6704],
                [5162, 6712],
                [5150, 6683],
                [5110, 6688],
                [5088, 6676],
                [5055, 6679],
                [5034, 6703],
                [5019, 6692],
                [4991, 6696],
                [4980, 6706],
                [4931, 6705],
                [4900, 6698],
                [4874, 6709],
                [4839, 6698],
                [4827, 6684],
                [4800, 6713],
                [4799, 6746],
                [4813, 6770],
                [4847, 6796],
                [4866, 6795],
                [4889, 6819],
                [4927, 6824],
                [4976, 6824],
                [4975, 6835],
                [5011, 6814],
                [5063, 6814],
                [5076, 6802],
                [5136, 6784],
                [5157, 6763],
                [5178, 6764],
                [5187, 6757],
                [5209, 6771],
                [5209, 6786],
                [5225, 6779],
                [5260, 6788],
                [5273, 6784],
                [5299, 6800],
                [5307, 6780],
                [5330, 6775],
                [5365, 6754],
                [5413, 6769],
                [5411, 6792],
                [5434, 6811],
                [5470, 6820],
                [5498, 6838],
                [5514, 6857],
                [5496, 6861],
                [5466, 6850],
                [5477, 6878],
                [5493, 6888],
                [5520, 6871],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SE",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-se",
          "hc-a2": "SE",
          labelrank: "2",
          hasc: "ID.SE",
          "alt-name": "Sulsel",
          "woe-id": "2345729",
          subregion: null,
          fips: "ID38",
          "postal-code": "SE",
          name: "Sulawesi Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "119.99",
          "woe-name": "Sulawesi Selatan",
          latitude: "-3.7444",
          "woe-label": "South Sulawesi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5031, 7056],
                [5072, 7055],
                [5074, 7047],
                [5019, 7049],
                [5031, 7056],
              ],
            ],
            [
              [
                [5001, 7101],
                [5008, 7088],
                [4985, 7083],
                [4971, 7101],
                [4972, 7117],
                [5001, 7101],
              ],
            ],
            [
              [
                [5160, 8047],
                [5132, 8035],
                [5085, 8065],
                [5059, 8065],
                [5042, 8056],
                [5028, 8077],
                [5039, 8090],
                [5021, 8112],
                [4967, 8120],
                [4924, 8103],
                [4915, 8088],
                [4839, 8036],
                [4860, 7990],
                [4884, 7979],
                [4897, 7876],
                [4903, 7862],
                [4884, 7815],
                [4885, 7777],
                [4892, 7762],
                [4890, 7711],
                [4901, 7669],
                [4911, 7657],
                [4900, 7611],
                [4883, 7600],
                [4883, 7573],
                [4875, 7536],
                [4903, 7495],
                [4923, 7429],
                [4892, 7455],
                [4841, 7433],
                [4799, 7438],
                [4775, 7408],
                [4739, 7410],
                [4735, 7424],
                [4721, 7415],
                [4708, 7436],
                [4689, 7429],
                [4689, 7444],
                [4668, 7481],
                [4679, 7536],
                [4690, 7546],
                [4703, 7590],
                [4694, 7619],
                [4715, 7664],
                [4721, 7721],
                [4714, 7768],
                [4722, 7798],
                [4711, 7786],
                [4676, 7856],
                [4687, 7894],
                [4682, 7908],
                [4663, 7974],
                [4712, 7993],
                [4688, 8041],
                [4680, 8074],
                [4713, 8076],
                [4741, 8091],
                [4729, 8121],
                [4719, 8168],
                [4699, 8181],
                [4703, 8208],
                [4743, 8240],
                [4753, 8261],
                [4792, 8284],
                [4817, 8286],
                [4849, 8278],
                [4874, 8294],
                [4884, 8288],
                [4927, 8235],
                [4970, 8206],
                [5096, 8187],
                [5120, 8179],
                [5201, 8118],
                [5199, 8088],
                [5160, 8047],
              ],
            ],
            [
              [
                [4949, 7350],
                [4944, 7268],
                [4938, 7237],
                [4926, 7312],
                [4923, 7380],
                [4932, 7397],
                [4949, 7350],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kr",
          "hc-a2": "KR",
          labelrank: "2",
          hasc: "ID.KR",
          "alt-name": "Rhio|Riou|Riouw",
          "woe-id": "55949082",
          subregion: null,
          fips: "ID40",
          "postal-code": "KR",
          name: "Kepulauan Riau",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "104.601",
          "woe-name": "Kepulauan Riau",
          latitude: "-0.142639",
          "woe-label": "Kepulauan Riau, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [1238, 8433],
                [1249, 8414],
                [1232, 8383],
                [1211, 8391],
                [1197, 8370],
                [1191, 8397],
                [1172, 8411],
                [1186, 8437],
                [1200, 8430],
                [1219, 8447],
                [1238, 8433],
              ],
            ],
            [
              [
                [1222, 8576],
                [1231, 8575],
                [1265, 8541],
                [1264, 8533],
                [1228, 8562],
                [1222, 8576],
              ],
            ],
            [
              [
                [1155, 8679],
                [1143, 8689],
                [1162, 8700],
                [1167, 8682],
                [1155, 8679],
              ],
            ],
            [
              [
                [964, 8710],
                [986, 8681],
                [984, 8654],
                [965, 8660],
                [948, 8684],
                [949, 8709],
                [964, 8710],
              ],
            ],
            [
              [
                [1061, 8691],
                [1035, 8707],
                [1038, 8718],
                [1055, 8707],
                [1061, 8691],
              ],
            ],
            [
              [
                [1137, 8721],
                [1159, 8715],
                [1141, 8702],
                [1118, 8719],
                [1122, 8736],
                [1137, 8721],
              ],
            ],
            [
              [
                [1075, 8746],
                [1089, 8733],
                [1076, 8730],
                [1060, 8746],
                [1075, 8746],
              ],
            ],
            [
              [
                [967, 8742],
                [948, 8739],
                [937, 8752],
                [954, 8768],
                [967, 8742],
              ],
            ],
            [
              [
                [1129, 8779],
                [1125, 8758],
                [1107, 8742],
                [1084, 8748],
                [1072, 8765],
                [1103, 8787],
                [1129, 8779],
              ],
            ],
            [
              [
                [2184, 9221],
                [2167, 9228],
                [2184, 9255],
                [2194, 9251],
                [2184, 9221],
              ],
            ],
            [
              [
                [1482, 9216],
                [1491, 9200],
                [1464, 9194],
                [1470, 9215],
                [1461, 9234],
                [1482, 9216],
              ],
            ],
            [
              [
                [1585, 9277],
                [1596, 9267],
                [1597, 9246],
                [1579, 9255],
                [1585, 9277],
              ],
            ],
            [
              [
                [1279, 8477],
                [1235, 8461],
                [1213, 8472],
                [1228, 8521],
                [1242, 8526],
                [1278, 8497],
                [1286, 8483],
                [1304, 8495],
                [1324, 8474],
                [1343, 8465],
                [1307, 8458],
                [1279, 8477],
              ],
            ],
            [
              [
                [1148, 8769],
                [1185, 8796],
                [1230, 8797],
                [1245, 8775],
                [1246, 8734],
                [1235, 8715],
                [1208, 8719],
                [1193, 8740],
                [1199, 8764],
                [1168, 8750],
                [1152, 8752],
                [1148, 8769],
              ],
            ],
            [
              [
                [2003, 9404],
                [2036, 9432],
                [1994, 9440],
                [1975, 9474],
                [2027, 9530],
                [2047, 9495],
                [2068, 9475],
                [2072, 9448],
                [2054, 9403],
                [2022, 9395],
                [2003, 9404],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.IB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ib",
          "hc-a2": "IB",
          labelrank: "2",
          hasc: "ID.IB",
          "alt-name":
            "New Guinea|Yos Sudarso or Frederick Hendrik|Waigeo|Supiori Biak|Yapen|Misool|Salawati|Batanta",
          "woe-id": "28350157",
          subregion: null,
          fips: "ID39",
          "postal-code": "IB",
          name: "Irian Jaya Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "132.825",
          "woe-name": "Irian Jaya Barat",
          latitude: "-1.32525",
          "woe-label": "West Papua, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [7991, 7850],
                [7968, 7846],
                [7936, 7864],
                [7936, 7878],
                [7969, 7856],
                [7991, 7850],
              ],
            ],
            [
              [
                [8176, 8362],
                [8165, 8378],
                [8176, 8398],
                [8187, 8391],
                [8176, 8362],
              ],
            ],
            [
              [
                [8128, 8416],
                [8122, 8438],
                [8135, 8459],
                [8140, 8447],
                [8128, 8416],
              ],
            ],
            [
              [
                [7098, 8551],
                [7075, 8537],
                [7047, 8543],
                [7074, 8558],
                [7098, 8551],
              ],
            ],
            [
              [
                [7304, 8658],
                [7324, 8656],
                [7300, 8634],
                [7252, 8622],
                [7210, 8624],
                [7211, 8642],
                [7279, 8643],
                [7304, 8658],
              ],
            ],
            [
              [
                [7228, 8820],
                [7291, 8840],
                [7371, 8825],
                [7407, 8809],
                [7418, 8781],
                [7395, 8753],
                [7361, 8767],
                [7343, 8756],
                [7326, 8760],
                [7307, 8781],
                [7287, 8784],
                [7261, 8820],
                [7246, 8805],
                [7292, 8765],
                [7310, 8771],
                [7325, 8755],
                [7306, 8739],
                [7275, 8735],
                [7262, 8770],
                [7236, 8758],
                [7233, 8736],
                [7248, 8741],
                [7264, 8729],
                [7254, 8713],
                [7211, 8711],
                [7220, 8732],
                [7233, 8736],
                [7218, 8777],
                [7204, 8769],
                [7152, 8783],
                [7192, 8785],
                [7194, 8802],
                [7168, 8793],
                [7162, 8809],
                [7186, 8818],
                [7197, 8811],
                [7216, 8826],
                [7228, 8820],
              ],
            ],
            [
              [
                [7196, 8372],
                [7178, 8348],
                [7098, 8355],
                [7047, 8382],
                [7116, 8416],
                [7166, 8421],
                [7198, 8432],
                [7198, 8421],
                [7219, 8396],
                [7198, 8377],
                [7220, 8369],
                [7205, 8357],
                [7196, 8372],
              ],
            ],
            [
              [
                [7292, 8543],
                [7261, 8603],
                [7268, 8611],
                [7318, 8630],
                [7329, 8622],
                [7352, 8625],
                [7363, 8612],
                [7356, 8551],
                [7345, 8521],
                [7313, 8524],
                [7292, 8543],
              ],
            ],
            [
              [
                [8313, 7851],
                [8280, 7863],
                [8259, 7880],
                [8269, 7927],
                [8325, 7920],
                [8320, 7933],
                [8262, 7935],
                [8241, 7910],
                [8226, 7905],
                [8202, 7934],
                [8178, 7943],
                [8175, 7906],
                [8144, 7923],
                [8132, 7940],
                [8144, 7950],
                [8127, 7971],
                [8119, 7952],
                [8087, 7948],
                [8057, 7995],
                [8054, 7975],
                [8024, 8001],
                [8007, 8037],
                [8020, 8046],
                [8015, 8093],
                [8058, 8131],
                [8056, 8169],
                [8042, 8146],
                [8011, 8120],
                [8011, 8061],
                [7986, 8043],
                [7994, 8011],
                [7952, 7972],
                [7964, 7942],
                [7920, 7891],
                [7906, 7885],
                [7874, 7888],
                [7847, 7875],
                [7804, 7915],
                [7812, 7916],
                [7787, 7977],
                [7793, 7991],
                [7823, 7988],
                [7835, 8010],
                [7810, 8031],
                [7804, 8074],
                [7775, 8060],
                [7752, 8085],
                [7758, 8093],
                [7740, 8115],
                [7683, 8151],
                [7650, 8157],
                [7623, 8147],
                [7599, 8156],
                [7614, 8183],
                [7595, 8185],
                [7651, 8215],
                [7678, 8216],
                [7744, 8209],
                [7782, 8188],
                [7805, 8206],
                [7851, 8270],
                [7884, 8285],
                [7918, 8281],
                [7943, 8252],
                [7949, 8268],
                [7970, 8247],
                [7991, 8262],
                [8006, 8255],
                [8011, 8218],
                [8017, 8268],
                [8043, 8236],
                [8042, 8277],
                [8024, 8286],
                [8083, 8296],
                [8060, 8306],
                [8073, 8323],
                [8046, 8321],
                [8034, 8330],
                [8071, 8353],
                [8069, 8368],
                [8013, 8350],
                [7998, 8334],
                [7949, 8332],
                [7912, 8339],
                [7827, 8316],
                [7796, 8325],
                [7768, 8309],
                [7733, 8337],
                [7683, 8314],
                [7650, 8338],
                [7615, 8351],
                [7589, 8384],
                [7577, 8422],
                [7597, 8452],
                [7573, 8445],
                [7567, 8470],
                [7583, 8486],
                [7545, 8468],
                [7546, 8489],
                [7525, 8476],
                [7520, 8490],
                [7488, 8496],
                [7453, 8490],
                [7439, 8514],
                [7415, 8514],
                [7428, 8496],
                [7400, 8482],
                [7380, 8498],
                [7340, 8498],
                [7355, 8539],
                [7391, 8555],
                [7407, 8588],
                [7401, 8650],
                [7473, 8674],
                [7467, 8662],
                [7554, 8691],
                [7604, 8744],
                [7644, 8767],
                [7684, 8778],
                [7750, 8778],
                [7799, 8758],
                [7816, 8761],
                [7836, 8746],
                [7860, 8742],
                [7920, 8698],
                [8007, 8696],
                [8063, 8705],
                [8113, 8673],
                [8089, 8664],
                [8080, 8649],
                [8105, 8603],
                [8124, 8589],
                [8145, 8556],
                [8133, 8534],
                [8129, 8501],
                [8100, 8473],
                [8121, 8387],
                [8121, 8354],
                [8133, 8304],
                [8168, 8271],
                [8187, 8217],
                [8203, 8189],
                [8220, 8196],
                [8205, 8245],
                [8206, 8268],
                [8222, 8280],
                [8214, 8301],
                [8227, 8325],
                [8229, 8293],
                [8248, 8264],
                [8254, 8197],
                [8200, 8149],
                [8202, 8136],
                [8173, 8108],
                [8155, 8079],
                [8157, 8056],
                [8407, 7975],
                [8313, 7851],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SU",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-su",
          "hc-a2": "SU",
          labelrank: "2",
          hasc: "ID.SU",
          "alt-name": "Sumut",
          "woe-id": "2345735",
          subregion: null,
          fips: "ID26",
          "postal-code": "SU",
          name: "Sumatera Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "99.2161",
          "woe-name": "Sumatera Utara",
          latitude: "2.36304",
          "woe-label": "North Sumatra, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.4,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-166, 8331],
                [-180, 8312],
                [-206, 8323],
                [-196, 8367],
                [-178, 8389],
                [-163, 8365],
                [-166, 8331],
              ],
            ],
            [
              [
                [-152, 8386],
                [-155, 8362],
                [-217, 8446],
                [-191, 8447],
                [-167, 8403],
                [-152, 8386],
              ],
            ],
            [
              [
                [-142, 8492],
                [-92, 8487],
                [-90, 8474],
                [-126, 8469],
                [-161, 8471],
                [-165, 8484],
                [-142, 8492],
              ],
            ],
            [
              [
                [-187, 8838],
                [-165, 8831],
                [-202, 8834],
                [-197, 8848],
                [-187, 8838],
              ],
            ],
            [
              [
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
              ],
            ],
            [
              [
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
              ],
            ],
            [
              [
                [-20, 8517],
                [-38, 8602],
                [-48, 8601],
                [-52, 8637],
                [-66, 8649],
                [-84, 8715],
                [-118, 8782],
                [-127, 8810],
                [-114, 8845],
                [-136, 8870],
                [-152, 8863],
                [-183, 8901],
                [-205, 8913],
                [-246, 8922],
                [-287, 8956],
                [-282, 8988],
                [-309, 9046],
                [-299, 9070],
                [-304, 9101],
                [-336, 9122],
                [-344, 9163],
                [-335, 9177],
                [-353, 9203],
                [-324, 9221],
                [-344, 9245],
                [-376, 9317],
                [-327, 9373],
                [-314, 9435],
                [-285, 9448],
                [-267, 9447],
                [-266, 9430],
                [-285, 9419],
                [-286, 9405],
                [-267, 9422],
                [-256, 9399],
                [-216, 9393],
                [-168, 9364],
                [-159, 9338],
                [-138, 9321],
                [-100, 9309],
                [-47, 9282],
                [27, 9236],
                [51, 9212],
                [89, 9203],
                [114, 9173],
                [145, 9151],
                [150, 9116],
                [141, 9094],
                [164, 9100],
                [183, 9055],
                [183, 9091],
                [199, 9098],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [226, 9063],
                [220, 9016],
                [230, 8976],
                [231, 8907],
                [248, 8892],
                [266, 8843],
                [246, 8825],
                [190, 8797],
                [182, 8784],
                [202, 8753],
                [219, 8742],
                [220, 8671],
                [213, 8646],
                [131, 8667],
                [103, 8670],
                [124, 8647],
                [155, 8599],
                [154, 8584],
                [132, 8574],
                [102, 8580],
                [78, 8594],
                [22, 8570],
                [-20, 8517],
              ],
            ],
            [
              [
                [-524, 8764],
                [-483, 8766],
                [-451, 8792],
                [-424, 8783],
                [-373, 8717],
                [-349, 8709],
                [-313, 8673],
                [-321, 8654],
                [-322, 8592],
                [-334, 8573],
                [-363, 8574],
                [-387, 8632],
                [-442, 8659],
                [-443, 8675],
                [-477, 8730],
                [-524, 8764],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.RI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ri",
          "hc-a2": "RI",
          labelrank: "2",
          hasc: "ID.RI",
          "alt-name": "Rhio|Riou|Riouw",
          "woe-id": "2345728",
          subregion: null,
          fips: "ID37",
          "postal-code": "RI",
          name: "Riau",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "101.745",
          "woe-name": "Riau",
          latitude: "0.396892",
          "woe-label": "Riau, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.48,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [913, 8625],
                [903, 8630],
                [906, 8659],
                [917, 8669],
                [937, 8651],
                [935, 8631],
                [913, 8625],
              ],
            ],
            [
              [
                [873, 8745],
                [907, 8709],
                [887, 8698],
                [817, 8739],
                [784, 8731],
                [798, 8766],
                [818, 8769],
                [873, 8745],
              ],
            ],
            [
              [
                [742, 8719],
                [727, 8710],
                [712, 8718],
                [687, 8748],
                [688, 8776],
                [677, 8793],
                [680, 8819],
                [697, 8819],
                [741, 8783],
                [737, 8751],
                [742, 8719],
              ],
            ],
            [
              [
                [558, 8963],
                [572, 8938],
                [560, 8898],
                [529, 8881],
                [501, 8893],
                [484, 8930],
                [493, 8961],
                [514, 8960],
                [541, 8978],
                [558, 8963],
              ],
            ],
            [
              [
                [220, 9016],
                [226, 9063],
                [244, 9017],
                [288, 8973],
                [313, 8969],
                [358, 8940],
                [368, 8914],
                [381, 8914],
                [365, 8949],
                [344, 8977],
                [345, 8998],
                [367, 9010],
                [400, 9010],
                [405, 8993],
                [461, 8956],
                [482, 8894],
                [494, 8879],
                [532, 8869],
                [576, 8868],
                [634, 8823],
                [657, 8813],
                [665, 8781],
                [679, 8767],
                [678, 8740],
                [690, 8721],
                [744, 8676],
                [765, 8669],
                [791, 8673],
                [840, 8670],
                [883, 8633],
                [889, 8607],
                [808, 8560],
                [792, 8556],
                [778, 8536],
                [804, 8554],
                [851, 8565],
                [890, 8593],
                [910, 8600],
                [923, 8619],
                [954, 8632],
                [997, 8611],
                [1013, 8583],
                [1022, 8591],
                [1049, 8569],
                [1059, 8511],
                [1014, 8509],
                [1013, 8490],
                [992, 8484],
                [975, 8460],
                [992, 8462],
                [982, 8433],
                [989, 8429],
                [1000, 8455],
                [1025, 8459],
                [1055, 8445],
                [1055, 8435],
                [1023, 8423],
                [996, 8426],
                [1018, 8415],
                [1015, 8403],
                [980, 8391],
                [979, 8371],
                [965, 8350],
                [987, 8339],
                [910, 8329],
                [867, 8329],
                [842, 8321],
                [815, 8293],
                [784, 8250],
                [741, 8265],
                [717, 8294],
                [700, 8298],
                [660, 8290],
                [631, 8261],
                [606, 8251],
                [582, 8266],
                [548, 8272],
                [478, 8321],
                [429, 8372],
                [419, 8388],
                [385, 8404],
                [368, 8430],
                [357, 8463],
                [379, 8472],
                [376, 8522],
                [295, 8577],
                [262, 8568],
                [238, 8576],
                [212, 8620],
                [213, 8646],
                [220, 8671],
                [219, 8742],
                [202, 8753],
                [182, 8784],
                [190, 8797],
                [246, 8825],
                [266, 8843],
                [248, 8892],
                [231, 8907],
                [230, 8976],
                [220, 9016],
              ],
            ],
            [
              [
                [833, 8686],
                [794, 8685],
                [766, 8678],
                [730, 8698],
                [751, 8722],
                [746, 8759],
                [761, 8758],
                [783, 8729],
                [811, 8734],
                [872, 8699],
                [880, 8684],
                [870, 8664],
                [833, 8686],
              ],
            ],
            [
              [
                [629, 8864],
                [644, 8867],
                [683, 8856],
                [709, 8854],
                [742, 8840],
                [749, 8792],
                [731, 8796],
                [706, 8821],
                [660, 8829],
                [642, 8841],
                [629, 8864],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SW",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sw",
          "hc-a2": "SW",
          labelrank: "2",
          hasc: "ID.SW",
          "alt-name": "Sulut",
          "woe-id": "28350156",
          subregion: null,
          fips: "ID31",
          "postal-code": "SW",
          name: "Sulawesi Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "124.446",
          "woe-name": "Sulawesi Utara",
          latitude: "0.853039",
          "woe-label": "North Sulawesi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5978, 9385],
                [5963, 9404],
                [5968, 9423],
                [5983, 9418],
                [5973, 9404],
                [5978, 9385],
              ],
            ],
            [
              [
                [6013, 9593],
                [6023, 9575],
                [6014, 9565],
                [5985, 9582],
                [5988, 9605],
                [5968, 9618],
                [5967, 9640],
                [5984, 9635],
                [6013, 9593],
              ],
            ],
            [
              [
                [6292, 9664],
                [6275, 9670],
                [6269, 9688],
                [6285, 9683],
                [6292, 9664],
              ],
            ],
            [
              [
                [6258, 9678],
                [6249, 9705],
                [6235, 9731],
                [6260, 9704],
                [6258, 9678],
              ],
            ],
            [
              [
                [6254, 9783],
                [6250, 9821],
                [6255, 9847],
                [6274, 9851],
                [6289, 9840],
                [6287, 9810],
                [6303, 9791],
                [6279, 9760],
                [6281, 9732],
                [6270, 9721],
                [6247, 9729],
                [6276, 9775],
                [6254, 9783],
              ],
            ],
            [
              [
                [5462, 8959],
                [5525, 8962],
                [5571, 8951],
                [5582, 8956],
                [5633, 8946],
                [5660, 8949],
                [5673, 8964],
                [5707, 8977],
                [5743, 9000],
                [5758, 9035],
                [5806, 9040],
                [5810, 9055],
                [5795, 9058],
                [5793, 9078],
                [5809, 9092],
                [5826, 9089],
                [5862, 9112],
                [5857, 9134],
                [5901, 9170],
                [5904, 9158],
                [5936, 9157],
                [5934, 9138],
                [5955, 9116],
                [5964, 9132],
                [5960, 9100],
                [5931, 9100],
                [5908, 9041],
                [5880, 8993],
                [5862, 8984],
                [5827, 8951],
                [5822, 8932],
                [5793, 8886],
                [5796, 8879],
                [5753, 8853],
                [5694, 8839],
                [5620, 8825],
                [5594, 8813],
                [5553, 8822],
                [5561, 8849],
                [5545, 8890],
                [5499, 8916],
                [5488, 8939],
                [5462, 8959],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KU",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ku",
          "hc-a2": "KU",
          labelrank: "2",
          hasc: "ID.KU",
          "alt-name": "Kaluta",
          "woe-id": "2345723",
          subregion: null,
          fips: "ID42",
          "postal-code": "KU",
          name: "Kalimantan Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.354",
          "woe-name": "Kalimantan Utara",
          latitude: "1.28915",
          "woe-label": "North Kalimantan, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [4183, 9419],
                [4163, 9431],
                [4154, 9456],
                [4186, 9455],
                [4183, 9419],
              ],
            ],
            [
              [
                [4234, 9470],
                [4208, 9485],
                [4208, 9494],
                [4222, 9494],
                [4234, 9470],
              ],
            ],
            [
              [
                [4145, 9473],
                [4144, 9462],
                [4088, 9471],
                [4090, 9490],
                [4119, 9486],
                [4145, 9473],
              ],
            ],
            [
              [
                [4184, 9585],
                [4158, 9601],
                [4172, 9622],
                [4193, 9607],
                [4184, 9585],
              ],
            ],
            [
              [
                [4228, 9627],
                [4235, 9605],
                [4214, 9599],
                [4181, 9625],
                [4228, 9627],
              ],
            ],
            [
              [
                [3501, 8981],
                [3522, 9027],
                [3521, 9056],
                [3556, 9077],
                [3558, 9104],
                [3543, 9106],
                [3535, 9132],
                [3540, 9154],
                [3571, 9167],
                [3616, 9211],
                [3634, 9219],
                [3623, 9236],
                [3599, 9239],
                [3598, 9289],
                [3636, 9339],
                [3652, 9328],
                [3686, 9340],
                [3697, 9369],
                [3688, 9380],
                [3694, 9414],
                [3712, 9434],
                [3698, 9471],
                [3704, 9528],
                [3692, 9537],
                [3709, 9570],
                [3713, 9600],
                [3751, 9627],
                [3755, 9652],
                [3788, 9638],
                [3797, 9627],
                [3820, 9653],
                [3843, 9649],
                [3862, 9657],
                [3881, 9638],
                [3904, 9646],
                [3912, 9662],
                [3923, 9649],
                [3953, 9658],
                [3974, 9651],
                [4056, 9657],
                [4068, 9662],
                [4120, 9627],
                [4150, 9623],
                [4137, 9614],
                [4106, 9622],
                [4112, 9607],
                [4141, 9597],
                [4181, 9570],
                [4168, 9565],
                [4214, 9554],
                [4194, 9532],
                [4215, 9523],
                [4199, 9506],
                [4176, 9503],
                [4152, 9510],
                [4133, 9538],
                [4148, 9501],
                [4049, 9500],
                [4078, 9492],
                [4082, 9470],
                [4105, 9455],
                [4132, 9457],
                [4117, 9426],
                [4114, 9398],
                [4138, 9397],
                [4145, 9381],
                [4176, 9380],
                [4165, 9356],
                [4194, 9355],
                [4161, 9343],
                [4205, 9339],
                [4183, 9318],
                [4218, 9308],
                [4230, 9274],
                [4266, 9244],
                [4242, 9202],
                [4205, 9215],
                [4179, 9245],
                [4139, 9248],
                [4121, 9265],
                [4095, 9265],
                [4056, 9254],
                [4043, 9238],
                [3984, 9214],
                [3942, 9215],
                [3931, 9227],
                [3912, 9197],
                [3889, 9191],
                [3878, 9123],
                [3864, 9112],
                [3869, 9085],
                [3804, 8982],
                [3750, 8966],
                [3718, 8962],
                [3711, 8902],
                [3633, 8898],
                [3608, 8923],
                [3584, 8937],
                [3524, 8951],
                [3501, 8981],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.LA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-la",
          "hc-a2": "LA",
          labelrank: "2",
          hasc: "ID.LA",
          "alt-name": "Malut",
          "woe-id": "20069998",
          subregion: null,
          fips: "ID29",
          "postal-code": "LA",
          name: "Maluku Utara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "125.976",
          "woe-name": "Maluku Utara",
          latitude: "-2.28945",
          "woe-label": "North Maluku, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [6194, 8209],
                [6167, 8222],
                [6162, 8252],
                [6151, 8261],
                [6140, 8294],
                [6155, 8324],
                [6168, 8317],
                [6168, 8274],
                [6190, 8232],
                [6194, 8209],
              ],
            ],
            [
              [
                [6562, 8513],
                [6555, 8504],
                [6506, 8510],
                [6526, 8526],
                [6562, 8513],
              ],
            ],
            [
              [
                [6468, 8615],
                [6429, 8615],
                [6441, 8652],
                [6460, 8634],
                [6468, 8615],
              ],
            ],
            [
              [
                [6437, 8737],
                [6456, 8732],
                [6448, 8717],
                [6452, 8690],
                [6417, 8672],
                [6413, 8727],
                [6437, 8737],
              ],
            ],
            [
              [
                [6989, 8774],
                [6966, 8797],
                [6945, 8804],
                [6929, 8833],
                [6993, 8784],
                [6989, 8774],
              ],
            ],
            [
              [
                [6478, 8833],
                [6486, 8827],
                [6492, 8790],
                [6475, 8811],
                [6478, 8833],
              ],
            ],
            [
              [
                [6476, 8974],
                [6480, 8955],
                [6465, 8944],
                [6465, 8975],
                [6476, 8974],
              ],
            ],
            [
              [
                [6456, 8975],
                [6440, 8987],
                [6449, 8999],
                [6462, 8987],
                [6456, 8975],
              ],
            ],
            [
              [
                [6100, 8355],
                [6168, 8366],
                [6250, 8362],
                [6234, 8350],
                [6166, 8339],
                [6082, 8332],
                [6038, 8322],
                [6039, 8335],
                [6017, 8353],
                [6034, 8358],
                [6048, 8362],
                [6100, 8355],
              ],
            ],
            [
              [
                [5849, 8387],
                [5940, 8370],
                [5958, 8364],
                [5963, 8380],
                [5978, 8376],
                [5980, 8358],
                [6001, 8371],
                [6012, 8340],
                [5949, 8332],
                [5940, 8319],
                [5903, 8328],
                [5832, 8299],
                [5800, 8298],
                [5780, 8339],
                [5791, 8376],
                [5825, 8385],
                [5849, 8387],
              ],
            ],
            [
              [
                [6651, 8404],
                [6623, 8410],
                [6568, 8406],
                [6529, 8395],
                [6491, 8416],
                [6502, 8468],
                [6513, 8460],
                [6546, 8490],
                [6580, 8482],
                [6596, 8468],
                [6612, 8470],
                [6648, 8443],
                [6669, 8438],
                [6674, 8415],
                [6651, 8404],
              ],
            ],
            [
              [
                [6546, 8636],
                [6578, 8641],
                [6604, 8624],
                [6587, 8601],
                [6570, 8595],
                [6547, 8608],
                [6540, 8625],
                [6501, 8608],
                [6495, 8631],
                [6502, 8649],
                [6485, 8653],
                [6461, 8678],
                [6462, 8718],
                [6472, 8722],
                [6497, 8704],
                [6509, 8729],
                [6524, 8724],
                [6537, 8704],
                [6550, 8694],
                [6534, 8653],
                [6546, 8636],
              ],
            ],
            [
              [
                [6707, 9295],
                [6660, 9288],
                [6649, 9303],
                [6643, 9336],
                [6635, 9340],
                [6661, 9387],
                [6694, 9421],
                [6724, 9427],
                [6750, 9388],
                [6740, 9346],
                [6725, 9309],
                [6707, 9295],
              ],
            ],
            [
              [
                [6639, 8639],
                [6588, 8718],
                [6554, 8735],
                [6545, 8748],
                [6548, 8813],
                [6542, 8840],
                [6548, 8867],
                [6513, 8899],
                [6500, 8931],
                [6505, 8973],
                [6520, 8996],
                [6492, 9007],
                [6481, 9048],
                [6465, 9042],
                [6463, 9086],
                [6492, 9145],
                [6486, 9158],
                [6497, 9210],
                [6520, 9253],
                [6570, 9314],
                [6600, 9323],
                [6602, 9310],
                [6579, 9269],
                [6561, 9256],
                [6560, 9232],
                [6581, 9227],
                [6600, 9209],
                [6597, 9187],
                [6607, 9167],
                [6596, 9110],
                [6579, 9075],
                [6565, 9072],
                [6521, 9035],
                [6526, 9010],
                [6561, 8990],
                [6590, 9009],
                [6591, 9041],
                [6618, 9069],
                [6642, 9073],
                [6650, 9089],
                [6625, 9102],
                [6645, 9131],
                [6686, 9163],
                [6707, 9175],
                [6769, 9184],
                [6762, 9154],
                [6776, 9146],
                [6771, 9066],
                [6711, 9030],
                [6682, 9021],
                [6678, 9001],
                [6660, 8990],
                [6685, 8966],
                [6774, 8942],
                [6778, 8896],
                [6810, 8889],
                [6820, 8874],
                [6742, 8889],
                [6727, 8903],
                [6676, 8901],
                [6649, 8914],
                [6627, 8915],
                [6604, 8918],
                [6593, 8907],
                [6587, 8875],
                [6599, 8839],
                [6594, 8800],
                [6627, 8733],
                [6634, 8709],
                [6681, 8642],
                [6732, 8597],
                [6697, 8603],
                [6676, 8627],
                [6639, 8639],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sb",
          "hc-a2": "SB",
          labelrank: "2",
          hasc: "ID.SB",
          "alt-name": "Sumbar",
          "woe-id": "2345733",
          subregion: null,
          fips: "ID24",
          "postal-code": "SB",
          name: "Sumatera Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "100.611",
          "woe-name": "Sumatera Barat",
          latitude: "-0.642611",
          "woe-label": "West Sumatra, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.3,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [266, 7832],
                [251, 7817],
                [223, 7813],
                [215, 7828],
                [216, 7857],
                [206, 7877],
                [211, 7893],
                [264, 7851],
                [266, 7832],
              ],
            ],
            [
              [
                [141, 7972],
                [180, 7921],
                [119, 7938],
                [100, 7963],
                [113, 7996],
                [137, 7985],
                [141, 7972],
              ],
            ],
            [
              [
                [522, 7955],
                [485, 7937],
                [453, 7909],
                [427, 7941],
                [403, 7984],
                [414, 8009],
                [405, 8042],
                [387, 8059],
                [352, 8108],
                [348, 8128],
                [333, 8142],
                [331, 8168],
                [292, 8181],
                [296, 8198],
                [282, 8204],
                [291, 8233],
                [283, 8235],
                [262, 8283],
                [227, 8316],
                [187, 8363],
                [142, 8398],
                [127, 8426],
                [123, 8458],
                [89, 8486],
                [41, 8499],
                [19, 8516],
                [2, 8509],
                [-20, 8517],
                [22, 8570],
                [78, 8594],
                [102, 8580],
                [132, 8574],
                [154, 8584],
                [155, 8599],
                [124, 8647],
                [103, 8670],
                [131, 8667],
                [213, 8646],
                [212, 8620],
                [238, 8576],
                [262, 8568],
                [295, 8577],
                [376, 8522],
                [379, 8472],
                [357, 8463],
                [368, 8430],
                [385, 8404],
                [419, 8388],
                [429, 8372],
                [478, 8321],
                [548, 8272],
                [582, 8266],
                [606, 8251],
                [610, 8230],
                [624, 8222],
                [614, 8205],
                [588, 8192],
                [590, 8144],
                [540, 8091],
                [489, 8085],
                [462, 8089],
                [472, 8040],
                [501, 8004],
                [522, 7955],
              ],
            ],
            [
              [
                [265, 7784],
                [261, 7817],
                [271, 7830],
                [331, 7777],
                [331, 7765],
                [332, 7750],
                [313, 7744],
                [338, 7708],
                [314, 7717],
                [304, 7750],
                [265, 7784],
              ],
            ],
            [
              [
                [-68, 8242],
                [-59, 8236],
                [-62, 8224],
                [-20, 8166],
                [-3, 8121],
                [32, 8087],
                [31, 8048],
                [-5, 8039],
                [-57, 8064],
                [-76, 8098],
                [-132, 8172],
                [-122, 8197],
                [-120, 8228],
                [-68, 8242],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.MA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ma",
          "hc-a2": "MA",
          labelrank: "2",
          hasc: "ID.MA",
          "alt-name": "Molucas||Moluccas|Molucche|Moluckerna|Moluqu",
          "woe-id": "20069997",
          subregion: null,
          fips: "ID28",
          "postal-code": "MA",
          name: "Maluku",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "128.161",
          "woe-name": "Maluku",
          latitude: "-8.248139999999999",
          "woe-label": "Maluku, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [6734, 6879],
                [6731, 6862],
                [6706, 6864],
                [6706, 6878],
                [6734, 6879],
              ],
            ],
            [
              [
                [6925, 6879],
                [6897, 6870],
                [6877, 6883],
                [6913, 6887],
                [6925, 6879],
              ],
            ],
            [
              [
                [6609, 6871],
                [6589, 6878],
                [6608, 6890],
                [6628, 6877],
                [6609, 6871],
              ],
            ],
            [
              [
                [6642, 6904],
                [6709, 6886],
                [6692, 6868],
                [6635, 6886],
                [6629, 6903],
                [6642, 6904],
              ],
            ],
            [
              [
                [7407, 6901],
                [7427, 6899],
                [7387, 6879],
                [7364, 6875],
                [7360, 6861],
                [7333, 6851],
                [7354, 6877],
                [7398, 6915],
                [7407, 6901],
              ],
            ],
            [
              [
                [7096, 6977],
                [7114, 6972],
                [7118, 6949],
                [7099, 6920],
                [7079, 6923],
                [7056, 6950],
                [7064, 6981],
                [7096, 6977],
              ],
            ],
            [
              [
                [7420, 7025],
                [7414, 7011],
                [7381, 7006],
                [7388, 7016],
                [7420, 7025],
              ],
            ],
            [
              [
                [6537, 7008],
                [6533, 7041],
                [6559, 7036],
                [6560, 7025],
                [6537, 7008],
              ],
            ],
            [
              [
                [7431, 7074],
                [7409, 7055],
                [7389, 7057],
                [7394, 7075],
                [7431, 7074],
              ],
            ],
            [
              [
                [7606, 7151],
                [7620, 7134],
                [7618, 7115],
                [7597, 7136],
                [7571, 7136],
                [7568, 7149],
                [7606, 7151],
              ],
            ],
            [
              [
                [6837, 7123],
                [6828, 7113],
                [6803, 7129],
                [6823, 7150],
                [6842, 7140],
                [6837, 7123],
              ],
            ],
            [
              [
                [8273, 7239],
                [8259, 7241],
                [8275, 7279],
                [8286, 7276],
                [8273, 7239],
              ],
            ],
            [
              [
                [8285, 7291],
                [8268, 7287],
                [8259, 7305],
                [8283, 7305],
                [8285, 7291],
              ],
            ],
            [
              [
                [8255, 7321],
                [8232, 7298],
                [8220, 7320],
                [8195, 7331],
                [8217, 7353],
                [8255, 7321],
              ],
            ],
            [
              [
                [8312, 7312],
                [8301, 7326],
                [8312, 7354],
                [8323, 7342],
                [8312, 7312],
              ],
            ],
            [
              [
                [8144, 7421],
                [8161, 7416],
                [8164, 7391],
                [8188, 7366],
                [8210, 7355],
                [8189, 7342],
                [8141, 7384],
                [8144, 7421],
              ],
            ],
            [
              [
                [7791, 7511],
                [7816, 7452],
                [7801, 7430],
                [7784, 7442],
                [7784, 7488],
                [7770, 7514],
                [7791, 7511],
              ],
            ],
            [
              [
                [7811, 7526],
                [7817, 7498],
                [7805, 7496],
                [7802, 7521],
                [7811, 7526],
              ],
            ],
            [
              [
                [6480, 7882],
                [6464, 7881],
                [6455, 7896],
                [6478, 7903],
                [6480, 7882],
              ],
            ],
            [
              [
                [6758, 7958],
                [6752, 7978],
                [6780, 7981],
                [6789, 7967],
                [6758, 7958],
              ],
            ],
            [
              [
                [6812, 7982],
                [6822, 7990],
                [6828, 7963],
                [6814, 7974],
                [6804, 7962],
                [6790, 7982],
                [6812, 7982],
              ],
            ],
            [
              [
                [6543, 8038],
                [6555, 8035],
                [6566, 8014],
                [6531, 8028],
                [6543, 8038],
              ],
            ],
            [
              [
                [6601, 8042],
                [6569, 8046],
                [6583, 8062],
                [6596, 8064],
                [6601, 8042],
              ],
            ],
            [
              [
                [6647, 8114],
                [6639, 8097],
                [6613, 8092],
                [6616, 8103],
                [6647, 8114],
              ],
            ],
            [
              [
                [6723, 7986],
                [6732, 7970],
                [6735, 7957],
                [6716, 7959],
                [6722, 7946],
                [6695, 7929],
                [6704, 7953],
                [6654, 7920],
                [6636, 7936],
                [6664, 7964],
                [6693, 7966],
                [6723, 7986],
              ],
            ],
            [
              [
                [6359, 7026],
                [6382, 7001],
                [6400, 7002],
                [6409, 6985],
                [6380, 6982],
                [6344, 6965],
                [6323, 6930],
                [6313, 6938],
                [6259, 6939],
                [6232, 6948],
                [6198, 6940],
                [6172, 6918],
                [6163, 6921],
                [6170, 6951],
                [6184, 6963],
                [6202, 6995],
                [6261, 6988],
                [6290, 6993],
                [6330, 7018],
                [6359, 7026],
              ],
            ],
            [
              [
                [7513, 7134],
                [7539, 7149],
                [7543, 7135],
                [7555, 7144],
                [7564, 7128],
                [7541, 7114],
                [7554, 7076],
                [7541, 7032],
                [7521, 7006],
                [7481, 6972],
                [7464, 6931],
                [7456, 6950],
                [7443, 6934],
                [7416, 6935],
                [7409, 6965],
                [7427, 6980],
                [7421, 7010],
                [7437, 7004],
                [7434, 7031],
                [7448, 7061],
                [7472, 7070],
                [7482, 7092],
                [7513, 7134],
              ],
            ],
            [
              [
                [8184, 7214],
                [8153, 7199],
                [8121, 7234],
                [8133, 7307],
                [8153, 7304],
                [8137, 7320],
                [8131, 7368],
                [8140, 7379],
                [8179, 7350],
                [8177, 7340],
                [8214, 7315],
                [8235, 7280],
                [8184, 7214],
              ],
            ],
            [
              [
                [8191, 7493],
                [8216, 7537],
                [8228, 7534],
                [8224, 7558],
                [8246, 7564],
                [8275, 7538],
                [8262, 7527],
                [8290, 7504],
                [8277, 7464],
                [8293, 7451],
                [8259, 7440],
                [8295, 7402],
                [8278, 7345],
                [8255, 7334],
                [8188, 7369],
                [8178, 7385],
                [8176, 7441],
                [8194, 7460],
                [8194, 7477],
                [8156, 7489],
                [8168, 7501],
                [8191, 7493],
              ],
            ],
            [
              [
                [7863, 7504],
                [7888, 7586],
                [7906, 7587],
                [7890, 7517],
                [7874, 7504],
                [7857, 7485],
                [7851, 7449],
                [7825, 7422],
                [7845, 7492],
                [7863, 7504],
              ],
            ],
            [
              [
                [6181, 8026],
                [6203, 8058],
                [6226, 8043],
                [6252, 8062],
                [6280, 8071],
                [6350, 8076],
                [6387, 8066],
                [6439, 8047],
                [6444, 8030],
                [6428, 8029],
                [6433, 8015],
                [6456, 8015],
                [6482, 8005],
                [6478, 7953],
                [6470, 7940],
                [6450, 7941],
                [6409, 7913],
                [6362, 7890],
                [6326, 7898],
                [6227, 7945],
                [6221, 7962],
                [6197, 7980],
                [6181, 8026],
              ],
            ],
            [
              [
                [7031, 8162],
                [7083, 8137],
                [7136, 8121],
                [7207, 8127],
                [7243, 8102],
                [7264, 8095],
                [7276, 8074],
                [7288, 8029],
                [7311, 8029],
                [7339, 7990],
                [7330, 7961],
                [7333, 7920],
                [7276, 7939],
                [7230, 7971],
                [7160, 7994],
                [7125, 8010],
                [7119, 8028],
                [7102, 8039],
                [7019, 8045],
                [7009, 8036],
                [7025, 8011],
                [7007, 8005],
                [6976, 8017],
                [6947, 8018],
                [6917, 8029],
                [6881, 8026],
                [6885, 8051],
                [6860, 8062],
                [6818, 8026],
                [6815, 8006],
                [6769, 7997],
                [6749, 8009],
                [6719, 8052],
                [6695, 8058],
                [6699, 8077],
                [6684, 8085],
                [6668, 8056],
                [6667, 8032],
                [6651, 8013],
                [6638, 7971],
                [6631, 7978],
                [6639, 8010],
                [6634, 8029],
                [6615, 8060],
                [6653, 8084],
                [6676, 8087],
                [6679, 8116],
                [6691, 8137],
                [6740, 8138],
                [6771, 8145],
                [6792, 8141],
                [6854, 8142],
                [6898, 8157],
                [6902, 8136],
                [6916, 8122],
                [6971, 8148],
                [6991, 8165],
                [7031, 8162],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.NB",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-nb",
          "hc-a2": "NB",
          labelrank: "2",
          hasc: "ID.NB",
          "alt-name": "NTB",
          "woe-id": "2345726",
          subregion: null,
          fips: "ID17",
          "postal-code": "NB",
          name: "Nusa Tenggara Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.294",
          "woe-name": "Nusa Tenggara Barat",
          latitude: "-8.571059999999999",
          "woe-label": "West Nusa Tenggara, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [4287, 6777],
                [4271, 6785],
                [4272, 6823],
                [4310, 6831],
                [4287, 6777],
              ],
            ],
            [
              [
                [4636, 6819],
                [4619, 6823],
                [4622, 6842],
                [4643, 6839],
                [4636, 6819],
              ],
            ],
            [
              [
                [4019, 6806],
                [4078, 6792],
                [4104, 6767],
                [4092, 6729],
                [4053, 6671],
                [4069, 6651],
                [4039, 6646],
                [4047, 6663],
                [4031, 6658],
                [4033, 6636],
                [4017, 6647],
                [3988, 6642],
                [3975, 6651],
                [3942, 6645],
                [3902, 6667],
                [3953, 6687],
                [3955, 6718],
                [3943, 6748],
                [3959, 6757],
                [3996, 6795],
                [4019, 6806],
              ],
            ],
            [
              [
                [4348, 6785],
                [4320, 6812],
                [4325, 6829],
                [4362, 6846],
                [4412, 6842],
                [4443, 6795],
                [4457, 6786],
                [4487, 6812],
                [4534, 6807],
                [4546, 6789],
                [4538, 6753],
                [4553, 6771],
                [4553, 6794],
                [4571, 6807],
                [4611, 6805],
                [4627, 6769],
                [4626, 6733],
                [4663, 6738],
                [4649, 6707],
                [4616, 6704],
                [4594, 6718],
                [4564, 6712],
                [4560, 6697],
                [4601, 6694],
                [4606, 6684],
                [4580, 6681],
                [4563, 6691],
                [4497, 6674],
                [4479, 6690],
                [4489, 6710],
                [4480, 6717],
                [4428, 6671],
                [4410, 6676],
                [4368, 6653],
                [4333, 6658],
                [4294, 6636],
                [4244, 6621],
                [4207, 6625],
                [4197, 6612],
                [4171, 6607],
                [4114, 6625],
                [4107, 6657],
                [4125, 6678],
                [4108, 6705],
                [4127, 6741],
                [4160, 6745],
                [4206, 6779],
                [4261, 6753],
                [4263, 6769],
                [4288, 6771],
                [4297, 6747],
                [4305, 6760],
                [4310, 6739],
                [4329, 6736],
                [4347, 6702],
                [4365, 6707],
                [4384, 6697],
                [4406, 6719],
                [4454, 6724],
                [4419, 6758],
                [4390, 6760],
                [4348, 6785],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SG",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sg",
          "hc-a2": "SG",
          labelrank: "2",
          hasc: "ID.SG",
          "alt-name": "Sultra",
          "woe-id": "2345731",
          subregion: null,
          fips: "ID22",
          "postal-code": "SG",
          name: "Sulawesi Tenggara",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "122.119",
          "woe-name": "Sulawesi Tenggara",
          latitude: "-4.0746",
          "woe-label": "South East Sulawesi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5757, 7370],
                [5750, 7367],
                [5732, 7391],
                [5749, 7392],
                [5757, 7370],
              ],
            ],
            [
              [
                [5651, 7515],
                [5634, 7518],
                [5629, 7543],
                [5648, 7538],
                [5651, 7515],
              ],
            ],
            [
              [
                [5254, 7564],
                [5265, 7570],
                [5288, 7543],
                [5287, 7487],
                [5268, 7479],
                [5248, 7496],
                [5229, 7525],
                [5239, 7561],
                [5254, 7564],
              ],
            ],
            [
              [
                [5512, 7825],
                [5540, 7828],
                [5553, 7806],
                [5534, 7775],
                [5515, 7771],
                [5489, 7795],
                [5482, 7813],
                [5499, 7831],
                [5512, 7825],
              ],
            ],
            [
              [
                [5042, 8056],
                [5059, 8065],
                [5085, 8065],
                [5132, 8035],
                [5160, 8047],
                [5202, 8046],
                [5267, 8024],
                [5302, 8021],
                [5334, 7994],
                [5324, 7976],
                [5343, 7963],
                [5315, 7961],
                [5325, 7944],
                [5305, 7919],
                [5317, 7897],
                [5342, 7881],
                [5362, 7881],
                [5383, 7851],
                [5416, 7840],
                [5390, 7826],
                [5414, 7820],
                [5419, 7793],
                [5458, 7794],
                [5442, 7811],
                [5458, 7810],
                [5474, 7779],
                [5474, 7734],
                [5461, 7722],
                [5420, 7749],
                [5444, 7713],
                [5404, 7730],
                [5381, 7720],
                [5366, 7724],
                [5292, 7697],
                [5279, 7654],
                [5300, 7633],
                [5268, 7619],
                [5229, 7627],
                [5202, 7621],
                [5167, 7641],
                [5150, 7660],
                [5158, 7758],
                [5169, 7757],
                [5178, 7792],
                [5160, 7806],
                [5114, 7817],
                [5092, 7846],
                [5068, 7854],
                [5004, 7910],
                [4997, 7931],
                [5021, 7973],
                [5040, 7991],
                [5035, 8020],
                [5042, 8056],
              ],
            ],
            [
              [
                [5438, 7674],
                [5450, 7604],
                [5420, 7574],
                [5411, 7539],
                [5425, 7518],
                [5414, 7496],
                [5400, 7492],
                [5392, 7525],
                [5383, 7499],
                [5368, 7509],
                [5339, 7504],
                [5351, 7564],
                [5365, 7575],
                [5346, 7627],
                [5363, 7650],
                [5384, 7653],
                [5420, 7678],
                [5438, 7674],
              ],
            ],
            [
              [
                [5458, 7540],
                [5447, 7555],
                [5457, 7583],
                [5467, 7635],
                [5464, 7674],
                [5476, 7715],
                [5501, 7735],
                [5542, 7696],
                [5548, 7671],
                [5551, 7639],
                [5528, 7662],
                [5512, 7655],
                [5505, 7611],
                [5494, 7596],
                [5499, 7574],
                [5491, 7555],
                [5508, 7562],
                [5548, 7539],
                [5554, 7527],
                [5539, 7507],
                [5520, 7499],
                [5500, 7504],
                [5477, 7488],
                [5487, 7473],
                [5468, 7438],
                [5446, 7448],
                [5424, 7439],
                [5406, 7475],
                [5442, 7534],
                [5458, 7540],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.ST",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-st",
          "hc-a2": "ST",
          labelrank: "2",
          hasc: "ID.ST",
          "alt-name": "Sulteng",
          "woe-id": "2345730",
          subregion: null,
          fips: "ID21",
          "postal-code": "ST",
          name: "Sulawesi Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "120.153",
          "woe-name": "Sulawesi Tengah",
          latitude: "-1.30097",
          "woe-label": "Central Sulawesi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [5675, 8292],
                [5657, 8295],
                [5655, 8322],
                [5669, 8310],
                [5675, 8292],
              ],
            ],
            [
              [
                [5495, 8310],
                [5488, 8310],
                [5495, 8344],
                [5507, 8327],
                [5495, 8310],
              ],
            ],
            [
              [
                [5601, 8383],
                [5612, 8378],
                [5604, 8355],
                [5583, 8359],
                [5579, 8390],
                [5589, 8409],
                [5601, 8383],
              ],
            ],
            [
              [
                [5191, 8639],
                [5206, 8624],
                [5198, 8614],
                [5152, 8621],
                [5191, 8639],
              ],
            ],
            [
              [
                [5238, 8658],
                [5241, 8672],
                [5253, 8644],
                [5209, 8636],
                [5196, 8640],
                [5207, 8660],
                [5238, 8658],
              ],
            ],
            [
              [
                [4670, 8513],
                [4696, 8536],
                [4689, 8543],
                [4706, 8561],
                [4735, 8507],
                [4735, 8543],
                [4719, 8567],
                [4710, 8598],
                [4713, 8681],
                [4699, 8677],
                [4677, 8692],
                [4685, 8711],
                [4721, 8686],
                [4733, 8723],
                [4708, 8760],
                [4726, 8772],
                [4722, 8784],
                [4734, 8815],
                [4761, 8826],
                [4757, 8861],
                [4765, 8878],
                [4804, 8901],
                [4812, 8938],
                [4826, 8937],
                [4829, 8908],
                [4881, 8894],
                [4906, 8944],
                [4916, 8941],
                [4931, 8962],
                [4932, 9017],
                [4952, 9028],
                [5010, 9020],
                [5035, 9005],
                [5077, 9023],
                [5073, 9007],
                [5086, 8983],
                [5122, 8971],
                [5189, 8983],
                [5200, 8968],
                [5227, 8977],
                [5253, 8970],
                [5207, 8947],
                [5171, 8953],
                [5096, 8920],
                [5066, 8922],
                [5049, 8913],
                [5035, 8889],
                [5018, 8879],
                [5041, 8857],
                [5059, 8856],
                [5061, 8830],
                [5022, 8827],
                [5012, 8816],
                [4981, 8822],
                [4960, 8816],
                [4909, 8838],
                [4869, 8835],
                [4840, 8822],
                [4818, 8798],
                [4787, 8751],
                [4779, 8711],
                [4766, 8692],
                [4761, 8660],
                [4788, 8559],
                [4826, 8509],
                [4845, 8498],
                [4865, 8507],
                [4886, 8492],
                [4906, 8463],
                [4904, 8438],
                [4931, 8398],
                [4966, 8412],
                [4980, 8400],
                [5003, 8404],
                [5023, 8396],
                [5043, 8420],
                [5049, 8448],
                [5064, 8461],
                [5115, 8530],
                [5151, 8542],
                [5165, 8515],
                [5214, 8513],
                [5255, 8521],
                [5265, 8551],
                [5277, 8559],
                [5370, 8567],
                [5395, 8559],
                [5440, 8568],
                [5450, 8576],
                [5408, 8584],
                [5397, 8592],
                [5417, 8602],
                [5464, 8607],
                [5475, 8617],
                [5513, 8616],
                [5552, 8601],
                [5565, 8575],
                [5551, 8518],
                [5535, 8506],
                [5497, 8531],
                [5483, 8554],
                [5475, 8543],
                [5418, 8530],
                [5399, 8486],
                [5383, 8474],
                [5346, 8421],
                [5322, 8394],
                [5281, 8364],
                [5243, 8362],
                [5193, 8336],
                [5171, 8292],
                [5136, 8286],
                [5112, 8311],
                [5082, 8316],
                [5090, 8300],
                [5091, 8269],
                [5104, 8288],
                [5136, 8255],
                [5146, 8232],
                [5176, 8229],
                [5205, 8206],
                [5220, 8178],
                [5253, 8133],
                [5253, 8115],
                [5292, 8091],
                [5296, 8077],
                [5324, 8065],
                [5318, 8038],
                [5362, 8009],
                [5355, 7993],
                [5334, 7994],
                [5302, 8021],
                [5267, 8024],
                [5202, 8046],
                [5160, 8047],
                [5199, 8088],
                [5201, 8118],
                [5120, 8179],
                [5096, 8187],
                [4970, 8206],
                [4927, 8235],
                [4884, 8288],
                [4874, 8294],
                [4849, 8278],
                [4817, 8286],
                [4792, 8284],
                [4753, 8261],
                [4741, 8279],
                [4745, 8298],
                [4715, 8337],
                [4706, 8372],
                [4694, 8386],
                [4659, 8399],
                [4657, 8409],
                [4682, 8441],
                [4674, 8463],
                [4670, 8513],
              ],
            ],
            [
              [
                [5428, 8450],
                [5441, 8471],
                [5458, 8470],
                [5511, 8481],
                [5522, 8466],
                [5512, 8458],
                [5521, 8426],
                [5559, 8469],
                [5591, 8458],
                [5590, 8421],
                [5575, 8406],
                [5552, 8401],
                [5543, 8421],
                [5528, 8410],
                [5528, 8374],
                [5511, 8373],
                [5495, 8388],
                [5511, 8405],
                [5504, 8445],
                [5488, 8436],
                [5467, 8397],
                [5440, 8379],
                [5424, 8410],
                [5428, 8450],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.PA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-pa",
          "hc-a2": "PA",
          labelrank: "2",
          hasc: "ID.PA",
          "alt-name":
            "New Guinea|Yos Sudarso or Frederick Hendrik|Waigeo|Supiori Biak|Yapen|Misool|Salawati|Batanta",
          "woe-id": "2345718",
          subregion: null,
          fips: "ID36",
          "postal-code": "PA",
          name: "Papua",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "138.689",
          "woe-name": "Papua",
          latitude: "-4.10825",
          "woe-label": "Papua, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.65,
          "hc-middle-y": 0.4,
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [9317, 6836],
                [9314, 6822],
                [9230, 6834],
                [9231, 6849],
                [9263, 6880],
                [9299, 6878],
                [9301, 6855],
                [9317, 6836],
              ],
            ],
            [
              [
                [9282, 7212],
                [9266, 7216],
                [9252, 7248],
                [9282, 7236],
                [9282, 7212],
              ],
            ],
            [
              [
                [8354, 8534],
                [8405, 8534],
                [8391, 8524],
                [8349, 8523],
                [8354, 8534],
              ],
            ],
            [
              [
                [8301, 8631],
                [8317, 8645],
                [8308, 8617],
                [8282, 8621],
                [8269, 8640],
                [8287, 8663],
                [8307, 8649],
                [8301, 8631],
              ],
            ],
            [
              [
                [9100, 7025],
                [9154, 7063],
                [9192, 7076],
                [9249, 7086],
                [9295, 7083],
                [9329, 7040],
                [9363, 7031],
                [9340, 6990],
                [9339, 6967],
                [9313, 6942],
                [9315, 6914],
                [9278, 6887],
                [9256, 6883],
                [9241, 6862],
                [9201, 6831],
                [9163, 6822],
                [9134, 6831],
                [9053, 6834],
                [9000, 6823],
                [9000, 6832],
                [9031, 6910],
                [9042, 6918],
                [9066, 6974],
                [9100, 7025],
              ],
            ],
            [
              [
                [8642, 8439],
                [8502, 8484],
                [8444, 8489],
                [8428, 8504],
                [8442, 8510],
                [8546, 8499],
                [8619, 8501],
                [8669, 8485],
                [8748, 8487],
                [8784, 8480],
                [8791, 8467],
                [8755, 8463],
                [8734, 8450],
                [8687, 8444],
                [8658, 8451],
                [8642, 8439],
              ],
            ],
            [
              [
                [8412, 8722],
                [8418, 8739],
                [8463, 8731],
                [8481, 8734],
                [8507, 8720],
                [8524, 8734],
                [8580, 8693],
                [8614, 8646],
                [8639, 8650],
                [8659, 8641],
                [8640, 8618],
                [8603, 8607],
                [8565, 8619],
                [8544, 8613],
                [8523, 8632],
                [8509, 8689],
                [8499, 8702],
                [8479, 8684],
                [8434, 8714],
                [8412, 8722],
              ],
            ],
            [
              [
                [8254, 8197],
                [8262, 8167],
                [8280, 8163],
                [8299, 8183],
                [8292, 8125],
                [8308, 8099],
                [8329, 8101],
                [8335, 8079],
                [8418, 8067],
                [8455, 8074],
                [8495, 8120],
                [8526, 8138],
                [8521, 8146],
                [8561, 8170],
                [8573, 8222],
                [8599, 8248],
                [8646, 8278],
                [8677, 8363],
                [8766, 8359],
                [8831, 8394],
                [8881, 8406],
                [8875, 8437],
                [8849, 8452],
                [8858, 8477],
                [8909, 8498],
                [8954, 8528],
                [9019, 8559],
                [9051, 8560],
                [9091, 8530],
                [9163, 8508],
                [9242, 8491],
                [9278, 8459],
                [9356, 8439],
                [9402, 8412],
                [9553, 8354],
                [9630, 8368],
                [9642, 8349],
                [9673, 8336],
                [9687, 8351],
                [9744, 8342],
                [9780, 8328],
                [9769, 8300],
                [9840, 8304],
                [9844, 8136],
                [9851, 7686],
                [9851, 7342],
                [9844, 7305],
                [9820, 7272],
                [9817, 7248],
                [9834, 7207],
                [9849, 7198],
                [9836, 6630],
                [9806, 6646],
                [9748, 6709],
                [9720, 6753],
                [9657, 6814],
                [9602, 6856],
                [9587, 6883],
                [9605, 6908],
                [9577, 6892],
                [9501, 6889],
                [9471, 6876],
                [9431, 6872],
                [9413, 6879],
                [9398, 6904],
                [9364, 6890],
                [9319, 6851],
                [9301, 6890],
                [9322, 6904],
                [9320, 6944],
                [9341, 6958],
                [9345, 6986],
                [9367, 7035],
                [9333, 7049],
                [9316, 7086],
                [9266, 7129],
                [9321, 7126],
                [9346, 7116],
                [9384, 7115],
                [9337, 7135],
                [9285, 7148],
                [9238, 7192],
                [9240, 7205],
                [9280, 7203],
                [9328, 7216],
                [9377, 7184],
                [9346, 7214],
                [9301, 7226],
                [9263, 7254],
                [9273, 7271],
                [9212, 7328],
                [9193, 7370],
                [9186, 7406],
                [9162, 7458],
                [9189, 7465],
                [9147, 7473],
                [9134, 7486],
                [9185, 7510],
                [9153, 7508],
                [9112, 7497],
                [9113, 7575],
                [9090, 7562],
                [9072, 7582],
                [9075, 7597],
                [9049, 7588],
                [9020, 7623],
                [8988, 7633],
                [8959, 7654],
                [8944, 7654],
                [8913, 7693],
                [8897, 7674],
                [8831, 7696],
                [8829, 7707],
                [8798, 7694],
                [8681, 7754],
                [8659, 7754],
                [8601, 7776],
                [8585, 7792],
                [8524, 7797],
                [8451, 7811],
                [8401, 7803],
                [8334, 7836],
                [8313, 7851],
                [8407, 7975],
                [8157, 8056],
                [8155, 8079],
                [8173, 8108],
                [8202, 8136],
                [8200, 8149],
                [8254, 8197],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jr",
          "hc-a2": "JR",
          labelrank: "2",
          hasc: "ID.JR",
          "alt-name": "Jabar",
          "woe-id": "2345715",
          subregion: null,
          fips: "ID30",
          "postal-code": "JR",
          name: "Jawa Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "107.638",
          "woe-name": "Jawa Barat",
          latitude: "-6.90763",
          "woe-label": "West Java, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1753, 6957],
              [1761, 6993],
              [1773, 7006],
              [1753, 7024],
              [1746, 7063],
              [1747, 7098],
              [1756, 7106],
              [1795, 7098],
              [1826, 7103],
              [1824, 7119],
              [1862, 7103],
              [1873, 7137],
              [1872, 7173],
              [1882, 7211],
              [1907, 7199],
              [1953, 7201],
              [1982, 7165],
              [2017, 7157],
              [2031, 7146],
              [2060, 7159],
              [2126, 7132],
              [2150, 7145],
              [2149, 7156],
              [2185, 7154],
              [2189, 7133],
              [2210, 7111],
              [2229, 7102],
              [2248, 7041],
              [2281, 7031],
              [2314, 7033],
              [2295, 7004],
              [2294, 6975],
              [2274, 6956],
              [2247, 6949],
              [2244, 6916],
              [2270, 6910],
              [2290, 6867],
              [2289, 6852],
              [2304, 6839],
              [2285, 6837],
              [2276, 6824],
              [2246, 6829],
              [2228, 6799],
              [2200, 6798],
              [2114, 6810],
              [2094, 6807],
              [2080, 6820],
              [2053, 6824],
              [2030, 6843],
              [1988, 6857],
              [1943, 6857],
              [1919, 6862],
              [1786, 6864],
              [1757, 6869],
              [1751, 6899],
              [1784, 6945],
              [1783, 6961],
              [1763, 6966],
              [1753, 6957],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KI",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ki",
          "hc-a2": "KI",
          labelrank: "2",
          hasc: "ID.KI",
          "alt-name": "Kaltim",
          "woe-id": "2345723",
          subregion: null,
          fips: "ID14",
          "postal-code": "KI",
          name: "Kalimantan Timur",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "116.354",
          "woe-name": "Kalimantan Timur",
          latitude: "1.28915",
          "woe-label": "East Kalimantan, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.3,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [3420, 8964],
              [3462, 8981],
              [3487, 8967],
              [3501, 8981],
              [3524, 8951],
              [3584, 8937],
              [3608, 8923],
              [3633, 8898],
              [3711, 8902],
              [3718, 8962],
              [3750, 8966],
              [3804, 8982],
              [3869, 9085],
              [3864, 9112],
              [3878, 9123],
              [3889, 9191],
              [3912, 9197],
              [3931, 9227],
              [3942, 9215],
              [3984, 9214],
              [4043, 9238],
              [4056, 9254],
              [4095, 9265],
              [4121, 9265],
              [4139, 9248],
              [4179, 9245],
              [4205, 9215],
              [4242, 9202],
              [4266, 9244],
              [4295, 9199],
              [4262, 9175],
              [4254, 9148],
              [4217, 9145],
              [4248, 9134],
              [4247, 9111],
              [4262, 9096],
              [4290, 9090],
              [4310, 9061],
              [4381, 9027],
              [4375, 9019],
              [4426, 8999],
              [4453, 8978],
              [4485, 8935],
              [4519, 8932],
              [4520, 8915],
              [4475, 8877],
              [4448, 8885],
              [4421, 8874],
              [4390, 8880],
              [4380, 8872],
              [4364, 8883],
              [4334, 8885],
              [4306, 8896],
              [4286, 8929],
              [4266, 8928],
              [4298, 8880],
              [4291, 8863],
              [4272, 8874],
              [4249, 8866],
              [4231, 8843],
              [4231, 8829],
              [4209, 8794],
              [4179, 8703],
              [4195, 8671],
              [4185, 8657],
              [4176, 8618],
              [4190, 8590],
              [4180, 8558],
              [4214, 8583],
              [4216, 8561],
              [4205, 8521],
              [4223, 8501],
              [4170, 8486],
              [4161, 8472],
              [4147, 8492],
              [4141, 8469],
              [4122, 8452],
              [4093, 8400],
              [4047, 8384],
              [4038, 8407],
              [4022, 8414],
              [4040, 8388],
              [4035, 8360],
              [4001, 8346],
              [3985, 8331],
              [3991, 8303],
              [3939, 8278],
              [3917, 8258],
              [3952, 8265],
              [3968, 8259],
              [3961, 8247],
              [3974, 8234],
              [3974, 8208],
              [3936, 8172],
              [3955, 8180],
              [3964, 8166],
              [3991, 8175],
              [4009, 8170],
              [4003, 8132],
              [3961, 8141],
              [3882, 8143],
              [3870, 8146],
              [3844, 8127],
              [3828, 8164],
              [3830, 8195],
              [3811, 8204],
              [3807, 8253],
              [3779, 8311],
              [3765, 8312],
              [3788, 8334],
              [3798, 8334],
              [3815, 8365],
              [3814, 8412],
              [3799, 8407],
              [3772, 8434],
              [3733, 8453],
              [3721, 8478],
              [3711, 8521],
              [3699, 8537],
              [3684, 8581],
              [3683, 8602],
              [3697, 8653],
              [3660, 8652],
              [3620, 8608],
              [3611, 8626],
              [3621, 8662],
              [3603, 8712],
              [3606, 8730],
              [3628, 8770],
              [3623, 8793],
              [3603, 8814],
              [3549, 8797],
              [3533, 8785],
              [3469, 8774],
              [3424, 8786],
              [3390, 8783],
              [3376, 8773],
              [3332, 8760],
              [3362, 8802],
              [3368, 8831],
              [3348, 8839],
              [3347, 8856],
              [3419, 8913],
              [3420, 8964],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.1024",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-1024",
          "hc-a2": "LA",
          labelrank: "2",
          hasc: "ID.LA",
          "alt-name": null,
          "woe-id": "2345724",
          subregion: null,
          fips: "ID15",
          "postal-code": null,
          name: "Lampung",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "105.059",
          "woe-name": "Lampung",
          latitude: "-4.919",
          "woe-label": "Lampung, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1084, 7388],
              [1111, 7407],
              [1118, 7416],
              [1139, 7406],
              [1148, 7388],
              [1192, 7388],
              [1221, 7402],
              [1241, 7404],
              [1249, 7422],
              [1231, 7445],
              [1240, 7464],
              [1237, 7507],
              [1285, 7538],
              [1319, 7545],
              [1355, 7565],
              [1386, 7574],
              [1415, 7605],
              [1418, 7629],
              [1448, 7647],
              [1457, 7677],
              [1505, 7654],
              [1522, 7635],
              [1527, 7615],
              [1553, 7593],
              [1581, 7593],
              [1580, 7560],
              [1603, 7523],
              [1600, 7436],
              [1610, 7415],
              [1602, 7393],
              [1604, 7344],
              [1599, 7314],
              [1602, 7252],
              [1594, 7212],
              [1583, 7196],
              [1578, 7210],
              [1553, 7214],
              [1537, 7248],
              [1523, 7246],
              [1481, 7288],
              [1467, 7288],
              [1466, 7263],
              [1453, 7260],
              [1464, 7220],
              [1442, 7213],
              [1365, 7247],
              [1345, 7265],
              [1324, 7272],
              [1305, 7255],
              [1344, 7201],
              [1352, 7175],
              [1317, 7171],
              [1311, 7191],
              [1273, 7222],
              [1252, 7232],
              [1242, 7255],
              [1207, 7274],
              [1178, 7303],
              [1179, 7315],
              [1155, 7323],
              [1157, 7341],
              [1127, 7364],
              [1095, 7374],
              [1084, 7388],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JK",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-jk",
          "hc-a2": "JK",
          labelrank: "9",
          hasc: "ID.JK",
          "alt-name": "Jawa|Djakarta",
          "woe-id": "2345713",
          subregion: null,
          fips: "ID04",
          "postal-code": "JK",
          name: "Jakarta Raya",
          country: "Indonesia",
          "type-en": "Special district",
          region: null,
          longitude: "106.837",
          "woe-name": "Jakarta Raya",
          latitude: "-6.22462",
          "woe-label": "DKI Jakarta, ID, Indonesia",
          type: "Daerah Khusus Ibukota",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1813, 7174],
              [1818, 7166],
              [1872, 7173],
              [1873, 7137],
              [1862, 7103],
              [1824, 7119],
              [1809, 7139],
              [1803, 7163],
              [1813, 7174],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.GO",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-go",
          "hc-a2": "GO",
          labelrank: "7",
          hasc: "ID.GO",
          "alt-name": null,
          "woe-id": "2345732",
          subregion: null,
          fips: "ID34",
          "postal-code": "GO",
          name: "Gorontalo",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "122.331",
          "woe-name": "Gorontalo",
          latitude: "0.760501",
          "woe-label": "Gorontalo, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [5253, 8970],
              [5262, 8967],
              [5312, 8972],
              [5352, 8962],
              [5406, 8931],
              [5421, 8941],
              [5432, 8965],
              [5462, 8959],
              [5488, 8939],
              [5499, 8916],
              [5545, 8890],
              [5561, 8849],
              [5553, 8822],
              [5502, 8822],
              [5462, 8864],
              [5440, 8855],
              [5365, 8851],
              [5289, 8850],
              [5253, 8842],
              [5223, 8843],
              [5211, 8835],
              [5169, 8828],
              [5142, 8848],
              [5105, 8850],
              [5101, 8838],
              [5061, 8830],
              [5059, 8856],
              [5041, 8857],
              [5018, 8879],
              [5035, 8889],
              [5049, 8913],
              [5066, 8922],
              [5096, 8920],
              [5171, 8953],
              [5207, 8947],
              [5253, 8970],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.YO",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-yo",
          "hc-a2": "YO",
          labelrank: "7",
          hasc: "ID.YO",
          "alt-name": "Jawa|Daerah Istimewa Yogyakarta",
          "woe-id": "2345719",
          subregion: null,
          fips: "ID10",
          "postal-code": "YO",
          name: "Yogyakarta",
          country: "Indonesia",
          "type-en": "Special region",
          region: null,
          longitude: "110.443",
          "woe-name": "Yogyakarta",
          latitude: "-7.83533",
          "woe-label": "Special Region of Yogyakarta, ID, Indonesia",
          type: "Daerah Istimewa",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [2773, 6745],
              [2738, 6748],
              [2689, 6760],
              [2588, 6805],
              [2606, 6854],
              [2634, 6847],
              [2673, 6884],
              [2691, 6835],
              [2733, 6829],
              [2755, 6818],
              [2761, 6762],
              [2773, 6745],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SL",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sl",
          "hc-a2": "SL",
          labelrank: "2",
          hasc: "ID.SL",
          "alt-name": "Sumsel",
          "woe-id": "2345734",
          subregion: null,
          fips: "ID32",
          "postal-code": "SL",
          name: "Sumatera Selatan",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "104.073",
          "woe-name": "Sumatera Selatan",
          latitude: "-3.3824",
          "woe-label": "South Sumatra, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.35,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1251, 8127],
              [1242, 8093],
              [1254, 8100],
              [1278, 8086],
              [1292, 8058],
              [1310, 8070],
              [1334, 8053],
              [1336, 8034],
              [1308, 7992],
              [1303, 7938],
              [1315, 7972],
              [1339, 8006],
              [1351, 7987],
              [1367, 7997],
              [1394, 7988],
              [1413, 7996],
              [1510, 7990],
              [1509, 7955],
              [1525, 7931],
              [1549, 7926],
              [1555, 7887],
              [1576, 7868],
              [1607, 7866],
              [1617, 7849],
              [1624, 7801],
              [1593, 7774],
              [1583, 7754],
              [1572, 7703],
              [1605, 7668],
              [1588, 7628],
              [1581, 7593],
              [1553, 7593],
              [1527, 7615],
              [1522, 7635],
              [1505, 7654],
              [1457, 7677],
              [1448, 7647],
              [1418, 7629],
              [1415, 7605],
              [1386, 7574],
              [1355, 7565],
              [1319, 7545],
              [1285, 7538],
              [1237, 7507],
              [1240, 7464],
              [1231, 7445],
              [1249, 7422],
              [1241, 7404],
              [1221, 7402],
              [1192, 7388],
              [1148, 7388],
              [1139, 7406],
              [1118, 7416],
              [1081, 7482],
              [1078, 7502],
              [977, 7536],
              [964, 7580],
              [926, 7580],
              [876, 7594],
              [842, 7626],
              [859, 7632],
              [901, 7671],
              [897, 7684],
              [923, 7684],
              [927, 7706],
              [916, 7726],
              [891, 7729],
              [866, 7750],
              [836, 7727],
              [795, 7752],
              [800, 7775],
              [786, 7789],
              [742, 7793],
              [736, 7817],
              [698, 7854],
              [735, 7879],
              [740, 7890],
              [785, 7872],
              [819, 7878],
              [862, 7913],
              [877, 7939],
              [875, 7963],
              [936, 7957],
              [954, 7966],
              [945, 7983],
              [954, 8007],
              [976, 7985],
              [1013, 7961],
              [1011, 7998],
              [1032, 8009],
              [1023, 8026],
              [1025, 8061],
              [1104, 8105],
              [1159, 8100],
              [1204, 8109],
              [1227, 8135],
              [1251, 8127],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.SR",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-sr",
          "hc-a2": "SR",
          labelrank: "2",
          hasc: "ID.SR",
          "alt-name": "Sulsel",
          "woe-id": "28350155",
          subregion: null,
          fips: "ID41",
          "postal-code": "SR",
          name: "Sulawesi Barat",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "119.316",
          "woe-name": "Sulawesi Barat",
          latitude: "-2.69615",
          "woe-label": "West Sulawesi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [4682, 7908],
              [4637, 7919],
              [4617, 7904],
              [4576, 7898],
              [4553, 7884],
              [4531, 7933],
              [4534, 7945],
              [4511, 7990],
              [4531, 8000],
              [4535, 8044],
              [4511, 8043],
              [4506, 8062],
              [4520, 8098],
              [4541, 8093],
              [4563, 8110],
              [4591, 8142],
              [4586, 8196],
              [4603, 8241],
              [4630, 8252],
              [4635, 8284],
              [4621, 8314],
              [4625, 8342],
              [4615, 8384],
              [4622, 8390],
              [4620, 8424],
              [4647, 8452],
              [4661, 8507],
              [4670, 8513],
              [4674, 8463],
              [4682, 8441],
              [4657, 8409],
              [4659, 8399],
              [4694, 8386],
              [4706, 8372],
              [4715, 8337],
              [4745, 8298],
              [4741, 8279],
              [4753, 8261],
              [4743, 8240],
              [4703, 8208],
              [4699, 8181],
              [4719, 8168],
              [4729, 8121],
              [4741, 8091],
              [4713, 8076],
              [4680, 8074],
              [4688, 8041],
              [4712, 7993],
              [4663, 7974],
              [4682, 7908],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.JA",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-ja",
          "hc-a2": "JA",
          labelrank: "6",
          hasc: "ID.JA",
          "alt-name": "Djambi",
          "woe-id": "2345714",
          subregion: null,
          fips: "ID05",
          "postal-code": "JA",
          name: "Jambi",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "102.823",
          "woe-name": "Jambi",
          latitude: "-1.65497",
          "woe-label": "Jambi, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [987, 8339],
              [989, 8324],
              [1004, 8327],
              [1038, 8297],
              [1083, 8279],
              [1109, 8293],
              [1169, 8274],
              [1207, 8286],
              [1213, 8250],
              [1226, 8224],
              [1231, 8173],
              [1251, 8127],
              [1227, 8135],
              [1204, 8109],
              [1159, 8100],
              [1104, 8105],
              [1025, 8061],
              [1023, 8026],
              [1032, 8009],
              [1011, 7998],
              [1013, 7961],
              [976, 7985],
              [954, 8007],
              [945, 7983],
              [954, 7966],
              [936, 7957],
              [875, 7963],
              [877, 7939],
              [862, 7913],
              [819, 7878],
              [785, 7872],
              [740, 7890],
              [735, 7879],
              [698, 7854],
              [659, 7861],
              [619, 7883],
              [577, 7923],
              [564, 7956],
              [544, 7971],
              [522, 7955],
              [501, 8004],
              [472, 8040],
              [462, 8089],
              [489, 8085],
              [540, 8091],
              [590, 8144],
              [588, 8192],
              [614, 8205],
              [624, 8222],
              [610, 8230],
              [606, 8251],
              [631, 8261],
              [660, 8290],
              [700, 8298],
              [717, 8294],
              [741, 8265],
              [784, 8250],
              [815, 8293],
              [842, 8321],
              [867, 8329],
              [910, 8329],
              [987, 8339],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "ID.KT",
        properties: {
          "hc-group": "admin1",
          hc_key: "id-kt",
          "hc-a2": "KT",
          labelrank: "2",
          hasc: "ID.KT",
          "alt-name": "Kalteng",
          "woe-id": "2345722",
          subregion: null,
          fips: "ID13",
          "postal-code": "KT",
          name: "Kalimantan Tengah",
          country: "Indonesia",
          "type-en": "Province",
          region: null,
          longitude: "113.286",
          "woe-name": "Kalimantan Tengah",
          latitude: "-1.84217",
          "woe-label": "Central Kalimantan, ID, Indonesia",
          type: "Propinsi",
          "hc-middle-x": 0.5,
          "hc-middle-y": 0.5,
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [3500, 7864],
              [3489, 7871],
              [3510, 7915],
              [3485, 7880],
              [3458, 7876],
              [3455, 7911],
              [3438, 7878],
              [3404, 7859],
              [3365, 7848],
              [3347, 7851],
              [3347, 7887],
              [3341, 7912],
              [3306, 7910],
              [3281, 7889],
              [3254, 7909],
              [3240, 7931],
              [3221, 7938],
              [3205, 7964],
              [3202, 7938],
              [3188, 7918],
              [3204, 7910],
              [3116, 7846],
              [3095, 7842],
              [3063, 7862],
              [3043, 7867],
              [3001, 7850],
              [2956, 7804],
              [2936, 7809],
              [2939, 7851],
              [2931, 7889],
              [2933, 7919],
              [2908, 7974],
              [2895, 7954],
              [2902, 7944],
              [2876, 7928],
              [2844, 7944],
              [2810, 7940],
              [2758, 7909],
              [2723, 7902],
              [2688, 7914],
              [2698, 7929],
              [2732, 7948],
              [2756, 7976],
              [2771, 7984],
              [2767, 8059],
              [2735, 8120],
              [2730, 8152],
              [2736, 8207],
              [2731, 8225],
              [2708, 8235],
              [2728, 8256],
              [2756, 8256],
              [2798, 8294],
              [2817, 8319],
              [2853, 8339],
              [2867, 8379],
              [2970, 8448],
              [3030, 8447],
              [3075, 8460],
              [3169, 8507],
              [3204, 8520],
              [3227, 8503],
              [3236, 8533],
              [3223, 8546],
              [3239, 8571],
              [3262, 8587],
              [3272, 8619],
              [3265, 8645],
              [3233, 8684],
              [3254, 8692],
              [3280, 8690],
              [3300, 8702],
              [3304, 8725],
              [3332, 8760],
              [3376, 8773],
              [3390, 8783],
              [3424, 8786],
              [3469, 8774],
              [3533, 8785],
              [3549, 8797],
              [3603, 8814],
              [3623, 8793],
              [3628, 8770],
              [3606, 8730],
              [3603, 8712],
              [3621, 8662],
              [3611, 8626],
              [3620, 8608],
              [3660, 8652],
              [3697, 8653],
              [3683, 8602],
              [3684, 8581],
              [3699, 8537],
              [3711, 8521],
              [3721, 8478],
              [3733, 8453],
              [3772, 8434],
              [3799, 8407],
              [3814, 8412],
              [3815, 8365],
              [3798, 8334],
              [3788, 8334],
              [3788, 8348],
              [3731, 8329],
              [3715, 8253],
              [3721, 8222],
              [3716, 8191],
              [3673, 8150],
              [3622, 8135],
              [3625, 8100],
              [3607, 8067],
              [3600, 8038],
              [3566, 8006],
              [3538, 7991],
              [3532, 7963],
              [3500, 7864],
            ],
          ],
        },
      },
    ],
  };
}

export default {
  load_data,
  load_data2,
};
